import './style.css'

const menuItems = [
  {
    id: "ube-dream-cookie-half",
    name: "Ube Dream Cookie",
    halfDozen: "$27",
    dozen: null,
    isNewRelease: true,
    availableNow: true,
    description: "Soft, chewy ube cookies with white chocolate pieces and a rich, creamy filling. Baked in a box of six.",
    image: "/images/ube-dream-cookie.jpeg",
    imagePosition: "center 58%"
  },
  {
    id: "red-velvet-dream-half",
    name: "Red Velvet Dream Cookie",
    halfDozen: "$27",
    dozen: null,
    isNewRelease: true,
    availableNow: true,
    description: "Chocolate-chip red velvet with a creamy center and a white chocolate drizzle. The middle bite is the one. Baked in a box of six.",
    image: "/images/popup/red-velvet-dream.jpeg",
    imagePosition: "center 50%"
  },
  {
    id: "milky-cheese-bread-half",
    name: "Milky Cheese Bread",
    halfDozen: null,
    dozen: "$25",
    isNewRelease: true,
    description: "Soft, fluffy rolls with a creamy, milky cheese filling. Baked in a box of twelve.",
    image: "/images/milky-cheese-bread.jpeg",
    imagePosition: "center 87%",
    imageZoom: true
  },
  {
    id: "milky-dubai-half",
    name: "Milky Dubai Chewy Cookie",
    halfDozen: "$35",
    dozen: null,
    squareLink: "https://square.link/u/lnNVwTEL",
    description: "Not a fan of cocoa powder? Try our Milky Dubai Chewy Cookie — a soft and chewy mochi-marshmallow style cookie with a creamy milky shell, dusted in a milk powder blend. Inside, you still get the original crispy pistachio kataifi filling everyone loves — rich, crunchy, creamy, and perfectly paired with the milky outer layer. Perfect for anyone who wants a lighter, creamier twist on our OG Dubai Chewy Cookie.",
    image: "/images/milky-dubai-chewy.png"
  },
  {
    id: "dubai-half",
    name: "Dubai Chewy Cookie",
    price: "$6",
    halfDozen: "$30",
    dozen: null,
    squareLink: "https://square.link/u/Zy7Qdqaj",
    description: "A rich, cocoa-dusted cookie with a chewy exterior and a crunchy, creamy pistachio filling.",
    image: "/images/2.jpg"
  },
  {
    id: "redvelvet-half",
    name: "Red Velvet Crinkle",
    price: "$3",
    halfDozen: "$15",
    dozen: null,
    squareLink: "https://square.link/u/Kumb2xu0",
    description: "A fudgy, cocoa-rich red velvet cookie sandwich with our creamy signature filling.",
    image: "/images/3.jpg"
  },
  {
    id: "ube-dozen",
    name: "Ube Dream Bun",
    price: "$2",
    halfDozen: null,
    dozen: "$20",
    squareLink: "https://square.link/u/2zHfwLsn",
    description: "Soft, pillowy purple Ube bun with our special ube signature filling.",
    image: "/images/1.jpg"
  },
  {
    name: "Ensaymada Series",
    price: "$60",
    halfDozen: null,
    dozen: "$60",
    available: false,
    specialOrder: true,
    specialOrderNote: "Special order only · minimum 1 dozen",
    description: "Our modern take on the classic. Soft buns with Oreo, pistachio, cheesy, or Biscoff finishes. Baked soft, topped generous. Available as a special order only — minimum one dozen (12 pcs).",
    image: "/images/Pistachio Ensaymada.jpeg",
    collageImages: [
      { src: "/images/Oreo Ensaymada.jpeg", label: "Oreo" },
      { src: "/images/Pistachio Ensaymada.jpeg", label: "Pistachio" },
      { src: "/images/Cheese Ensaymada.jpeg", label: "Cheesy" },
      { src: "/images/Biscoff Ensaymada.jpeg", label: "Biscoff" }
    ]
  }
];

// Show catalog prices on the menu, hero bubbles and checkout.
const SHOW_PUBLIC_MENU_PRICES = true;

const boxItems = [
  { name: "Ube Dream Cookie (Box of 6)", price: "$27" },
  { name: "Red Velvet Dream Cookie (Box of 6)", price: "$27" },
  { name: "Milky Cheese Bread (Box of 12)", price: "$25" },
  { name: "Milky Dubai Chewy Cookie (Box of 6)", price: "$35" },
  { name: "Dubai Chewy Cookie (Box of 6)", price: "$30" },
  { name: "Ube Dream Bun (Box of 12)", price: "$20" },
  { name: "Red Velvet Crinkle (Box of 6)", price: "$15" },
  { name: "Ensaymada Series (Special order · Dozen (12 pcs))", price: "$60", available: false }
];

const orderableItems = [
  { id: "ube-dream-cookie-half", name: "Ube Dream Cookie (Half dozen (6 pcs))", price: 27, image: "/images/ube-dream-cookie.jpeg" },
  { id: "red-velvet-dream-half", name: "Red Velvet Dream Cookie (Half dozen (6 pcs))", price: 27, image: "/images/popup/red-velvet-dream.jpeg" },
  { id: "milky-cheese-bread-half", name: "Milky Cheese Bread (Dozen (12 pcs))", price: 25, image: "/images/milky-cheese-bread.jpeg" },
  { id: "milky-dubai-half", name: "Milky Dubai Chewy Cookie (Half dozen (6 pcs))", price: 35, image: "/images/milky-dubai-chewy.png", squareLink: "https://square.link/u/lnNVwTEL" },
  { id: "dubai-half", name: "Dubai Chewy Cookie (Half dozen (6 pcs))", price: 30, image: "/images/2.jpg", squareLink: "https://square.link/u/Zy7Qdqaj" },
  { id: "redvelvet-half", name: "Red Velvet Crinkle (Half dozen (6 pcs))", price: 15, image: "/images/3.jpg", squareLink: "https://square.link/u/Kumb2xu0" },
  { id: "ube-dozen", name: "Ube Dream Bun (Dozen (12 pcs))", price: 20, image: "/images/1.jpg", squareLink: "https://square.link/u/2zHfwLsn" },
  { id: "ensaymada-dozen", name: "Ensaymada Series (Special order · Dozen (12 pcs))", price: 60, image: "/images/Pistachio Ensaymada.jpeg", available: false }
];
const availableOrderableItems = orderableItems.filter(item => item.available !== false);
const CART_STORAGE_KEY = 'softbakes_cart_v1';

function sanitizeCart(cart) {
  const clean = {};
  if (!cart || typeof cart !== 'object' || Array.isArray(cart)) return clean;
  availableOrderableItems.forEach(function (item) {
    const quantity = Number.parseInt(cart[item.id], 10);
    if (Number.isInteger(quantity) && quantity > 0) clean[item.id] = Math.min(quantity, 50);
  });
  return clean;
}

function getCart() {
  try {
    return sanitizeCart(JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || '{}'));
  } catch (_) {
    return {};
  }
}

function setCart(cart) {
  const clean = sanitizeCart(cart);
  try {
    if (Object.keys(clean).length) {
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(clean));
    } else {
      localStorage.removeItem(CART_STORAGE_KEY);
    }
  } catch (_) {}
  document.dispatchEvent(new CustomEvent('softbakes:cartchange'));
  return clean;
}

function setCartQuantity(itemId, quantity) {
  if (!availableOrderableItems.some(item => item.id === itemId)) return getCart();
  const cart = getCart();
  const nextQuantity = Math.max(0, Math.min(Number.parseInt(quantity, 10) || 0, 50));
  if (nextQuantity > 0) cart[itemId] = nextQuantity;
  else delete cart[itemId];
  return setCart(cart);
}

function addToCart(itemId, quantity = 1) {
  const cart = getCart();
  return setCartQuantity(itemId, (cart[itemId] || 0) + quantity);
}

function clearCart() {
  return setCart({});
}

function getCartItems() {
  const cart = getCart();
  return availableOrderableItems
    .filter(item => cart[item.id] > 0)
    .map(item => ({ ...item, quantity: cart[item.id], lineTotal: cart[item.id] * item.price }));
}

function renderCartUI() {
  const items = getCartItems();
  const count = items.reduce((total, item) => total + item.quantity, 0);
  const subtotal = items.reduce((total, item) => total + item.lineTotal, 0);
  document.querySelectorAll('.cart-count-badge').forEach(function (badge) {
    badge.textContent = String(count);
    badge.hidden = count === 0;
  });

  const itemsEl = document.getElementById('cartDrawerItems');
  const emptyEl = document.getElementById('cartDrawerEmpty');
  const subtotalEl = document.getElementById('cartDrawerSubtotal');
  const checkoutBtn = document.getElementById('cartDrawerCheckout');
  const clearBtn = document.getElementById('cartDrawerClear');
  if (itemsEl) {
    itemsEl.innerHTML = items.map(item => `
      <div class="cart-drawer-item" data-cart-id="${item.id}">
        <img src="${item.image || ''}" alt="" class="cart-drawer-item-image">
        <div class="cart-drawer-item-copy">
          <strong>${escapeHTML(item.name)}</strong>
          <span>$${item.price.toFixed(2)} each</span>
          <button type="button" class="cart-remove-item" data-cart-action="remove">Remove</button>
        </div>
        <div class="cart-drawer-item-controls">
          <button type="button" data-cart-action="decrease" aria-label="Decrease ${escapeHTML(item.name)}">−</button>
          <span aria-label="${item.quantity} in cart">${item.quantity}</span>
          <button type="button" data-cart-action="increase" aria-label="Increase ${escapeHTML(item.name)}">+</button>
        </div>
        <strong class="cart-drawer-line-total">$${item.lineTotal.toFixed(2)}</strong>
      </div>
    `).join('');
  }
  if (emptyEl) emptyEl.hidden = items.length > 0;
  if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2) + ' CAD';
  if (checkoutBtn) checkoutBtn.disabled = items.length === 0;
  if (clearBtn) clearBtn.hidden = items.length === 0;

  const stickyCart = document.getElementById('stickyCartBar');
  const stickyCount = document.getElementById('stickyCartCount');
  const stickySubtotal = document.getElementById('stickyCartSubtotal');
  if (stickyCount) stickyCount.textContent = count + (count === 1 ? ' item' : ' items');
  if (stickySubtotal) stickySubtotal.textContent = '$' + subtotal.toFixed(2) + ' CAD';
  if (stickyCart) {
    const onCheckoutPage = (window.location.pathname.replace(/\/$/, '') || '/') === '/checkout';
    stickyCart.hidden = count === 0 || onCheckoutPage;
    stickyCart.setAttribute(
      'aria-label',
      count === 0
        ? 'Cart is empty'
        : `View cart, ${count} ${count === 1 ? 'item' : 'items'}, $${subtotal.toFixed(2)} CAD`
    );
  }
}

function showCartToast(message) {
  const toast = document.getElementById('cartToast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('visible');
  clearTimeout(showCartToast.timeoutId);
  showCartToast.timeoutId = setTimeout(() => toast.classList.remove('visible'), 1800);
}

function pulseStickyCart() {
  const stickyCart = document.getElementById('stickyCartBar');
  if (!stickyCart || stickyCart.hidden) return;
  stickyCart.classList.remove('is-pulsing');
  void stickyCart.offsetWidth;
  stickyCart.classList.add('is-pulsing');
  clearTimeout(pulseStickyCart.timeoutId);
  pulseStickyCart.timeoutId = setTimeout(() => stickyCart.classList.remove('is-pulsing'), 700);
}

document.addEventListener('softbakes:cartchange', renderCartUI);
window.addEventListener('storage', function (event) {
  if (event.key === CART_STORAGE_KEY) renderCartUI();
});

let orderModalChatWithKC = false;
let orderModalCustomMessage = '';
const ORDER_ETRANSFER_EMAIL = "softbakesbykc@gmail.com";
const CHECKOUT_REWARD_MESSAGE_KEY = 'softbakes_checkout_reward_message';

const testimonials = [
  {
    name: "Sarah M.",
    text: "The Dubai Chewy Cookies are a revelation! That pistachio filling is unlike anything I've ever had. Truly professional quality from a home kitchen.",
    stars: 5
  },
  {
    name: "James L.",
    text: "Ordered a dozen Ube Dream Buns for a family gathering and they were gone in minutes. So soft and the ube flavor is authentic and rich.",
    stars: 5
  },
  {
    name: "Elena R.",
    text: "KC's attention to detail is amazing. The Red Velvet Crinkles are perfectly fudgy. My go-to for special treats now!",
    stars: 5
  }
];

const INSTAGRAM_URL = "https://instagram.com/softbakesbykc";
const FACEBOOK_URL = "https://www.facebook.com/people/Soft-Bakes-by-KC/61578518656069/";
const INSTAGRAM_HANDLE = "@SoftBakesByKC";
const MESSENGER_URL = "https://m.me/61578518656069";
const EMAIL_ADDR = "softbakesbykc@gmail.com";
const SMS_NUM = "4036047532";
const WHATSAPP_NUM = "14036047532";
const LOYALTY_REWARD_LABEL = "free ube pandesal";

const ICON_INSTAGRAM = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5a5 5 0 1 0 .001 10.001A5 5 0 0 0 12 7zm6.5-.9a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></svg>`;
const ICON_FACEBOOK = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 8h3V4h-3c-2.8 0-5 2.2-5 5v2H6v4h3v7h4v-7h3l1-4h-4V9c0-.6.4-1 1-1z"/></svg>`;
const ICON_SQUARE = `<svg class="btn-square-logo" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2.5" y="2.5" width="19" height="19" rx="4.5" fill="none" stroke="currentColor" stroke-width="2"/><rect x="7.25" y="7.25" width="9.5" height="9.5" rx="2.25" fill="currentColor"/></svg>`;
const SQUARE_EXPRESS_LABEL = 'Express Order with Square';
const SQUARE_CHECKOUT_LABEL = 'Pay securely with Square';

function squareButtonHTML(label = SQUARE_EXPRESS_LABEL) {
  return `${ICON_SQUARE}<span>${escapeHTML(label)}</span>`;
}

function setSquareButtonLabel(button, label = SQUARE_EXPRESS_LABEL) {
  if (!button) return;
  button.innerHTML = squareButtonHTML(label);
}

function encodeSmsBody(message) {
  return String(message)
    .replace(/\n/g, '%0A')
    .replace(/&/g, '%26')
    .replace(/=/g, '%3D')
    .replace(/\?/g, '%3F')
    .replace(/#/g, '%23')
    .replace(/ /g, '+');
}

function escapeHTML(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const blogPosts = [
  { slug: "planning-bakery-order-for-an-event", title: "What to Ask When Planning a Bakery Order for an Event", published: "November 2, 2026", publishedDateISO: "2026-11-02", author: "Soft Bakes by KC", excerpt: "A practical checklist for event treat orders: guest count, ingredients, packaging, pickup and storage.", images: [{ src: "/images/blog/planning-bakery-event-illustration.png", alt: "Illustration of assorted purple buns and cookies in a kraft box", caption: "Illustration: planning an assortment for an event" }], shoutouts: [] },
  {
    slug: "soho-volume-1-community-coffee-bakes",
    title: "SOHO Volume 1: A Night of Community, Coffee, & Bakes",
    published: "March 15, 2026",
    publishedDateISO: "2026-03-15",
    author: "Soft Bakes by KC",
    excerpt: "Recap of KUHA Studio's SOHO (Social House) Volume 1 at Studio 122 in Calgary. Community, local entrepreneurs, Filipino bakes, and the debut of our limited-edition Ensaymada.",
    images: [
      { src: "/images/blog/Team.png", alt: "Soft Bakes by KC team and guests at SOHO Volume 1 event in front of branded booth", caption: "The Soft Bakes Team" },
      { src: "/images/blog/The Owner KC.jpeg", alt: "KC, owner of Soft Bakes by KC, at SOHO Volume 1", caption: "SOLD OUT: Soft Bakes 1st Pop Up was a success" },
      { src: "/images/blog/Painter.png", alt: "Patrick De Guzman (@dropofthought) and his paintings at SOHO Volume 1", caption: "The Painter — @dropofthought" }
    ],
    shoutouts: [
      { name: "Kuha Studio", handle: "Kuhastudios.yyc", url: "https://instagram.com/Kuhastudios.yyc", note: "Capturing beautiful moments, prints, and organizing the event." },
      { name: "NSW Curation", handle: "NSW.Curation", url: "https://instagram.com/NSW.Curation", note: "Premium style and curated aesthetic shop." },
      { name: "Patrick De Guzman", handle: "Dropofthought", url: "https://instagram.com/Dropofthought", note: "Cozy vibe and the painting on the wall." },
      { name: "Muni Muni Kape", handle: "Munimuni.kape", url: "https://instagram.com/Munimuni.kape", note: "Ube-inspired coffees. The perfect pairing for a Soft Bake." },
      { groupTitle: "DJ's", people: [
        { name: "DJ Rhayver", handle: "Rhayverr", url: "https://instagram.com/Rhayverr" },
        { name: "DJ Jalen", handle: "jalenul_", url: "https://instagram.com/jalenul_" }
      ], note: "Good vibes all evening." }
    ]
  },
  {
    slug: "spring-2026-custom-cookie-boxes-calgary",
    title: "Spring 2026: Custom Cookie Boxes for Calgary Events",
    published: "June 3, 2026",
    publishedDateISO: "2026-06-03",
    author: "Soft Bakes by KC",
    excerpt: "Planning a Calgary shower, office thank-you, or small celebration this spring? Here is how we build custom cookie boxes with ube pandesal, Dubai chewy cookies, and other Filipino-inspired treats baked fresh for pickup.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Open gift box of Soft Bakes by KC ube pandesal, Dubai chewy cookies, and red velvet crinkles on a wooden table",
        caption: "Custom spring cookie boxes, baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "calgary-pop-up-branding-treats-and-custom-merch",
    title: "Branding a Calgary Pop-Up: Treats, Team Shirts, and Trusted Local Vendors",
    published: "June 3, 2026",
    publishedDateISO: "2026-06-03",
    author: "Soft Bakes by KC",
    excerpt: "What we learned branding our booth for Calgary community events: matching cookie boxes with team aprons, working with Formulated Prints on shirts, and planning merch before the line forms.",
    images: [
      {
        src: "/images/blog/calgary-pop-up-branding-hero.jpg",
        alt: "Soft Bakes by KC pop-up table with ube pandesal, cookie boxes, and branded team aprons at a Calgary community event",
        caption: "Treats up front, branded team gear that shows up in every photo"
      }
    ],
    shoutouts: []
  },
  {
    slug: "filipino-inspired-treats-calgary-pickup-guide",
    title: "Filipino-Inspired Treats in Calgary: A Pickup Guide for Offices and Gatherings",
    published: "June 4, 2026",
    publishedDateISO: "2026-06-04",
    author: "Soft Bakes by KC",
    excerpt: "New to ube pandesal or Dubai chewy cookies in Calgary? This guide explains what to order, how far ahead to book pickup, and which Soft Bakes treats work best for office thank-yous, family dinners, and community events in YYC.",
    images: [
      {
        src: "/images/blog/filipino-treats-calgary-guide-hero.jpg",
        alt: "Filipino-inspired ube pandesal, chewy cookies, and pastry boxes from Soft Bakes by KC ready for Calgary pickup",
        caption: "Filipino-inspired treats baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "best-ube-pandesal-calgary-soft-bakes",
    title: "The Best Ube Pandesal in Calgary (And What Actually Makes It Good)",
    published: "June 9, 2026",
    publishedDateISO: "2026-06-09",
    author: "Soft Bakes by KC",
    excerpt: "Not all ube pandesal in Calgary tastes the same. Here is what separates a soft, fresh roll from a dry grocery imitation, why we bake to order, and how to order trays for office mornings and family brunch in YYC.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Soft Bakes by KC ube pandesal with purple yam color and soft crumb, baked fresh for Calgary pickup",
        caption: "Real ube color, soft crumb, baked after you order"
      }
    ],
    shoutouts: []
  },
  {
    slug: "office-thank-you-treats-calgary",
    title: "Office Thank-You Treats in Calgary: What to Order (and When)",
    published: "June 15, 2026",
    publishedDateISO: "2026-06-15",
    author: "Soft Bakes by KC",
    excerpt: "Planning a team thank-you, Friday morale boost, or client gift in Calgary? Here is how we build office treat orders with ube pandesal, cookie boxes, and Filipino-inspired bakes baked fresh for pickup.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Office thank-you treat box with ube pandesal and Dubai chewy cookies from Soft Bakes by KC in Calgary",
        caption: "Office thank-you boxes baked to order in YYC"
      }
    ],
    shoutouts: []
  },
  {
    slug: "milky-dubai-chewy-cookie-calgary",
    title: "Milky Dubai Chewy Cookie in Calgary: Our Creamy Take on a Viral Favorite",
    published: "June 15, 2026",
    publishedDateISO: "2026-06-15",
    author: "Soft Bakes by KC",
    excerpt: "Prefer a lighter, creamier shell than classic Dubai chocolate? Our Milky Dubai Chewy Cookie is baked to order in Calgary — half dozen boxes, gift-ready, and pickup-friendly across YYC.",
    images: [
      {
        src: "/images/milky-dubai-chewy.png",
        alt: "Milky Dubai Chewy Cookie half dozen box from Soft Bakes by KC Calgary bakery",
        caption: "Half dozen (6 pcs) · baked fresh after you order"
      }
    ],
    shoutouts: []
  },
  {
    slug: "baby-shower-cookies-calgary",
    title: "Baby Shower Cookies in Calgary: How We Build Custom Boxes for YYC Celebrations",
    published: "June 16, 2026",
    publishedDateISO: "2026-06-16",
    author: "Soft Bakes by KC",
    excerpt: "Planning a baby shower in Calgary? Here is how we design custom cookie boxes with ube pandesal, chewy cookies, and Filipino-inspired treats baked fresh for pickup — plus how far ahead to order.",
    images: [
      {
        src: "/images/blog/baby-shower-cookies-calgary-hero.jpg",
        alt: "Custom baby shower cookie box with pastel treats, ube pandesal, and chewy cookies from Soft Bakes by KC in Calgary",
        caption: "Custom baby shower boxes, baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "filipino-desserts-calgary-guide",
    title: "Filipino Desserts in Calgary: Ube, Ensaymada, and Where to Order Fresh",
    published: "June 22, 2026",
    publishedDateISO: "2026-06-22",
    author: "Soft Bakes by KC",
    excerpt: "Looking for Filipino desserts in Calgary? This guide covers ube pandesal, ensaymada, chewy cookies, and how to order fresh Filipino-inspired treats for pickup across YYC.",
    images: [
      {
        src: "/images/blog/filipino-treats-calgary-guide-hero.jpg",
        alt: "Filipino desserts including ube pandesal and ensaymada from Soft Bakes by KC in Calgary",
        caption: "Filipino-inspired desserts baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "birthday-cookie-box-calgary",
    title: "Birthday Cookie Boxes in Calgary: Sizes, Flavors, and How to Order",
    published: "June 22, 2026",
    publishedDateISO: "2026-06-22",
    author: "Soft Bakes by KC",
    excerpt: "Planning a birthday in Calgary? Here is how we build custom cookie boxes with Dubai chewy cookies, ube pandesal, and Filipino-inspired treats baked fresh for pickup.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Birthday cookie box with ube pandesal and chewy cookies from Soft Bakes by KC Calgary",
        caption: "Birthday cookie boxes baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "corporate-gift-boxes-calgary-bakery",
    title: "Corporate Gift Boxes in Calgary: Client Thank-Yous That Feel Personal",
    published: "June 22, 2026",
    publishedDateISO: "2026-06-22",
    author: "Soft Bakes by KC",
    excerpt: "Need corporate gift boxes in Calgary for clients or staff? How we build labeled treat boxes with ube pandesal, chewy cookies, and pickup timing for YYC offices.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Corporate gift boxes of cookies and ube pandesal from Soft Bakes by KC Calgary bakery",
        caption: "Corporate gift boxes for Calgary offices and clients"
      }
    ],
    shoutouts: []
  },
  {
    slug: "event-merch-and-treats-calgary",
    title: "Event Merch and Treats in Calgary: Why We Pair Cookie Boxes With Branded Gear",
    published: "July 2, 2026",
    publishedDateISO: "2026-07-02",
    author: "Soft Bakes by KC",
    excerpt: "Planning a Calgary market booth or community event? Here is why we order treats and team merch together, and why we keep going back to Formulated Prints for DTF gear that survives a full market day.",
    images: [
      {
        src: "/images/blog/calgary-pop-up-branding-hero.jpg",
        alt: "Soft Bakes by KC event table with cookie boxes and branded team apparel printed by Formulated Prints",
        caption: "Treats and team merch, ordered together for Calgary events"
      }
    ],
    shoutouts: []
  },
  {
    slug: "filipino-food-gifts-calgary",
    title: "Filipino Food Gifts in Calgary: Boxes That Travel Well",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Need Filipino food gifts in Calgary for a thank-you, family visit, or office surprise? Here is how we build gift-ready boxes with ube pandesal, chewy cookies, and treats baked fresh for pickup.",
    images: [
      {
        src: "/images/blog/filipino-treats-calgary-guide-hero.jpg",
        alt: "Filipino food gift box with ube pandesal and chewy cookies from Soft Bakes by KC Calgary",
        caption: "Filipino food gifts baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "bridal-shower-treats-calgary",
    title: "Bridal Shower Treats in Calgary: Dessert Tables Without the Cake Stress",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Planning bridal shower treats in Calgary? Custom cookie boxes and ube pandesal trays photograph well, share easily, and bake fresh for pickup before your YYC celebration.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Bridal shower treat box with cookies and ube pandesal from Soft Bakes by KC Calgary",
        caption: "Bridal shower treats baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "ensaymada-calgary-soft-bakes",
    title: "Ensaymada in Calgary: How We Bake Limited Runs at Soft Bakes by KC",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Looking for ensaymada in Calgary? Our brioche-style Filipino buns debut at pop-ups and limited drops. Here is what makes them different and how to catch the next batch.",
    images: [
      {
        src: "/images/Cheese Ensaymada.jpeg",
        alt: "Ensaymada from Soft Bakes by KC Calgary home bakery",
        caption: "Ensaymada limited runs at Soft Bakes by KC"
      }
    ],
    shoutouts: []
  },
  {
    slug: "team-appreciation-baked-goods-calgary",
    title: "Team Appreciation Baked Goods in Calgary: Friday Drops That Land",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Team appreciation baked goods in Calgary work when they are labeled, easy to share, and still soft at 3 p.m. Here is what YYC offices order and how far ahead to book pickup.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Team appreciation baked goods box from Soft Bakes by KC Calgary",
        caption: "Team appreciation boxes for Calgary offices"
      }
    ],
    shoutouts: []
  },
  {
    slug: "filipino-breakfast-bread-calgary",
    title: "Filipino Breakfast Bread in Calgary: Pandesal Mornings Done Right",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Filipino breakfast bread in Calgary means fresh pandesal and ube rolls baked after you order. Here is how to book a tray for office mornings and weekend brunch across YYC.",
    images: [
      {
        src: "/images/blog/filipino-treats-calgary-guide-hero.jpg",
        alt: "Filipino breakfast bread and pandesal tray from Soft Bakes by KC Calgary",
        caption: "Pandesal and ube rolls baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "small-celebration-cookies-calgary",
    title: "Small Celebration Cookies in Calgary: Boxes for Milestones That Matter",
    published: "July 3, 2026",
    publishedDateISO: "2026-07-03",
    author: "Soft Bakes by KC",
    excerpt: "Small celebration cookies in Calgary fit promotions, housewarmings, and quiet wins that still deserve something sweet. Here is how we size boxes and time pickup across YYC.",
    images: [
      {
        src: "/images/blog/spring-cookie-boxes-hero.jpg",
        alt: "Small celebration cookie box from Soft Bakes by KC Calgary bakery",
        caption: "Small celebration cookies baked to order in Calgary"
      }
    ],
    shoutouts: []
  },
  {
    slug: "why-soft-bakes-bakes-to-order-calgary",
    title: "Why Soft Bakes by KC Bakes to Order in Calgary",
    published: "July 6, 2026",
    publishedDateISO: "2026-07-06",
    author: "Soft Bakes by KC",
    excerpt: "Soft Bakes by KC is a Calgary home bakery built around one rule: nothing leaves the kitchen until you confirm your order. Here is how that model works, what we bake, and why it matters for ube pandesal, cookies, and gift boxes across YYC.",
    images: [
      {
        src: "/images/blog/The Owner KC.jpeg",
        alt: "KC, owner of Soft Bakes by KC, at a Calgary community pop-up bakery event",
        caption: "KC started Soft Bakes to share the same treats she served at home"
      }
    ],
    shoutouts: []
  },
  {
    slug: "calgary-market-vendor-treats-guide",
    title: "Calgary Market Vendor Treats: Matching Boxes and Aprons in One Week",
    published: "July 24, 2026",
    publishedDateISO: "2026-07-24",
    author: "Soft Bakes by KC",
    excerpt: "A Calgary market week checklist for Soft Bakes by KC: when to lock cookie boxes and labels, when team aprons need to be ready, and how we keep treats and merch looking like one booth.",
    images: [
      {
        src: "/images/blog/calgary-market-vendor-treats-hero.jpg",
        alt: "Calgary bakery market prep with cookie boxes, apron, and Soft Bakes treats ready for booth day",
        caption: "Treats and aprons planned on the same market timeline"
      }
    ],
    shoutouts: []
  },
  {
    slug: "kuha-studios-social-house-vol-2-pop-up-calgary",
    title: "SOHO by Kuha Volume 2 in Calgary: Soft Bakes by KC Launches Four New Dream Cookies",
    published: "October 14, 2026",
    publishedDateISO: "2026-10-14",
    author: "Soft Bakes by KC",
    excerpt: "Our four Dream Cookies debut at SOHO Volume 2: Brown Butter Chocolate Chip, Red Velvet Dream, Ube Dream Cookies, and White Chocolate Matcha. Stop by Saturday, October 24 at Studio 122 in Calgary.",
    images: [
      {
        src: "/images/popup/dream-cookie-lineup.jpeg",
        alt: "Soft Bakes by KC Dream Cookie lineup in warm bakery colors",
        caption: "The Dream Cookie lineup, launching at SOHO Volume 2 and joining our menu"
      }
    ],
    shoutouts: [
      { name: "Kuha Studios", handle: "kuhastudios.yyc", url: "https://www.instagram.com/kuhastudios.yyc/", note: "Organizers of Social House Vol. 2 at Studio 122." }
    ],
    event: {
      name: "SOHO by Kuha Volume 2",
      startDate: "2026-10-24T13:30:00-06:00",
      endDate: "2026-10-24T21:00:00-06:00",
      venue: "Studio 122",
      streetAddress: "#122, 4029 8 St SE",
      organizerName: "Kuha Studios",
      organizerUrl: "https://www.instagram.com/kuhastudios.yyc/"
    }
  }
];

function getPostBySlug(slug) {
  return blogPosts.find(p => p.slug === slug) || null;
}

function setMeta(nameOrProp, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${nameOrProp}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, nameOrProp);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content || '');
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href || window.location.origin + '/');
}

function removeMeta(nameOrProp, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  const el = document.querySelector(`meta[${attr}="${nameOrProp}"]`);
  if (el) el.remove();
}

const HOMEPAGE_DESCRIPTION = 'Order Filipino-inspired cookies and soft breads baked in Calgary. Try Ube Dream Cookies, Milky Cheese Bread, and Dubai Chewy Cookies for pickup.';

function injectLocalBusinessSchema() {
  const origin = window.location.origin;
  const telephone = SMS_NUM.replace(/\D/g, '');
  const e164 = telephone.length === 10 ? '+1' + telephone : telephone.startsWith('1') ? '+' + telephone : '+' + telephone;
  let scriptEl = document.getElementById('local-business-jsonld');
  if (scriptEl) scriptEl.remove();
  scriptEl = document.createElement('script');
  scriptEl.id = 'local-business-jsonld';
  scriptEl.type = 'application/ld+json';
  scriptEl.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Bakery',
    name: 'Soft Bakes by KC',
    url: origin + '/',
    logo: origin + '/logo.png',
    description: HOMEPAGE_DESCRIPTION,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Calgary',
      addressRegion: 'AB',
      addressCountry: 'CA'
    },
    email: EMAIL_ADDR,
    telephone: e164,
    sameAs: [INSTAGRAM_URL, FACEBOOK_URL],
    areaServed: {
      '@type': 'City',
      name: 'Calgary',
      address: { '@type': 'PostalAddress', addressRegion: 'AB', addressCountry: 'CA' }
    }
  });
  document.head.appendChild(scriptEl);
}

function updateBlogSEO(post, pathname) {
  const origin = window.location.origin;
  const url = pathname ? origin + pathname : origin + '/blogs';

  if (post) {
    const articleUrl = origin + '/blogs/' + post.slug;
    const imageUrl = (post.images && post.images[0]) ? origin + post.images[0].src : origin + '/images/og-share.png';

    setMeta('description', post.excerpt);
    setCanonical(articleUrl);

    setMeta('og:title', post.title, true);
    setMeta('og:description', post.excerpt, true);
    setMeta('og:url', articleUrl, true);
    setMeta('og:type', 'article', true);
    setMeta('og:image', imageUrl, true);
    setMeta('og:locale', 'en_CA', true);
    setMeta('article:published_time', post.publishedDateISO ? post.publishedDateISO + 'T00:00:00-07:00' : '', true);
    setMeta('article:author', post.author, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', post.title);
    setMeta('twitter:description', post.excerpt);
    setMeta('twitter:image', imageUrl);

    setMeta('geo.region', 'CA-AB');
    setMeta('geo.placename', 'Calgary');

    const staleEventEl = document.getElementById('blog-event-jsonld');
    if (staleEventEl) staleEventEl.remove();
    let scriptEl = document.getElementById('blog-jsonld');
    if (scriptEl) scriptEl.remove();
    scriptEl = document.createElement('script');
    scriptEl.id = 'blog-jsonld';
    scriptEl.type = 'application/ld+json';
    scriptEl.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.title,
      description: post.excerpt,
      datePublished: post.publishedDateISO ? post.publishedDateISO + 'T00:00:00-07:00' : post.published,
      dateModified: post.publishedDateISO ? post.publishedDateISO + 'T00:00:00-07:00' : post.published,
      author: { '@type': 'Organization', name: post.author },
      publisher: { '@type': 'Organization', name: 'Soft Bakes by KC', logo: { '@type': 'ImageObject', url: origin + '/logo.png' } },
      image: imageUrl,
      mainEntityOfPage: { '@type': 'WebPage', '@id': articleUrl },
      contentLocation: { '@type': 'Place', name: 'Calgary', address: { '@type': 'PostalAddress', addressRegion: 'AB', addressCountry: 'CA' } }
    });
    document.head.appendChild(scriptEl);

    if (post.event) {
      const eventEl = document.createElement('script');
      eventEl.id = 'blog-event-jsonld';
      eventEl.type = 'application/ld+json';
      eventEl.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: post.event.name,
        description: post.excerpt,
        startDate: post.event.startDate,
        endDate: post.event.endDate,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        image: [imageUrl],
        url: articleUrl,
        location: {
          '@type': 'Place',
          name: post.event.venue,
          address: { '@type': 'PostalAddress', streetAddress: post.event.streetAddress, addressLocality: 'Calgary', addressRegion: 'AB', postalCode: 'T2G 3A5', addressCountry: 'CA' }
        },
        organizer: { '@type': 'Organization', name: post.event.organizerName, url: post.event.organizerUrl },
        performer: { '@type': 'Organization', name: 'Soft Bakes by KC', url: origin + '/' }
      });
      document.head.appendChild(eventEl);
    }
  } else {
    setCanonical(url);
    setMeta('description', 'Stories and updates from the Soft Bakes kitchen. Calgary bakery, Filipino bakes, community events.');
    setMeta('og:title', 'Blog | Soft Bakes by KC', true);
    setMeta('og:description', 'Stories and updates from the Soft Bakes kitchen. Calgary bakery, Filipino bakes, community events.', true);
    setMeta('og:url', url, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', origin + '/images/og-share.png', true);
    setMeta('og:locale', 'en_CA', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Blog | Soft Bakes by KC');
    setMeta('twitter:description', 'Stories and updates from the Soft Bakes kitchen. Calgary bakery, Filipino bakes, community events.');
    setMeta('twitter:image', origin + '/images/og-share.png');
    setMeta('geo.region', 'CA-AB');
    setMeta('geo.placename', 'Calgary');
    const scriptEl = document.getElementById('blog-jsonld');
    if (scriptEl) scriptEl.remove();
  }
}

function getHeaderHTML(isBlogsActive, isRewardsActive, isMenuActive = false, isAboutActive = false) {
  return `
  <header class="header blur-effect">
    <div class="container header-container">
      <div class="logo-wrapper">
         <a href="/" class="logo-link"><img src="/logo.png" alt="Soft Bakes by KC Logo" class="brand-logo" /></a>
      </div>
      <nav class="nav">
        <a href="/menu" class="nav-link${isMenuActive ? ' nav-link-active' : ''}">Menu</a>
        <a href="/about" class="nav-link${isAboutActive ? ' nav-link-active' : ''}">About</a>
        <a href="/#contact" class="nav-link">Contact</a>
        <a href="/rewards" class="nav-link${isRewardsActive ? ' nav-link-active' : ''}">Rewards</a>
        <a href="/blogs" class="nav-link${isBlogsActive ? ' nav-link-active' : ''}">Blogs</a>
        <button type="button" class="nav-cart-button" id="openCartDrawer" aria-label="Open shopping cart">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L20 7H6"/><circle cx="10" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>
          <span>Cart</span>
          <span class="cart-count-badge" hidden>0</span>
        </button>
        <a href="/menu" class="btn-primary btn-small order-btn">Order Now</a>
      </nav>
    </div>
  </header>`;
}

function getBlogsMainHTML(pathname) {
  const slug = pathname === '/blogs' || !pathname.startsWith('/blogs/') ? null : pathname.replace(/^\/blogs\/?/, '');
  const post = slug ? getPostBySlug(slug) : null;

  if (post) {
    return getBlogPostHTML(post);
  }

  if (slug) {
    return `
  <main class="blog-page">
    <section class="section blog-section">
      <div class="blog-reading-width">
        <h1 class="blog-page-title">Page not found</h1>
        <p class="blog-page-subtitle">That blog post does not exist. Browse current stories below or <a href="/">return home</a>.</p>
        <p><a href="/blogs" class="btn btn-primary">Back to blog</a></p>
      </div>
    </section>
  </main>`;
  }

  return `
  <main class="blog-page">
    <section class="section blog-section">
      <div class="blog-reading-width">
        <h1 class="blog-page-title">Blog</h1>
        <p class="blog-page-subtitle">Stories and updates from the Soft Bakes kitchen.</p>
        <div class="blog-list">
          ${[...blogPosts].sort((a, b) => b.publishedDateISO.localeCompare(a.publishedDateISO)).map(p => `
            <article class="blog-card">
              <a href="/blogs/${p.slug}" class="blog-card-link">
                ${p.images && p.images[0] ? `<img src="${p.images[0].src}" alt="${p.images[0].alt}" class="blog-card-image" loading="lazy" />` : ''}
                <div class="blog-card-content">
                  <h2 class="blog-card-title">${p.title}</h2>
                  <p class="blog-card-meta">${p.published} · ${p.author}</p>
                  <p class="blog-card-excerpt">${p.excerpt}</p>
                </div>
              </a>
            </article>
          `).join('')}
        </div>
      </div>
    </section>
  </main>`;
}

function getBlogPostHTML(post) {
  const carouselId = 'blog-carousel-' + post.slug;
  const imagesHTML = post.images && post.images.length
    ? `
    <div class="blog-carousel" id="${carouselId}" aria-label="Event photos">
      <button type="button" class="blog-carousel-arrow blog-carousel-prev" aria-label="Previous slide">&larr;</button>
      <button type="button" class="blog-carousel-arrow blog-carousel-next" aria-label="Next slide">&rarr;</button>
      <div class="blog-carousel-track">
        ${post.images.map((img, i) => `
          <div class="blog-carousel-slide" data-index="${i}">
            <img src="${img.src}" alt="${img.alt}" loading="${i === 0 ? 'eager' : 'lazy'}" />
            ${img.caption ? `<div class="blog-carousel-overlay"><span class="blog-carousel-caption">${img.caption}</span></div>` : ''}
          </div>
        `).join('')}
      </div>
      <div class="blog-carousel-dots" aria-hidden="true"></div>
    </div>`
    : '';

  const shoutoutsHTML = post.shoutouts && post.shoutouts.length
    ? `
    <div class="blog-shoutouts">
      <h3 class="blog-shoutouts-title">Major Shoutouts</h3>
      <div class="blog-shoutouts-panels">
        ${post.shoutouts.map(s => s.groupTitle ? `
          <div class="blog-shoutout-panel blog-shoutout-panel-group">
            <span class="blog-shoutout-name">${s.groupTitle}</span>
            <ul class="blog-shoutout-list">
              ${s.people.map(p => `
                <li>
                  <a href="${p.url}" target="_blank" rel="noopener noreferrer" class="blog-shoutout-link">
                    ${p.name} <span class="blog-shoutout-handle">@${p.handle}</span>
                  </a>
                </li>
              `).join('')}
            </ul>
            <p class="blog-shoutout-note">${s.note}</p>
          </div>
        ` : `
          <div class="blog-shoutout-panel">
            <a href="${s.url}" target="_blank" rel="noopener noreferrer" class="blog-shoutout-link">
              <span class="blog-shoutout-name">${s.name}</span>
              <span class="blog-shoutout-handle">@${s.handle}</span>
              <p class="blog-shoutout-note">${s.note}</p>
            </a>
          </div>
        `).join('')}
      </div>
    </div>`
    : '';

  const bodyHTML = getBlogPostBodyHTML(post);

  return `
  <main class="blog-page blog-page-article">
    <article class="blog-article">
      <header class="blog-article-header">
        <div class="blog-reading-width">
          <h1 class="blog-article-title">${post.title}</h1>
          <p class="blog-article-meta">Published by ${post.author} · ${post.published}</p>
        </div>
      </header>
      ${imagesHTML}
      <div class="blog-reading-width blog-article-body">
        ${bodyHTML}
        ${shoutoutsHTML}
        ${post.slug === 'soho-volume-1-community-coffee-bakes' ? '<p class="blog-footer-shoutout">Shoutout to <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a> for our uniforms.</p>' : ''}
      </div>
    </article>
  </main>`;
}

function getBlogPostBodyHTML(post) {
  if (post.slug === 'planning-bakery-order-for-an-event') return `<p>A simple order brief helps a bakery understand your event. Start with your guest count, serving date and pickup window, then ask what is available for your date and how the treats should be stored.</p><h2>Describe the event and the people you are serving</h2><p>Share the date, approximate number of guests, and whether the treats are dessert, a snack, or gifts to take home. If guests will choose from several flavours, ask how each item is packaged and whether separate boxes can be arranged. Check availability rather than assuming every item can be mixed into one box.</p><h2>Ask about ingredients and dietary needs</h2><p>Tell the bakery about any allergies or dietary restrictions before ordering. Ask for the ingredients in the specific products and whether cross-contact with allergens is possible. Do not assume a flavour name or appearance tells you everything about its ingredients. For a severe allergy, make a decision based on the bakery's specific response and the guest's needs.</p><h2>Confirm quantity, timing and storage</h2><p>Ask what quantities each item is sold in, the total cost, the available pickup time and how long the treats should be kept. If you need labels or individual packaging, ask whether those options are offered. Allow time between pickup and the event for transport and setup.</p><h2>Use the current menu as a starting point</h2><p><a href="/menu">Our current menu</a> lists Filipino-inspired treats, including cookies and buns. Pickup details are confirmed after an order is sent. Items and availability can change, so check the menu and contact KC before finalizing an event plan.</p>`;
  if (post.slug === 'soho-volume-1-community-coffee-bakes') return getSOHOPostBody();
  if (post.slug === 'spring-2026-custom-cookie-boxes-calgary') return getSpringCookieBoxesPostBody();
  if (post.slug === 'calgary-pop-up-branding-treats-and-custom-merch') return getCalgaryPopUpBrandingPostBody();
  if (post.slug === 'filipino-inspired-treats-calgary-pickup-guide') return getFilipinoTreatsCalgaryGuidePostBody();
  if (post.slug === 'best-ube-pandesal-calgary-soft-bakes') return getBestUbePandesalCalgaryPostBody();
  if (post.slug === 'office-thank-you-treats-calgary') return getOfficeThankYouTreatsCalgaryPostBody();
  if (post.slug === 'milky-dubai-chewy-cookie-calgary') return getMilkyDubaiChewyCookieCalgaryPostBody();
  if (post.slug === 'baby-shower-cookies-calgary') return getBabyShowerCookiesCalgaryPostBody();
  if (post.slug === 'filipino-desserts-calgary-guide') return getFilipinoDessertsCalgaryGuidePostBody();
  if (post.slug === 'birthday-cookie-box-calgary') return getBirthdayCookieBoxCalgaryPostBody();
  if (post.slug === 'corporate-gift-boxes-calgary-bakery') return getCorporateGiftBoxesCalgaryPostBody();
  if (post.slug === 'event-merch-and-treats-calgary') return getEventMerchAndTreatsCalgaryPostBody();
  if (post.slug === 'filipino-food-gifts-calgary') return getFilipinoFoodGiftsCalgaryPostBody();
  if (post.slug === 'bridal-shower-treats-calgary') return getBridalShowerTreatsCalgaryPostBody();
  if (post.slug === 'ensaymada-calgary-soft-bakes') return getEnsaymadaCalgarySoftBakesPostBody();
  if (post.slug === 'team-appreciation-baked-goods-calgary') return getTeamAppreciationBakedGoodsCalgaryPostBody();
  if (post.slug === 'filipino-breakfast-bread-calgary') return getFilipinoBreakfastBreadCalgaryPostBody();
  if (post.slug === 'small-celebration-cookies-calgary') return getSmallCelebrationCookiesCalgaryPostBody();
  if (post.slug === 'why-soft-bakes-bakes-to-order-calgary') return getWhySoftBakesBakesToOrderCalgaryPostBody();
  if (post.slug === 'calgary-market-vendor-treats-guide') return getCalgaryMarketVendorTreatsGuidePostBody();
  if (post.slug === 'kuha-studios-social-house-vol-2-pop-up-calgary') return getKuhaSocialHouseVol2PostBody();
  return '';
}

function getSOHOPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Wow, what a night. If you were at Studio 122 yesterday, you know exactly what I mean. At Soft Bakes by KC we always say our treats are baked with love, but seeing that love reflected back by the Calgary community during KUHA Studio's SOHO (Social House) Volume 1 was something else entirely.</p>
      <p>This wasn't just another pop-up. It felt like the start of something. The energy was real: organizers uniting Calgary's local entrepreneurs and giving our vibrant Filipino community the recognition it deserves. We're so honored to have been part of this first episode of community engagement.</p>
      <h2 class="blog-h2">The Aesthetic & The Vibe</h2>
      <p>The space looked incredible thanks to everyone involved. That perfect blend of SOHO-style industrial cool and warm, welcoming home vibes. Major love to Kuha Studios for bringing the community together and helping everyone capture those core memories with their photo booth studio. It was the heart of the social experience.</p>
      <p>While people browsed the art and our baked treats, the atmosphere was set by DJ Jalen and DJ Rhayver. Huge thanks to them for the good vibes and keeping the energy high all evening.</p>
      <h2 class="blog-h2">Bringing the Sweet to the Social House</h2>
      <p>Our debut of the limited-edition Ensaymadas was a hit. We're so happy people enjoyed those pop-up specials, and it was amazing to see our signature treats enjoyed just as much. Everyone chatting over a Muni Muni drink with a Soft Bake in hand is exactly why we do this. Community is the secret ingredient in everything we bake, and last night proved that when we support each other, we all rise. (Pun intended.)</p>
      <h2 class="blog-h2">What's Next</h2>
      <p>If you missed SOHO Vol 1, don't worry. This is only the beginning of our journey with the local community, and we can't wait to see where it goes. Follow us and all the creators linked above to stay in the loop for the next Social House event.</p>
      <p class="blog-thank-you">A huge thank you to everyone who tried our treats and took a moment to share such kind words. It truly means the world to us. We'll keep striving to bring you the softest, most delightful pastries, from our kitchen to your table.</p>
    </div>`;
}

function getSpringCookieBoxesPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Spring in Calgary fills up fast with birthdays, baby showers, team thank-yous, and the kind of small gatherings that still deserve something special on the table. At Soft Bakes by KC we have been getting more requests for custom cookie boxes that feel personal without needing a full catering spread.</p>
      <p>This post explains how we put those boxes together, what you can mix in one order, and how far ahead to reach out so everything is baked fresh for pickup.</p>
      <h2 class="blog-h2">What goes in a custom cookie box?</h2>
      <p>Most spring boxes start with a mix of crowd favorites: Dubai chewy cookies, red velvet crinkles, and ube pandesal when you want something distinctly Filipino-inspired. Some customers add ensaymada for a softer, brioche-style treat. We can label flavors on request so guests know what they are grabbing.</p>
      <p>Boxes work well for offices, teacher gifts, bridal showers, and family dinners. If you are not sure what ratio to pick, tell us how many people you are feeding and whether you want mostly classic flavors or more ube-forward options.</p>
      <h2 class="blog-h2">How far ahead should you order?</h2>
      <p>For a standard custom box, three to five days notice is usually enough. Larger event orders or boxes that need specific packaging may need a full week. Spring weekends fill quickly, so earlier is better when you have a fixed pickup date.</p>
      <p>We bake to order. That means your box is not pulled from a freezer shelf. It is assembled after you confirm flavors, quantity, and pickup time.</p>
      <h2 class="blog-h2">Pickup and delivery in Calgary</h2>
      <p>Most custom box orders are pickup. We will confirm time and location when your order is placed. If you need delivery, ask when you order and we will let you know what is possible for your date and area.</p>
      <h2 class="blog-h2">How to place a spring box order</h2>
      <p>Use the order form on our site or message us with your event date, approximate headcount, and any flavor preferences. We will reply with options and pricing before anything is confirmed.</p>
      <p class="blog-thank-you">Thank you for supporting a small Calgary bakery. We love seeing our treats on your celebration tables. Planning a booth look too? Read our post on <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">pop-up branding and team merch</a>.</p>
    </div>`;
}

function getCalgaryPopUpBrandingPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">People remember the food first at a pop-up. They also remember whether your booth looked like a real business or a folding table with good luck. At Soft Bakes by KC we care about both: Filipino-inspired treats on the table and simple branded gear on the team so photos and tags are easy to find after the event.</p>
      <p>This is how we plan merch alongside cookie boxes and limited runs like our ensaymada debut at <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>.</p>
      <h2 class="blog-h2">Start with what shows up in photos</h2>
      <p>Event photos catch your table layout, packaging, and what your team is wearing. We keep packaging consistent first: boxes, labels, and menu cards that match our site and Instagram. Then we add aprons or shirts so staff are recognizable in crowd shots without shouting our name at every customer.</p>
      <p>For our SOHO night we worked with <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a> on team shirts. Having a local DTF supplier that understands small runs made it easier to order what we needed without committing to a huge screen print minimum.</p>
      <h2 class="blog-h2">Match treats and merch to the same event story</h2>
      <p>If you are selling <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes</a> for spring showers or office thank-yous, think about whether staff should wear neutral aprons or a simple logo tee that matches your box colors. Customers notice when the table feels planned. It also helps other vendors and organizers tag the right account when they post recap photos.</p>
      <h2 class="blog-h2">What we would order again</h2>
      <p>Black or neutral garments press well and survive long market days. Small chest logos read cleaner in photos than full back designs with tiny URLs. We keep one master logo file and reuse it for shirts, stickers, and packaging so everything stays aligned.</p>
      <p>If you run a shop or production studio, <a href="https://formulatedapps.com/blogs/small-business-event-merch-dtf-pop-ups-2026" target="_blank" rel="noopener noreferrer">Formulated Apps wrote a practical guide to event merch and DTF gang sheets</a> that matches what we learned on the vendor side. Their <a href="https://formulatedapps.com/blogs/how-to-choose-a-dtf-transfer-supplier-2026" target="_blank" rel="noopener noreferrer">supplier checklist</a> is useful if you are comparing transfer vendors before your next order.</p>
      <h2 class="blog-h2">Planning timeline for your next pop-up</h2>
      <p>Three weeks out: confirm menu or box offerings and garment count. Two weeks out: finalize logo placement with your print supplier. One week out: press or receive garments and pack them with your display items. Day of: lint roll, clip loose threads, and keep one spare tee in the car. After the event, note what sold out and what appeared most in tagged photos so the next booking is easier.</p>
      <p class="blog-thank-you">Thank you to Formulated Prints for supporting our team gear, and to every Calgary organizer and vendor who makes community nights like SOHO possible. Follow us for the next pop-up and cookie box openings.</p>
    </div>`;
}

function getFilipinoTreatsCalgaryGuidePostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Calgary has a growing appetite for Filipino-inspired baking, from ube-forward buns to rich chewy cookies that travel well in a box. If you are ordering for the first time, this guide explains what each treat is, who it is for, and how far ahead to reach out for pickup anywhere in the YYC area.</p>
      <h2 class="blog-h2">What is ube pandesal?</h2>
      <p>Ube pandesal is a soft Filipino-style roll with ube, a purple yam that adds color and a mild, earthy sweetness. Ours are baked fresh to order, not pulled from a freezer case. They work for breakfast boxes, office mornings, and anyone who wants something familiar if they grew up with Filipino bakeries and something new if they did not.</p>
      <p>Order a dozen when you want a shareable tray. Order two dozen when you are feeding a team meeting or family brunch across Calgary northeast, northwest, or downtown pickup windows we confirm at order time.</p>
      <h2 class="blog-h2">What are Dubai chewy cookies?</h2>
      <p>Dubai chewy cookies are rich, stuffed cookies with a soft center and bold flavor. They hold up well in gift boxes and survive a car ride across the city better than frosted cupcakes. Pair them with ube pandesal in a mixed box when your group wants variety without committing to a full cake.</p>
      <h2 class="blog-h2">Red velvet crinkles and ensaymada</h2>
      <p>Red velvet crinkles are a crowd default when you are not sure what everyone likes. Ensaymada is a brioche-style Filipino pastry we sometimes offer as a limited run at pop-ups like <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>. Watch our Instagram for the next date if you missed the first batch.</p>
      <h2 class="blog-h2">Best occasions for Calgary pickup orders</h2>
      <p><strong>Office thank-yous:</strong> Mixed cookie boxes labeled by flavor. Order mid-week and pick up before Friday meetings.<br><strong>Family gatherings:</strong> Pandesal trays plus crinkles for kids and adults who want different textures.<br><strong>Baby showers and birthdays:</strong> Custom boxes described in our <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">spring cookie box guide</a>.<br><strong>Community events:</strong> Plan with our <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">pop-up branding tips</a> if you are a vendor pairing treats with team shirts from local print partners like <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a>.</p>
      <h2 class="blog-h2">How far ahead should Calgary customers order?</h2>
      <p>For a standard mixed box or two dozen pandesal, three to five days notice is usually enough. Larger office orders or custom flavor splits may need a full week, especially before long weekends when YYC pickup schedules fill quickly. We bake after you confirm, so last-minute same-day requests are not always possible.</p>
      <h2 class="blog-h2">Pickup areas and delivery in YYC</h2>
      <p>Most orders are pickup at a confirmed Calgary location and time window. Delivery may be available for select dates; ask when you order and include your neighborhood so we can give an honest answer. We serve customers across Calgary and surrounding communities who are willing to meet at an agreed pickup point.</p>
      <h2 class="blog-h2">How to place your first order</h2>
      <p>Use the order form on our homepage or message us with your date, headcount, and any flavor preferences. Tell us if you need labels for an office or a note card for a gift. We reply with options before anything is confirmed.</p>
      <p>If you run a Calgary market booth and want ideas for packaging plus team apparel, <a href="https://formulatedapps.com/blogs/calgary-makers-markets-custom-dtf-apparel-guide" target="_blank" rel="noopener noreferrer">Formulated Apps published a practical YYC vendors guide to custom DTF apparel</a> that pairs well with a food-focused table setup.</p>
      <p class="blog-thank-you">Thank you for supporting a home bakery rooted in Calgary. We love feeding the city we live in.</p>
    </div>`;
}

function getBestUbePandesalCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">If you grew up grabbing pandesal from a bakery counter, you know the difference between a roll that pulls apart soft and one that turns into a hockey puck by noon. In Calgary, ube pandesal shows up at grocery freezers, pop-up tables, and home bakeries like ours. The purple color is easy to copy. The texture is not.</p>
      <p>We bake ube pandesal to order because that is the only way to keep the crumb soft and the ube flavor honest. This post is our straight answer to what makes great ube pandesal in YYC, why fresh matters, and how to order when you are feeding an office or a Sunday family table.</p>
      <h2 class="blog-h2">What ube pandesal should feel like when you bite it</h2>
      <p>Good ube pandesal is still a pandesal first: lightly sweet, soft inside, with a thin crust that does not fight your teeth. Ube adds color and a mild, earthy sweetness. It should not taste like purple food coloring and sugar paste.</p>
      <p>Ours uses real ube in the dough, not a neon shortcut. When you tear one open, the inside should look moist and even, not dry and crumbly. That is the baseline. Everything else is about timing and how soon you eat them after bake day.</p>
      <h2 class="blog-h2">Why most Calgary options fall short</h2>
      <p>Freezer case rolls survive shipping. They do not survive the standard people hold Filipino bread to. Pandesal is best within a day or two of baking. After that, even good bread stiffens, especially in Alberta dry air.</p>
      <p>Some shops treat ube as a novelty flavor on a generic sweet bun recipe. You get color without structure. Other vendors only offer pandesal at pop-ups, which is fun but hard to plan around when you need two dozen for a Monday meeting in the northwest or a family brunch in the southeast.</p>
      <p>We are not trying to win a debate about every bakery in the city. We are saying that if you want ube pandesal that actually eats like pandesal, you need a baker who makes them after you order and tells you when to pick up while they are still at their best.</p>
      <h2 class="blog-h2">What makes Soft Bakes ube pandesal worth ordering</h2>
      <p>We bake in small batches tied to confirmed orders, not a warehouse shelf. That means your tray is not leftover from last week's market. It also means we can pair pandesal with <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes</a> or <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">mixed Filipino-inspired treat orders</a> when you want variety without ordering from three places.</p>
      <p>Customers who know ube usually notice the balance first: color without perfume sweetness. Customers new to Filipino baking usually ask if they can take a dozen to the office. Both groups care about the same thing once they try a fresh roll: whether it is still soft at the second cup of coffee.</p>
      <h2 class="blog-h2">Best ways to order ube pandesal in Calgary</h2>
      <p><strong>Office mornings:</strong> Order a dozen or two with pickup timed before your meeting. Ask for flavor labels if your team has not tried ube before.<br><strong>Family brunch:</strong> Pair pandesal with red velvet crinkles or Dubai chewy cookies from our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">pickup guide</a> so kids and adults get different textures.<br><strong>Community events:</strong> If you are vending, read our <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">booth branding notes</a>. Treats pull a crowd. Branded aprons help people find you in recap photos. We have worked with <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a> on team gear for nights like <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>.</p>
      <h2 class="blog-h2">How far ahead to book pickup in YYC</h2>
      <p>For one or two dozen, three to five days notice is usually enough. Larger office trays or orders mixed with custom boxes may need a full week, especially before long weekends when Calgary pickup slots fill fast. We confirm time and location when your order is placed. Delivery is limited, so tell us your neighborhood early if you need it.</p>
      <h2 class="blog-h2">How to place an order</h2>
      <p>Use the order form on our homepage or message us with your date, quantity, and pickup area. Tell us if it is a first-time ube order for your group. We will reply with availability before anything is confirmed.</p>
      <p>If you run a Calgary shop and want a practical read on small-run merch for markets, <a href="https://formulatedapps.com/blogs/best-gang-sheet-builder-software" target="_blank" rel="noopener noreferrer">Formulated Apps wrote a sharp guide on gang sheet builder software</a> that pairs well with the vendor side of event planning.</p>
      <p class="blog-thank-you">Thank you for supporting a Calgary home bakery. We love seeing ube pandesal on your table while it is still soft.</p>
    </div>`;
}

function getOfficeThankYouTreatsCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Office thank-yous in Calgary usually land on a Thursday or Friday when someone on the team did extra work, a client sent a kind note, or leadership wants a small morale boost without booking full catering. The best orders are easy to share, labeled clearly, and still taste fresh when the meeting starts.</p>
      <p>At Soft Bakes by KC we build office treat orders from the same signature menu you see on our <a href="/menu">treats page</a>: ube pandesal trays, Dubai chewy cookies, Milky Dubai Chewy Cookies, red velvet crinkles, and mixed boxes when your group wants variety.</p>
      <h2 class="blog-h2">What Calgary offices order most often</h2>
      <p><strong>Mixed cookie boxes:</strong> Half Dubai, half red velvet crinkle, sometimes with a few ube pandesal for teams curious about Filipino-inspired baking. See our <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">spring custom box guide</a> for sizing.<br><strong>Pandesal mornings:</strong> One or two dozen ube pandesal timed for an early pickup before a stand-up or client breakfast. Read <a href="/blogs/best-ube-pandesal-calgary-soft-bakes">what makes great ube pandesal in Calgary</a> if your team has not tried it before.<br><strong>Friday morale trays:</strong> Chewy cookie half dozens plus labeled flavors so people grab quickly between meetings.</p>
      <h2 class="blog-h2">How far ahead to book office pickup in YYC</h2>
      <p>For a standard mixed box or one dozen pandesal, three to five business days is usually enough. Orders for ten or more people, multiple flavor splits, or note cards may need a full week — especially before long weekends when Calgary pickup windows fill fast.</p>
      <p>We bake after you confirm. That means your tray is not pulled from a freezer shelf the night before. Tell us your meeting time and we will suggest a pickup window so everything is still soft when you walk into the office.</p>
      <h2 class="blog-h2">Labels, dietary notes, and first-time ube orders</h2>
      <p>Ask for flavor labels when half your team has not tried ube before. We can note common allergens at a high level, but everything is made in a home kitchen that also processes nuts, dairy, wheat, and soy. For severe allergies, message us before ordering.</p>
      <p>If you want a broader Filipino-inspired spread for a larger gathering, our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Calgary pickup guide</a> explains how to mix pandesal, cookies, and limited runs like ensaymada when they are available.</p>
      <h2 class="blog-h2">How to place an office thank-you order</h2>
      <p>Use the order form on our homepage or message us with your date, headcount, pickup neighborhood, and any flavor preferences. Mention if you need a receipt-friendly total for an expense report. We reply with options before anything is confirmed.</p>
      <p class="blog-thank-you">Thank you for choosing a small Calgary bakery for your team. We love seeing our treats on break-room tables across YYC.</p>
    </div>`;
}

function getMilkyDubaiChewyCookieCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Dubai chewy cookies took over social feeds for a reason: rich filling, crunchy kataifi, and a cookie that feels like dessert and snack at the same time. Not everyone wants the classic cocoa-dusted shell though. That is why we added the Milky Dubai Chewy Cookie to our Calgary menu — same pistachio crunch inside, with a lighter, creamier milky outer layer.</p>
      <p>This post explains what makes our version different, how we pack half dozen boxes for gifts and office orders, and how to order pickup anywhere in the YYC area.</p>
      <h2 class="blog-h2">What is a Milky Dubai Chewy Cookie?</h2>
      <p>Think of our original <a href="/menu">Dubai Chewy Cookie</a> structure: soft chewy exterior, crispy pistachio kataifi filling, bold texture contrast. The Milky version swaps the cocoa dust for a creamy milky shell finished with a milk powder blend. It reads lighter on the palate while keeping the crunch people chase in Dubai-style cookies.</p>
      <p>We sell them by the half dozen (6 pcs) for $35, baked fresh after you order — not thawed from a wholesale tray.</p>
      <h2 class="blog-h2">Who orders them in Calgary</h2>
      <p><strong>Gift boxes:</strong> Birthdays, thank-yous, and client surprises where you want something trending but not generic.<br><strong>Office trays:</strong> Pair with ube pandesal when you want one sweet item that feels new and one that feels familiar. See our <a href="/blogs/office-thank-you-treats-calgary">office thank-you guide</a> for timing.<br><strong>Pop-up nights:</strong> Limited runs sell fast at community events like <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>. Pre-order when you know the date.</p>
      <h2 class="blog-h2">Milky vs classic Dubai — which should you pick?</h2>
      <p>Choose classic Dubai if your group loves deep cocoa and a darker shell. Choose Milky Dubai if someone in the order dislikes cocoa powder or wants a cream-forward finish. Mixed half-and-half boxes are popular for first-time orders.</p>
      <p>Both hold up well in Calgary car rides better than frosted cupcakes, which is why they show up in our <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes</a> alongside red velvet crinkles.</p>
      <h2 class="blog-h2">How far ahead to order pickup</h2>
      <p>For one or two half dozen boxes, three to five days notice is usually enough. Larger mixed orders or event quantities may need a full week. We confirm pickup time and location when your order is placed.</p>
      <h2 class="blog-h2">Order Milky Dubai Chewy Cookies</h2>
      <p>Browse the full <a href="/menu">menu</a>, click Add to Order on the Milky Dubai Chewy Cookie card, or message us with your date and quantity. Tell us if you need flavor labels for an office or a short note for a gift.</p>
      <p class="blog-thank-you">Thank you for supporting a Calgary home bakery. We love introducing YYC to our creamier take on a viral favorite.</p>
    </div>`;
}

function getBabyShowerCookiesCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Baby shower tables in Calgary usually need something pretty, easy to share, and still memorable after the last guest leaves. A custom cookie box hits that sweet spot better than a sheet cake slice fight — especially when you mix classic shower colors with treats your family has not tried before.</p>
      <p>At Soft Bakes by KC we build baby shower orders the same way we build <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">spring celebration boxes</a>: you tell us the date, headcount, and vibe; we bake fresh after you confirm and coordinate pickup anywhere in YYC.</p>
      <h2 class="blog-h2">What goes in a baby shower cookie box?</h2>
      <p>Most Calgary showers start with a mix of crowd favorites and one conversation starter. Red velvet crinkles and Dubai chewy cookies travel well and look great on a dessert table. Ube pandesal adds soft Filipino-inspired color without needing custom icing on every roll. Some hosts add ensaymada when we have a limited run available — watch our Instagram for dates.</p>
      <p>Tell us if you want pastel-forward packaging, flavor labels for guests, or a split box for dietary preferences. We can keep one section nut-heavy (pistachio Dubai cookies) and another simpler (crinkles and pandesal) when you ask early.</p>
      <h2 class="blog-h2">How many treats to order for your guest count</h2>
      <p><strong>Intimate shower (12–20 guests):</strong> One mixed half-dozen box plus a dozen ube pandesal usually covers grazing after lunch.<br><strong>Medium shower (25–40 guests):</strong> Two mixed boxes or one large custom split with labeled flavors.<br><strong>Drop-off gift for the honoree:</strong> A single curated box with a note card — popular when the shower is out of town but the family is in Calgary.</p>
      <p>If you are also feeding an office the same week, read our <a href="/blogs/office-thank-you-treats-calgary">office thank-you guide</a> for timing two pickups without over-ordering.</p>
      <h2 class="blog-h2">How far ahead to book in Calgary</h2>
      <p>For a standard baby shower box, five to seven days notice is ideal. Popular spring and summer weekends fill quickly across Calgary northwest, southeast, and downtown pickup windows. We bake after you confirm, so last-minute same-day requests are not always possible.</p>
      <p>Share your shower date, approximate guest count, and any theme colors when you message us. We reply with options and pricing before anything is confirmed.</p>
      <h2 class="blog-h2">Pickup and pairing ideas for YYC hosts</h2>
      <p>Most orders are pickup at a confirmed Calgary time window. Pair the box with coffee or Filipino-inspired drinks if your shower has a brunch vibe. If you want a broader intro to our menu first, browse our <a href="/menu">signature treats page</a> or read the <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Filipino-inspired pickup guide</a>.</p>
      <p>Hosts planning shower favors plus a dessert table sometimes order ube pandesal trays separately from cookie boxes so guests can take rolls home after the table spread.</p>
      <h2 class="blog-h2">How to place a baby shower order</h2>
      <p>Use the order form on our homepage or message us with your date, guest count, and flavor preferences. Mention baby shower in the note so we can suggest box sizes and labels. A 50% deposit confirms your bake slot once we accept the order.</p>
      <p class="blog-thank-you">Thank you for letting Soft Bakes be part of your Calgary celebration. We love seeing our treats on shower tables across YYC.</p>
    </div>`;
}

function getFilipinoDessertsCalgaryGuidePostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Filipino desserts in Calgary used to mean whatever showed up at a grocery freezer or a one-off pop-up table. That is changing. Home bakeries and small vendors now offer ube-forward rolls, ensaymada, and chewy cookies built for pickup across YYC, not just festival weekends.</p>
      <p>This guide names the desserts people ask us about most, what each one is, and how to order fresh instead of settling for stale imitations.</p>
      <h2 class="blog-h2">Ube pandesal and ube-forward buns</h2>
      <p>Ube is a purple yam with a mild, earthy sweetness. In pandesal it adds color and softness without tasting like candy. Good ube pandesal should still pull apart like bread, not crumble like cake. We bake ours to order; read <a href="/blogs/best-ube-pandesal-calgary-soft-bakes">what makes great ube pandesal in Calgary</a> if you are comparing options.</p>
      <h2 class="blog-h2">Ensaymada and brioche-style Filipino pastries</h2>
      <p>Ensaymada is a soft, enriched bun often topped with sugar and finished with flavors like cheesy, Biscoff, or pistachio. We debut limited runs at community events like <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>. Follow our Instagram when you want the next batch date.</p>
      <h2 class="blog-h2">Chewy cookies and stuffed favorites</h2>
      <p>Dubai-style chewy cookies and our <a href="/blogs/milky-dubai-chewy-cookie-calgary">Milky Dubai Chewy Cookie</a> travel well in gift boxes. Red velvet crinkles are the safe pick when your group mixes adventurous and classic eaters. All are on our <a href="/menu">menu page</a>.</p>
      <h2 class="blog-h2">Filipino bakery Calgary: what to ask before you order</h2>
      <p>Ask whether items are baked after you confirm or pulled from frozen stock. Ask for pickup timing in your neighborhood. Ask for flavor labels on office orders. A real Filipino bakery Calgary customers return to will answer those plainly.</p>
      <p>For broader occasion planning, see our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Filipino-inspired pickup guide</a> and <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie box guide</a>.</p>
      <h2 class="blog-h2">How to order from Soft Bakes by KC</h2>
      <p>Message us with your date, headcount, and favorites. Three to five days notice works for most mixed orders; larger trays may need a week. We confirm Calgary pickup details before anything is baked.</p>
      <p class="blog-thank-you">Thank you for supporting Filipino-inspired baking in Calgary. We love feeding the city we live in.</p>
    </div>`;
}

function getBirthdayCookieBoxCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Birthday cookie boxes in Calgary work when they are easy to share, labeled clearly, and still taste fresh after candles and photos. Sheet cake slices fight for fork space. A mixed box of chewy cookies and ube pandesal lets guests grab what they want without a plating mess.</p>
      <h2 class="blog-h2">What goes in a birthday cookie box?</h2>
      <p>Most Calgary birthday orders mix Dubai chewy cookies, red velvet crinkles, and ube pandesal for color and variety. Some hosts add Milky Dubai Chewy Cookie for guests who want a creamier shell. Tell us the birthday person's favorites and we suggest ratios.</p>
      <h2 class="blog-h2">How many boxes for your party size</h2>
      <p><strong>Small gathering (8–12 people):</strong> One mixed half-dozen cookie box plus a dozen pandesal.<br><strong>House party (15–25 people):</strong> Two mixed boxes or one large custom split with labels.<br><strong>Office birthday drop-off:</strong> Labeled half dozens so coworkers grab between meetings. See our <a href="/blogs/office-thank-you-treats-calgary">office thank-you guide</a> for timing.</p>
      <h2 class="blog-h2">How far ahead to book in Calgary</h2>
      <p>Five to seven days is ideal for custom birthday boxes. Summer weekends in YYC fill fast. We bake after you confirm, so share your party date early when pickup has to hit before guests arrive.</p>
      <h2 class="blog-h2">Pair with other celebration guides</h2>
      <p>Planning a shower in the same season? Read <a href="/blogs/baby-shower-cookies-calgary">baby shower cookies in Calgary</a>. Want a broader spring spread? See <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes for Calgary events</a>.</p>
      <h2 class="blog-h2">How to place a birthday order</h2>
      <p>Use the order form on our homepage or message us with date, guest count, and flavor notes. Mention birthday in the message so we suggest the right box size. A deposit confirms your bake slot once we accept the order.</p>
      <p class="blog-thank-you">Thank you for celebrating with a Calgary home bakery. We love seeing our boxes on birthday tables across YYC.</p>
    </div>`;
}

function getCorporateGiftBoxesCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Corporate gift boxes in Calgary should feel personal without needing a full catering contract. Clients and staff remember a labeled box of fresh treats more than another generic mug. The trick is ordering something that survives a car ride across the city and still looks intentional on a desk.</p>
      <h2 class="blog-h2">What Calgary offices order for client thank-yous</h2>
      <p>Mixed cookie boxes with labeled flavors work for client visits and project close-outs. Ube pandesal trays surprise teams who have only had grocery rolls. Milky and classic Dubai chewy cookies photograph well when marketing wants a quick team shot. Browse options on our <a href="/menu">menu</a>.</p>
      <h2 class="blog-h2">Staff appreciation and Friday morale boxes</h2>
      <p>Friday drops need pickup timed before lunch. Tell us your headcount and we suggest half-dozen splits. For recurring monthly treats, book standing dates when you know review season or sprint endings.</p>
      <p>Our <a href="/blogs/office-thank-you-treats-calgary">office thank-you treats guide</a> covers lead times and labeling for YYC teams.</p>
      <h2 class="blog-h2">Corporate gift boxes Calgary bakery logistics</h2>
      <p>Most orders are pickup at a confirmed Calgary window. Include your neighborhood when you message us. Ask for receipt-friendly totals if finance needs them. We can note allergens at a high level; everything is made in a home kitchen that also processes nuts, dairy, wheat, and soy.</p>
      <h2 class="blog-h2">Filipino-inspired options for diverse teams</h2>
      <p>Filipino desserts Calgary offices may not have tried yet are a conversation starter without feeling risky when paired with familiar crinkles. Read our <a href="/blogs/filipino-desserts-calgary-guide">Filipino desserts guide</a> if you want a quick explainer to share with HR before ordering.</p>
      <h2 class="blog-h2">How to place a corporate gift order</h2>
      <p>Message us with delivery or pickup date, recipient count, and any branding notes. We reply with box options and pricing before anything is confirmed. Larger multi-box orders may need five to seven business days.</p>
      <p class="blog-thank-you">Thank you for choosing a small Calgary bakery for your team and clients. We love being part of thank-yous across YYC.</p>
    </div>`;
}

function getEventMerchAndTreatsCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Treats get people to your table. Team merch is what they remember and tag in photos after the table is packed up. At Soft Bakes by KC we order both together for every Calgary market and pop-up, because a great cookie box next to a wrinkled t-shirt still looks like a folding-table operation.</p>
      <p>This post covers how we plan event merch and treats side by side, and why we keep ordering team apparel from the same DTF supplier instead of shopping around every time.</p>
      <h2 class="blog-h2">Why treats and merch are one planning decision, not two</h2>
      <p>If you plan cookie boxes in one conversation and shirts in another, colors clash and deadlines slip separately. We set both at once: box packaging, label colors, and what the team is wearing get decided the same week so the whole table reads as one brand, not a bake sale next to a merch table.</p>
      <p>See how we handle the treat side in our <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie box guide</a> and <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">pop-up branding notes</a>.</p>
      <h2 class="blog-h2">Why we use Formulated Prints for team apparel</h2>
      <p>Small bakeries do not need a 50-shirt minimum. We need ten to twenty pieces, printed correctly, in time for a Saturday market. <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a> handles DTF transfers at that scale without treating a small order like an afterthought. That matters when your event date is fixed and reprints are not an option.</p>
      <p>We first worked with them on team shirts for <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a>, and it became the default vendor for every event since.</p>
      <h2 class="blog-h2">What we order and why it holds up</h2>
      <p>Small chest logos on black or neutral shirts. Simple designs survive a full market day of lifting boxes, wiping hands, and standing under tent lighting better than large back prints with fine detail. <a href="https://formulatedprints.com/products/custom-dtf-gang-sheet" target="_blank" rel="noopener noreferrer">Custom DTF gang sheets</a> let us print a small batch without paying for a run size we do not need.</p>
      <h2 class="blog-h2">Planning timeline that keeps both on track</h2>
      <p>Three weeks out: confirm box flavors and shirt design together. Two weeks out: send art to print, confirm packaging order. One week out: pick up shirts, pack display items. Day of: focus on the table, not on whether the shirts arrived. Full breakdown in our <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">branding a Calgary pop-up guide</a>.</p>
      <h2 class="blog-h2">If you run a Calgary booth too</h2>
      <p>Vendors comparing DTF suppliers before their next event should read the <a href="https://formulatedapps.com/blogs/how-to-choose-a-dtf-transfer-supplier-2026" target="_blank" rel="noopener noreferrer">supplier checklist Formulated Apps put together</a>. It covers the same small-run questions we ask before every order: minimums, turnaround, and what happens when art needs a last-minute fix.</p>
      <p class="blog-thank-you">Thank you to Formulated Prints for keeping our team looking like a real business at every market, and to every Calgary organizer who makes room for small vendors.</p>
    </div>`;
}

function getFilipinoFoodGiftsCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Filipino food gifts in Calgary land best when they taste fresh, survive a car ride, and still feel personal on the table. A grocery tray of frozen rolls sends one message. A labeled box of ube pandesal and chewy cookies baked after you order sends another.</p>
      <h2 class="blog-h2">What to put in a Filipino food gift box</h2>
      <p>Most gift orders mix ube pandesal with Dubai chewy cookies or red velvet crinkles. Some add Milky Dubai Chewy Cookie when the recipient likes a creamier finish. Tell us if the box is for family abroad visiting Calgary, an office thank-you, or a friend who grew up with Filipino merienda.</p>
      <h2 class="blog-h2">Sizing for your occasion</h2>
      <p><strong>One-to-one thank-you:</strong> Half dozen cookies plus six pandesal.<br><strong>Family dinner drop-off:</strong> Two dozen pandesal with a mixed cookie box.<br><strong>Office gift:</strong> Labeled flavors so coworkers know what they are grabbing. See our <a href="/blogs/office-thank-you-treats-calgary">office thank-you guide</a>.</p>
      <h2 class="blog-h2">How far ahead to order in YYC</h2>
      <p>Three to five days notice works for most gift boxes. Holiday weeks and long weekends need a full week. We bake after you confirm pickup time anywhere in Calgary.</p>
      <h2 class="blog-h2">Pair with our Filipino treat guides</h2>
      <p>New to the menu? Read our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Filipino-inspired pickup guide</a> and <a href="/blogs/filipino-desserts-calgary-guide">Filipino desserts guide</a> before you order.</p>
      <p class="blog-thank-you">Thank you for gifting Filipino-inspired baking from a Calgary home bakery. We love being part of your thank-yous.</p>
    </div>`;
}

function getBridalShowerTreatsCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Bridal shower treats in Calgary should photograph well, share without forks, and still feel special next to flowers and games. Cookie boxes and pandesal trays hit that balance better than a sheet cake that needs slicing while guests mingle.</p>
      <h2 class="blog-h2">What hosts order for bridal showers</h2>
      <p>Pastel-friendly mixed boxes with red velvet crinkles, Dubai chewy cookies, and ube pandesal are the most common request. Some showers add ensaymada when we have a limited run available. Read <a href="/blogs/ensaymada-calgary-soft-bakes">ensaymada in Calgary</a> for the next drop date.</p>
      <h2 class="blog-h2">Guest counts and box sizes</h2>
      <p><strong>Intimate shower (15–25 guests):</strong> One large mixed box plus a dozen pandesal.<br><strong>Larger brunch shower (30–45 guests):</strong> Two custom splits with flavor labels.<br><strong>Out-of-town family gift:</strong> Curated box with note card for the honoree.</p>
      <h2 class="blog-h2">Timing and pickup in Calgary</h2>
      <p>Book five to seven days ahead for spring and summer weekends. We coordinate YYC pickup windows so treats are fresh before guests arrive. Planning a baby shower too? See <a href="/blogs/baby-shower-cookies-calgary">baby shower cookies in Calgary</a>.</p>
      <h2 class="blog-h2">How to place a bridal shower order</h2>
      <p>Message us with your date, guest count, and theme colors. Mention bridal shower in the note so we suggest the right box size. A deposit confirms your bake slot once we accept the order.</p>
      <p class="blog-thank-you">Thank you for letting Soft Bakes sweeten your Calgary celebration.</p>
    </div>`;
}

function getEnsaymadaCalgarySoftBakesPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Ensaymada in Calgary shows up at festivals, grocery aisles, and occasional bakery counters. Ours is a soft brioche-style Filipino bun we bake in limited runs because enriched dough needs small batches and fixed pickup windows, not a daily conveyor line.</p>
      <h2 class="blog-h2">What our ensaymada tastes like</h2>
      <p>Expect a tender crumb, light sweetness, and finishes like cheesy, Biscoff, Oreo, or pistachio depending on the drop. We debuted the line at <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a> and bring flavors back when the schedule allows.</p>
      <h2 class="blog-h2">How to catch the next Calgary batch</h2>
      <p>Follow @softbakesbykc on Instagram for drop announcements. Limited runs sell out at pop-ups. Pre-order when a date is posted if you need a dozen for brunch or a shower dessert table.</p>
      <h2 class="blog-h2">Pair ensaymada with other Filipino treats</h2>
      <p>Hosts often mix ensaymada with <a href="/blogs/best-ube-pandesal-calgary-soft-bakes">ube pandesal</a> and <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes</a> so guests get soft buns and handheld cookies on the same table.</p>
      <h2 class="blog-h2">Order from our regular menu anytime</h2>
      <p>When ensaymada is not on the calendar, ube pandesal, chewy cookies, and crinkles are always available on our <a href="/menu">menu</a>. Message us if you want a notify list for the next ensaymada release.</p>
      <p class="blog-thank-you">Thank you for supporting Filipino-inspired baking at a Calgary home bakery.</p>
    </div>`;
}

function getTeamAppreciationBakedGoodsCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Team appreciation baked goods in Calgary land best on a Thursday or Friday when the week already feels long. The box should be labeled, easy to grab between meetings, and still soft when the last person walks in.</p>
      <h2 class="blog-h2">What Calgary teams order</h2>
      <p><strong>Friday morale:</strong> Mixed cookie half dozens with flavor labels.<br><strong>Project close-out:</strong> Dubai chewy cookies plus ube pandesal for variety.<br><strong>Monthly thank-you:</strong> Standing pickup dates when you know sprint endings.</p>
      <h2 class="blog-h2">First-time ube orders for mixed teams</h2>
      <p>Ask for labels when half the office has not tried Filipino-inspired baking. Pair pandesal with familiar red velvet crinkles so everyone has a safe first pick. Our <a href="/blogs/office-thank-you-treats-calgary">office thank-you guide</a> covers lead times.</p>
      <h2 class="blog-h2">Corporate vs small team sizing</h2>
      <p>Ten people: one mixed box and a dozen pandesal. Twenty-five people: two boxes or a tray plus cookies. Larger client gifts may need our <a href="/blogs/corporate-gift-boxes-calgary-bakery">corporate gift box guide</a>.</p>
      <h2 class="blog-h2">How to book pickup</h2>
      <p>Message us with headcount, meeting time, and neighborhood. Three to five business days is usually enough. We bake after you confirm so nothing sits overnight on a shelf.</p>
      <p class="blog-thank-you">Thank you for choosing a Calgary home bakery for your team.</p>
    </div>`;
}

function getFilipinoBreakfastBreadCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Filipino breakfast bread in Calgary starts with pandesal: soft rolls meant for coffee, jam, or a quick office morning. When you want color and ube flavor, ube pandesal is the tray people ask for by name across YYC.</p>
      <h2 class="blog-h2">Pandesal Calgary: what to expect from a fresh tray</h2>
      <p>Good pandesal pulls apart soft and eats best within a day or two of baking. We make pandesal Calgary customers reorder by baking after you confirm, not thawing wholesale trays. Order a dozen for brunch or two dozen for a Monday stand-up.</p>
      <h2 class="blog-h2">Ube pandesal vs classic pandesal</h2>
      <p>Classic pandesal is lightly sweet and neutral. Ube adds purple yam color and a mild earthy note without tasting like candy. Read <a href="/blogs/best-ube-pandesal-calgary-soft-bakes">what makes great ube pandesal in Calgary</a> if you are comparing options.</p>
      <h2 class="blog-h2">Best mornings to order for</h2>
      <p><strong>Office breakfast:</strong> Pickup timed before 9 a.m. with labels.<br><strong>Weekend family brunch:</strong> Pandesal tray plus <a href="/blogs/milky-dubai-chewy-cookie-calgary">Milky Dubai Chewy Cookies</a> for variety.<br><strong>Community gatherings:</strong> See our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Filipino-inspired pickup guide</a>.</p>
      <h2 class="blog-h2">How far ahead to book</h2>
      <p>Three to five days notice for one or two dozen. A full week for larger trays mixed with cookie boxes. Tell us your pickup neighborhood when you message us.</p>
      <p class="blog-thank-you">Thank you for starting your morning with a Calgary home bakery that bakes to order.</p>
    </div>`;
}

function getSmallCelebrationCookiesCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Small celebration cookies in Calgary fit the moments that do not need a tiered cake: a promotion, a new apartment, a kid's milestone, or a team win that deserves something sweet on the desk by Monday.</p>
      <h2 class="blog-h2">What goes in a small celebration box</h2>
      <p>Half dozen Dubai chewy cookies, red velvet crinkles, or a mix with a few ube pandesal for color. Hosts who want one trending item and one familiar flavor often split the box half and half.</p>
      <h2 class="blog-h2">Sizing for your guest count</h2>
      <p><strong>4–8 people:</strong> One half dozen box.<br><strong>10–15 people:</strong> Half dozen cookies plus a dozen pandesal.<br><strong>Office drop:</strong> Labeled flavors so coworkers grab quickly. Compare with our <a href="/blogs/birthday-cookie-box-calgary">birthday cookie box guide</a> if you need a larger spread.</p>
      <h2 class="blog-h2">Lead times across YYC</h2>
      <p>Three to five days works for most small celebration orders. Summer weekends fill fast. We bake after you confirm pickup anywhere in Calgary.</p>
      <h2 class="blog-h2">How to order</h2>
      <p>Use the order form on our homepage or message us with date, headcount, and favorites. Mention the occasion so we suggest the right mix.</p>
      <p class="blog-thank-you">Thank you for celebrating with Soft Bakes by KC.</p>
    </div>`;
}

function getCalgaryMarketVendorTreatsGuidePostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Calgary market vendor treats are not only about flavor. Customers remember the box they carried home, the apron they photographed, and whether your booth felt planned. At Soft Bakes by KC we treat packaging and team aprons as part of the same prep week as the oven schedule.</p>
      <p>This is the bakery-side timeline we use before community markets and pop-ups. It pairs with how we brand booths in our <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">pop-up branding post</a>, but focuses on the week-of checklist instead of the big-picture story.</p>
      <h2 class="blog-h2">Seven days out: lock the treat menu and box look</h2>
      <p>Decide what sells at a standing table: cookie boxes that stack, pandesal trays that stay warm, and one limited item if you can bake it without slowing the line. Confirm box size, label stickers, and menu card wording so Instagram photos match what people see in person.</p>
      <p>If you sell <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">custom cookie boxes</a> the same weekend, separate those pickups from market inventory so you are not shorting the booth for a bridal shower order.</p>
      <h2 class="blog-h2">Five days out: confirm apron and shirt readiness</h2>
      <p>Team aprons need to be pressed, washed once if fabric allows, and packed before bake day gets loud. We keep black or neutral aprons with a small chest logo because they survive flour, frosting, and long market hours. Shirts are backup for helpers who are not at the table the whole time.</p>
      <p>We order DTF gear through <a href="https://formulatedprints.com" target="_blank" rel="noopener noreferrer">Formulated Prints</a> when we need small runs without screen print minimums. If you are still lining up art and press timing, <a href="https://formulatedapps.com/blogs/booth-branding-dtf-vendors" target="_blank" rel="noopener noreferrer">Formulated Apps has a booth branding timeline for food vendors</a> that matches this week.</p>
      <h2 class="blog-h2">Three days out: bake plan and packaging station</h2>
      <p>Write the bake order by product, not by vibes. Cookies that hold well can go earlier. Soft rolls closer to market morning. Set a packaging station the night before: boxes, tissue, stickers, business cards, and one spare apron. Soft Bakes bakes to order for customer pickups, so market prep still follows that same rule. Nothing ships to the booth until the list is confirmed.</p>
      <h2 class="blog-h2">Market morning: match what customers photograph</h2>
      <p>Put the cleanest boxes at the front edge of the table. Keep the apron logo facing the camera path people use when they walk the aisle. Price signs should be readable from three steps away. If a flavor sells out, remove the empty tray instead of leaving a sad gap. That small cleanup keeps tagged photos looking like a real Calgary bakery, not a rushed garage sale.</p>
      <h2 class="blog-h2">After the market: note what sold and what got tagged</h2>
      <p>Write down sell-outs, leftover counts, and which packaging showed up most in customer stories. That note becomes next market's shopping list. Merch that never appears in photos can wait. Treats that sell out before noon deserve a bigger batch or an earlier bake start.</p>
      <p>Planning event merch and treats together still matters. Read our longer note on <a href="/blogs/event-merch-and-treats-calgary">why we order treats and team merch together</a> if you are building a new booth from scratch.</p>
      <p class="blog-thank-you">Thank you for supporting Soft Bakes by KC at Calgary markets and community nights. Follow @softbakesbykc for the next booth date, and message us if you want a cookie box pickup the same week as a market.</p>
    </div>`;
}

function getWhySoftBakesBakesToOrderCalgaryPostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Soft Bakes by KC is a Calgary home bakery run by KC. We do not keep a retail shelf full of yesterday's rolls. Every ube pandesal tray, Dubai chewy cookie box, and ensaymada limited run starts after you confirm your order and pickup time.</p>
      <p>That is not a marketing line. It is how the kitchen stays small, the texture stays soft, and Filipino-inspired treats still taste like they did when KC served them at home before the business existed.</p>
      <h2 class="blog-h2">How the bakery started</h2>
      <p>KC began with tea parties for family and friends. The feedback was always the same: these treats feel different from grocery boxes. When community events like <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1</a> sold out, it confirmed what regular customers already knew. Calgary wanted a home bakery that bakes after you ask, not before.</p>
      <h2 class="blog-h2">What bake-to-order means for your order</h2>
      <p><strong>You confirm flavors and quantity first.</strong> We reply with availability before anything hits the oven.<br><strong>We suggest pickup windows.</strong> Pandesal and chewy cookies are best fresh, especially in dry Calgary air.<br><strong>We bake in small batches.</strong> Large office trays and custom boxes may need five to seven days notice.<br><strong>We do not thaw wholesale trays.</strong> If you ordered ube pandesal from us before, that difference is why.</p>
      <h2 class="blog-h2">What we bake at Soft Bakes by KC</h2>
      <p>Our <a href="/menu">signature menu</a> centers on Filipino-inspired favorites and crowd pleasers: ube pandesal and Ube Dream Buns, Dubai and Milky Dubai Chewy Cookies, red velvet crinkles, and ensaymada in limited drops. Custom <a href="/blogs/spring-2026-custom-cookie-boxes-calgary">cookie boxes</a> mix those items for showers, offices, and small celebrations across YYC.</p>
      <h2 class="blog-h2">Pickup, delivery, and how far ahead to book</h2>
      <p>Most orders are pickup at a confirmed Calgary time window. Limited delivery may be available depending on date and order size. Three to five days notice works for many mixed boxes. Tell us your neighborhood and event date when you message us so we can answer honestly about timing.</p>
      <p>Read our <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">Filipino-inspired pickup guide</a> if you are ordering for the first time.</p>
      <h2 class="blog-h2">Rewards for repeat customers</h2>
      <p>Soft Bakes Rewards tracks confirmed orders by phone number. After 12 orders you earn a free ube pandesal. Check progress on our <a href="/rewards">rewards page</a>. Repeat customers are why bake-to-order works: your second order should be easier than your first.</p>
      <h2 class="blog-h2">Pop-ups, community nights, and what's next</h2>
      <p>We still show up at Calgary community events with fresh boxes and branded team gear. Planning a booth? Read <a href="/blogs/calgary-pop-up-branding-treats-and-custom-merch">how we brand pop-ups</a>. Follow @softbakesbykc on Instagram for limited runs like ensaymada drops and new menu items.</p>
      <h2 class="blog-h2">How to place your first order</h2>
      <p>Use the order form on our homepage, click Add to Order on the <a href="/menu">menu</a>, or message us with your date, headcount, and favorites. Tell us if it is your first ube order or a gift box for an office. We reply with options before anything is confirmed.</p>
      <p class="blog-thank-you">Thank you for supporting a Calgary home bakery that still bakes like KC's kitchen, one confirmed order at a time.</p>
    </div>`;
}

function getKuhaSocialHouseVol2PostBody() {
  return `
    <div class="blog-prose">
      <p class="blog-lead">Our Dream Cookies are launching at SOHO Volume 2 on <strong>Saturday, October 24, 2026 from 1:30 to 9 PM at Studio 122 in Calgary</strong> (#122, 4029 8 St SE). Come be part of the event: take pictures, shop, listen to music, and try Brown Butter Chocolate Chip, Red Velvet Dream, Ube Dream Cookies, and White Chocolate Matcha. These cookies are the start of something, and they will be part of the Soft Bakes by KC lineup moving forward.</p>
      <h2 class="blog-h2">Quick facts</h2>
      <p><strong>Event:</strong> SOHO by Kuha Volume 2 (Social House)<br><strong>Date:</strong> Saturday, October 24, 2026<br><strong>Time:</strong> 1:30 PM to 9:00 PM<br><strong>Location:</strong> Studio 122, #122, 4029 8 St SE, Calgary, AB T2G 3A5<br><strong>What to do:</strong> take pictures, shop, and listen to music<br><strong>From Soft Bakes by KC:</strong> the launch of four new Dream Cookies, now part of our products<br><strong>Official post:</strong> <a href="https://www.instagram.com/kuhastudios.yyc/p/Decffy3j9HA/" target="_blank" rel="noopener noreferrer">Kuha Studios on Instagram</a></p>
      <h2 class="blog-h2">What is SOHO by Kuha Volume 2?</h2>
      <p>SOHO (Social House) is Kuha Studios' community pop-up series at Studio 122, bringing Calgary creators, local businesses, and the Filipino community into one room. We were part of the first one, and you can read how that night went in our <a href="/blogs/soho-volume-1-community-coffee-bakes">SOHO Volume 1 recap</a>. Volume 2 is the next chapter, and we are so excited to be back.</p>
      <h2 class="blog-h2">Meet the Dream Cookie lineup</h2>
      <p>Four cookies make their debut at SOHO by Kuha Volume 2, each baked fresh with its own little moment.</p>
      <p><strong>Brown Butter Chocolate Chip.</strong> Brown butter, generous chocolate chips, crisp edges and a soft center. No filling.<br><strong>Red Velvet Dream.</strong> Chocolate-chip red velvet with a creamy center and white chocolate drizzle.<br><strong>Ube Dream Cookies.</strong> Our best-selling Ube Dream Bun filling, tucked inside a soft ube cookie with white chocolate.<br><strong>White Chocolate Matcha.</strong> Earthy matcha with creamy white chocolate. Soft-baked, with no filling.</p>
      <h2 class="blog-h2">Why come to the launch</h2>
      <p>Social House is a day to hang out: snap photos with friends, shop from local vendors, and listen to music while you are there. We will be on site at Studio 122 launching the Dream Cookies, so you can taste them first and tell us your favourite. If you are new to Soft Bakes, this is the easiest way to find out why ube and matcha belong in a cookie.</p>
      <h2 class="blog-h2">How to get there</h2>
      <p>Studio 122 is at #122, 4029 8 St SE in Calgary's southeast, T2G 3A5. The event runs all day from 1:30 PM to 9 PM, so you can swing by after lunch or make it an evening plan. <a href="https://www.google.com/maps/search/?api=1&query=4029+8+St+SE+%23122+Calgary+AB+T2G+3A5" target="_blank" rel="noopener noreferrer">Open directions in Google Maps</a>.</p>
      <h2 class="blog-h2">Frequently asked questions</h2>
      <p><strong>When is SOHO by Kuha Volume 2?</strong><br>Saturday, October 24, 2026, from 1:30 PM to 9 PM.</p>
      <p><strong>Where is it?</strong><br>Studio 122, #122, 4029 8 St SE, Calgary, AB T2G 3A5.</p>
      <p><strong>Who is hosting?</strong><br>Kuha Studios (@kuhastudios.yyc) organizes Social House.</p>
      <p><strong>What is Soft Bakes by KC launching?</strong><br>Brown Butter Chocolate Chip, Red Velvet Dream, Ube Dream Cookies, and White Chocolate Matcha.</p>
      <p><strong>What can I do at the event?</strong><br>Take pictures, shop, listen to music, and try our new cookies.</p>
      <p><strong>Will the Dream Cookies be available after the event?</strong><br>Yes. The Dream Cookies are joining the Soft Bakes by KC lineup as regular products. Follow <a href="https://instagram.com/softbakesbykc" target="_blank" rel="noopener noreferrer">@softbakesbykc on Instagram</a> for when they open for orders. Our other treats, like the Ube Dream Cookie box and the new Milky Cheese Bread, are on the <a href="/menu">menu</a> now.</p>
      <h2 class="blog-h2">Can't make it?</h2>
      <p>You can still order Soft Bakes treats baked to order for Calgary pickup. Browse the <a href="/menu">menu</a>, read <a href="/blogs/why-soft-bakes-bakes-to-order-calgary">why we bake to order</a>, or check your progress on <a href="/rewards">Soft Bakes Rewards</a>.</p>
      <p class="blog-thank-you">Thank you to Kuha Studios for hosting us again, and to everyone in Calgary who keeps showing up for local. See you at Studio 122.</p>
    </div>`;
}

function getRewardsMainHTML() {
  return `
  <main class="rewards-page">
    <section class="section rewards-hero">
      <div class="container rewards-container">
        <div class="rewards-copy">
          <span class="story-label">Soft Bakes Rewards</span>
          <h1 class="hero-title">Track your way to a ${LOYALTY_REWARD_LABEL}.</h1>
          <p class="hero-subtitle">Enter the phone number you use when ordering and we'll show your current loyalty progress.</p>
          <p class="rewards-privacy-note">For privacy, this lookup only shows your first name, reward progress, and available rewards. We do not show full order details from a phone number alone.</p>
          <div class="rewards-rules">
            <h2>How Soft Bakes Rewards works</h2>
            <p>Soft Bakes Rewards is our Calgary bakery loyalty program for repeat customers. Every confirmed order placed with the same phone number counts toward your next free treat.</p>
            <ul>
              <li><strong>Earn threshold:</strong> 12 confirmed orders unlock one free ube pandesal reward.</li>
              <li><strong>How to earn:</strong> Use the same phone number when you order through our site, text, or email so we can track your progress.</li>
              <li><strong>Redeeming:</strong> When you hit 12 orders, your free ube pandesal appears as an available reward on this page. Mention it on your next pickup order.</li>
              <li><strong>New customers:</strong> Your first order starts your count. Browse our <a href="/menu">signature treats</a> or read <a href="/blogs/filipino-inspired-treats-calgary-pickup-guide">what to order first</a>.</li>
            </ul>
            <p>Questions about loyalty rewards bakery Calgary pickup? Message us at +1 (403) 604-7532 or order through the homepage and ask us to link your phone number.</p>
          </div>
        </div>
        <div class="rewards-card">
          <h2>Check Your Rewards</h2>
          <form id="rewardsLookupForm" class="rewards-form">
            <label for="rewardsPhone">Phone number</label>
            <input type="tel" id="rewardsPhone" class="form-control" placeholder="403-604-7532" autocomplete="tel" required>
            <button type="submit" class="btn-primary w-full">View My Progress</button>
          </form>
          <div id="rewardsLookupResult" class="rewards-result" aria-live="polite"></div>
        </div>
      </div>
    </section>
  </main>`;
}

function getAdminNavHTML(active) {
  return `
    <nav class="admin-portal-nav" aria-label="Admin portal">
      <a href="/admin/orders" class="${active === 'orders' ? 'active' : ''}">Orders</a>
      <a href="/admin/history" class="${active === 'history' ? 'active' : ''}">History</a>
      <a href="/admin/drafts" class="${active === 'drafts' ? 'active' : ''}">Drafts</a>
      <a href="/admin/loyalty" class="${active === 'loyalty' ? 'active' : ''}">Loyalty tools</a>
      <button type="button" class="admin-logout-button" data-admin-logout>Log out</button>
    </nav>`;
}

function getAdminLoginMainHTML() {
  return `
  <main class="admin-login-page">
    <section class="admin-login-panel">
      <img src="/logo.png" alt="Soft Bakes by KC" class="admin-login-logo">
      <span class="story-label">Private owner portal</span>
      <h1>Admin Login</h1>
      <p>Secure access to paid orders, preparation, pickup, courier, and loyalty tools.</p>
      <form id="adminLoginForm" class="admin-login-form">
        <label for="adminPassword">Owner password</label>
        <input type="password" id="adminPassword" class="form-control" autocomplete="current-password" required>
        <button type="submit" class="btn-primary w-full">Log in securely</button>
      </form>
      <div id="adminLoginStatus" class="admin-login-status" aria-live="polite"></div>
      <p class="admin-login-help">The owner can also send <code>/orders</code> in the private Telegram bot chat for a 90-second, single-use link.</p>
    </section>
  </main>`;
}

function getAdminOrdersMainHTML() {
  return `
  <main class="admin-page admin-orders-page">
    <section class="section">
      <div class="container admin-container">
        <div class="admin-header">
          <span class="story-label">Private owner portal</span>
          <h1 class="section-title">Order Tracker</h1>
          <p class="admin-intro">Track each confirmed order from payment through preparation, customer contact, pickup, or courier completion.</p>
        </div>
        ${getAdminNavHTML('orders')}
        <div class="admin-order-toolbar">
          <label>Show
            <select id="adminOrderFilter" class="form-control">
              <option value="active">Active orders</option>
              <option value="ready">Ready</option>
              <option value="all">All orders</option>
            </select>
          </label>
          <label>Search
            <input type="search" id="adminOrderSearch" class="form-control" placeholder="Customer or phone">
          </label>
          <button type="button" id="refreshAdminOrders" class="btn-secondary">Refresh</button>
        </div>
        <div id="adminOrdersStatus" class="admin-orders-status" aria-live="polite"></div>
        <div id="adminOrderList" class="admin-order-list"></div>
      </div>
    </section>
  </main>`;
}

function getAdminHistoryMainHTML() {
  return `
  <main class="admin-page admin-history-page">
    <section class="section">
      <div class="container admin-container">
        <div class="admin-header">
          <span class="story-label">Private owner portal</span>
          <h1 class="section-title">Order History</h1>
          <p class="admin-intro">Past paid and fulfilled orders with revenue, item quantities, loyalty points, and customer details.</p>
        </div>
        ${getAdminNavHTML('history')}
        <div class="admin-order-toolbar">
          <label>Show
            <select id="adminHistoryFilter" class="form-control">
              <option value="history">Completed + cancelled</option>
              <option value="completed">Completed only</option>
              <option value="cancelled">Cancelled only</option>
              <option value="all">All orders</option>
            </select>
          </label>
          <label>Search
            <input type="search" id="adminHistorySearch" class="form-control" placeholder="Customer or phone">
          </label>
          <button type="button" id="refreshAdminHistory" class="btn-secondary">Refresh</button>
        </div>
        <div id="adminHistorySummary" class="admin-history-summary" aria-live="polite"></div>
        <div id="adminHistoryStatus" class="admin-orders-status" aria-live="polite"></div>
        <div id="adminHistoryList" class="admin-order-list"></div>
      </div>
    </section>
  </main>`;
}

function getAdminDraftsMainHTML() {
  return `
  <main class="admin-page admin-drafts-page">
    <section class="section">
      <div class="container admin-container">
        <div class="admin-header">
          <span class="story-label">Private owner portal</span>
          <h1 class="section-title">Draft Orders</h1>
          <p class="admin-intro">Create catalog or custom payment links, email them with Resend, and only credit loyalty after Square confirms payment.</p>
        </div>
        ${getAdminNavHTML('drafts')}

        <section class="admin-card admin-draft-composer">
          <div class="admin-draft-composer-header">
            <h2 id="adminDraftComposerTitle">New draft</h2>
            <button type="button" id="adminDraftReset" class="btn-secondary">Clear</button>
          </div>
          <form id="adminDraftForm" class="admin-draft-form">
            <input type="hidden" id="adminDraftId" value="">
            <div class="admin-draft-customer-grid">
              <label>Customer name
                <input type="text" id="adminDraftName" class="form-control" required autocomplete="name">
              </label>
              <label>Phone
                <input type="tel" id="adminDraftPhone" class="form-control" required autocomplete="tel">
              </label>
              <label>Email
                <input type="email" id="adminDraftEmail" class="form-control" required autocomplete="email">
              </label>
            </div>

            <div class="admin-draft-catalog-picker">
              <label for="adminDraftCatalogSelect">Add catalog item</label>
              <div class="admin-draft-inline-controls">
                <select id="adminDraftCatalogSelect" class="form-control"></select>
                <button type="button" id="adminDraftAddCatalog" class="btn-secondary">Add</button>
              </div>
            </div>

            <div class="admin-draft-custom-picker">
              <h3>Custom item</h3>
              <div class="admin-draft-custom-grid">
                <label>Name
                  <input type="text" id="adminDraftCustomName" class="form-control" placeholder="Custom treat tray">
                </label>
                <label>Qty
                  <input type="number" id="adminDraftCustomQty" class="form-control" min="1" max="50" value="1">
                </label>
                <label>Unit price ($)
                  <input type="number" id="adminDraftCustomPrice" class="form-control" min="0.01" step="0.01" placeholder="25.00">
                </label>
                <label>Points / unit
                  <input type="number" id="adminDraftCustomPoints" class="form-control" min="0" max="20" value="1">
                </label>
              </div>
              <button type="button" id="adminDraftAddCustom" class="btn-secondary w-full">Add custom item</button>
            </div>

            <div id="adminDraftLines" class="admin-draft-lines"></div>
            <div class="admin-draft-totals" id="adminDraftTotals">
              <strong>Total $0.00</strong>
              <span>0 point(s)</span>
            </div>
            <div class="admin-draft-actions">
              <button type="submit" class="btn-primary w-full" id="adminDraftSave">Save draft</button>
              <button type="button" class="btn-primary w-full" id="adminDraftCreateLink" disabled>Create link &amp; email</button>
            </div>
          </form>
          <div id="adminDraftFormStatus" class="admin-orders-status" aria-live="polite"></div>
        </section>

        <div class="admin-order-toolbar admin-draft-toolbar">
          <label>Show
            <select id="adminDraftFilter" class="form-control">
              <option value="all">All drafts</option>
              <option value="draft">Draft</option>
              <option value="link_ready">Link ready</option>
              <option value="paid">Paid</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </label>
          <label>Search
            <input type="search" id="adminDraftSearch" class="form-control" placeholder="Customer, phone, or email">
          </label>
          <button type="button" id="refreshAdminDrafts" class="btn-secondary">Refresh</button>
        </div>
        <div id="adminDraftsStatus" class="admin-orders-status" aria-live="polite"></div>
        <div id="adminDraftList" class="admin-draft-list"></div>
      </div>
    </section>
  </main>`;
}

function getAdminLoyaltyMainHTML() {
  return `
  <main class="admin-page">
    <section class="section">
      <div class="container admin-container">
        <div class="admin-header">
          <span class="story-label">Private Loyalty Admin</span>
          <h1 class="section-title">Order Intake & Rewards</h1>
          <p class="admin-intro">Square-paid website carts appear automatically after the signed webhook. Use these tools for manual orders, rewards, and Telegram candidates.</p>
        </div>
        ${getAdminNavHTML('loyalty')}

        <div class="admin-grid">
          <section class="admin-card">
            <h2>Add Confirmed Order</h2>
            <form id="adminOrderForm">
              <div class="form-group">
                <label for="adminOrderName">Customer name</label>
                <input type="text" id="adminOrderName" class="form-control" required>
              </div>
              <div class="form-group">
                <label for="adminOrderPhone">Phone number</label>
                <input type="tel" id="adminOrderPhone" class="form-control" required>
              </div>
              <div class="form-group">
                <label for="adminOrderNote">Order note</label>
                <textarea id="adminOrderNote" class="form-control" rows="3" placeholder="Example: 2 dubai chewy half dozen, 1 ube dream"></textarea>
              </div>
              <button type="submit" class="btn-primary w-full">Add Loyalty Order</button>
            </form>
          </section>

          <section class="admin-card">
            <h2>Redeem Reward</h2>
            <form id="adminRedeemForm">
              <div class="form-group">
                <label for="adminRedeemPhone">Customer phone number</label>
                <input type="tel" id="adminRedeemPhone" class="form-control" required>
              </div>
              <button type="submit" class="btn-primary w-full">Mark Free Pandesal Redeemed</button>
            </form>
          </section>

          <section class="admin-card">
            <h2>Telegram Candidate</h2>
            <form id="telegramCandidateForm">
              <div class="form-group">
                <label for="candidateRef">Candidate reference</label>
                <input type="text" id="candidateRef" class="form-control" placeholder="Telegram message id or screenshot id">
              </div>
              <div class="form-group">
                <label for="candidateName">Extracted name</label>
                <input type="text" id="candidateName" class="form-control">
              </div>
              <div class="form-group">
                <label for="candidatePhone">Extracted phone</label>
                <input type="tel" id="candidatePhone" class="form-control">
              </div>
              <div class="form-group">
                <label for="candidateNote">Extracted order text</label>
                <textarea id="candidateNote" class="form-control" rows="3"></textarea>
              </div>
              <button type="submit" class="btn-secondary w-full">Create Pending Candidate</button>
            </form>
            <div class="admin-candidate-actions">
              <input type="number" id="candidateReviewId" class="form-control" placeholder="Candidate id">
              <button type="button" id="approveCandidate" class="btn-primary">Approve</button>
              <button type="button" id="rejectCandidate" class="btn-secondary">Reject</button>
            </div>
          </section>
        </div>
        <section class="admin-card admin-square-card">
          <div class="admin-square-header">
            <div>
              <span class="story-label">Webhook activity</span>
              <h2>Square Payments</h2>
            </div>
            <button type="button" id="refreshSquareOrders" class="btn-secondary">Refresh</button>
          </div>
          <p>Paid carts are already credited to loyalty. Pending checkouts are shown for visibility and do not count until Square confirms payment.</p>
          <div id="adminSquareOrders" class="admin-square-orders" aria-live="polite">
            <p class="admin-square-empty">Loading Square orders...</p>
          </div>
        </section>
        <div id="adminResult" class="admin-result" aria-live="polite"></div>
      </div>
    </section>
  </main>`;
}

function getMenuCatalogHTML() {
  return `
        <h2 class="section-title">Signature Treats</h2>
        <p class="menu-checkout-note">Add treats to your cart or contact KC directly to place your order. All treats are baked fresh to order in Calgary for pickup.</p>
        <div class="menu-grid">
          ${menuItems.filter(item => item.available !== false).map(item => {
            const boxLines = [];
            if (item.halfDozen) boxLines.push('Half dozen (6 pcs) ' + item.halfDozen);
            if (item.dozen) boxLines.push('Dozen (12 pcs) ' + item.dozen);
            const priceLabel = boxLines.length > 0 ? boxLines.join(' · ') : 'Trio ' + item.price;
            const imageHTML = item.collageImages && item.collageImages.length >= 4
              ? '<div class="ensaymada-carousel">' + item.collageImages.map(function (slide, i) {
                  const s = typeof slide === 'string' ? { src: slide, label: '' } : slide;
                  return '<div class="ensaymada-slide" data-slide-index="' + i + '" style="animation-delay:' + (i * 4) + 's"><img src="' + s.src + '" alt="' + item.name + ' – ' + s.label + '" loading="lazy"><span class="ensaymada-label">' + s.label + '</span></div>';
                }).join('') + '</div>'
              : '<img src="' + item.image + '" alt="' + item.name + '" class="card-image' + (item.imageZoom ? ' card-image-zoom' : '') + '" loading="lazy"' + (item.imagePosition ? ' style="object-position:' + item.imagePosition + '"' : '') + '>';
            const flavorBtns = item.collageImages && item.collageImages.length >= 4
              ? '<div class="ensaymada-flavor-btns">' + item.collageImages.map(function (slide, i) {
                  const s = typeof slide === 'string' ? { label: ['Oreo', 'Pistachio', 'Cheesy', 'Biscoff'][i] || '' } : slide;
                  return '<button type="button" class="ensaymada-flavor-btn" data-ensaymada-index="' + i + '" aria-pressed="false">' + s.label + '</button>';
                }).join('') + '</div>'
              : '';
            const newReleaseBadge = item.availableNow
              ? '<span class="card-new-release-badge">Available now — fresh from our kitchen</span>'
              : (item.isNewRelease ? '<span class="card-new-release-badge">New release — fresh from our kitchen</span>' : '');
            const specialOrderBadge = item.specialOrder
              ? '<span class="card-special-order-badge">' + (item.specialOrderNote || 'Special order only') + '</span>'
              : '';
            return `
              <div class="card product-card group" data-order-id="${item.id}">
                <div class="card-image-wrapper">
                  ${imageHTML}
                  ${SHOW_PUBLIC_MENU_PRICES ? '<div class="card-price-tag card-box-prices">' + priceLabel + '</div>' : ''}
                </div>
                <div class="card-content">
                  ${newReleaseBadge}
                  ${specialOrderBadge}
                  <h3 class="card-title">${item.name}</h3>
                  <p class="card-desc">${item.description}</p>
                  ${flavorBtns}
                  <div class="product-card-actions">
                    <div class="product-cart-row">
                      <div class="product-card-quantity" aria-label="Quantity for ${item.name}">
                        <button type="button" data-card-qty-action="decrease" aria-label="Decrease ${item.name} quantity">−</button>
                        <input
                          type="number"
                          class="product-card-qty-input"
                          value="1"
                          min="1"
                          max="50"
                          inputmode="numeric"
                          aria-label="${item.name} quantity"
                        >
                        <button type="button" data-card-qty-action="increase" aria-label="Increase ${item.name} quantity">+</button>
                      </div>
                      <button type="button" class="btn-secondary add-to-cart-button" data-order-action="add">Add to Cart</button>
                    </div>
                    <button type="button" class="btn-primary w-full buy-now-button contact-owner-buy-btn" data-order-action="buy-now">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                      <span>Contact KC to Order</span>
                    </button>
                  </div>
                </div>
              </div>`;
          }).join('')}
        </div>

        <h2 class="section-title mt-16">By The Box</h2>
        <div class="box-grid">
           ${boxItems.filter(item => item.available !== false).map(item => `
             <div class="box-item group">
               <span class="box-name">${item.name}</span>
               <div class="line"></div>
               ${SHOW_PUBLIC_MENU_PRICES ? '<span class="box-price">' + item.price + '</span>' : ''}
             </div>
           `).join('')}
        </div>`;
}

function getMenuMainHTML() {
  return `
  <main class="menu-page">
    <section class="section menu-section">
      <div class="container">
        <h1 class="section-title">Menu</h1>
        <p class="hero-subtitle">Signature Filipino-inspired treats baked to order in Calgary. Pick your favorites and we will confirm pickup details after you send your order.</p>
        ${getMenuCatalogHTML()}
      </div>
    </section>
  </main>`;
}

function getCheckoutOrderRowsHTML() {
  const items = getCartItems();
  if (!items.length) {
    return '<p class="checkout-cart-empty-note">No treats selected yet.</p>';
  }
  return items.map(function (item) {
    return (
      '<div class="order-row" data-order-id="' + item.id + '">' +
        '<img src="' + (item.image || '') + '" alt="" class="order-row-product-img">' +
        '<span class="order-row-label"><strong>' + escapeHTML(item.name) + '</strong>' + (SHOW_PUBLIC_MENU_PRICES ? '<small>$' + item.price.toFixed(2) + ' each</small>' : '') + '</span>' +
        '<div class="quantity-controls">' +
          '<button type="button" class="btn-qty order-qty-minus" aria-label="Decrease">-</button>' +
          '<input type="number" id="qty-' + item.id + '" class="form-control qty-input order-qty-input" value="' + item.quantity + '" min="0" max="50" inputmode="numeric" aria-label="Quantity for ' + escapeHTML(item.name) + '">' +
          '<button type="button" class="btn-qty order-qty-plus" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>'
    );
  }).join('');
}

function getCheckoutMainHTML() {
  return `
  <main class="checkout-page">
    <section class="section checkout-section">
      <div class="container checkout-container">
        <div class="checkout-topbar">
          <a href="/menu" class="checkout-back-link">← Return to menu</a>
          <div class="checkout-topbar-brand">
            <img src="/logo.png" alt="Soft Bakes by KC" class="checkout-header-img" width="48" height="48">
            <div>
              <span class="story-label">Soft Bakes by KC</span>
              <h1 class="checkout-title">Secure checkout</h1>
            </div>
          </div>
          <p class="checkout-etransfer-hint">Prefer Interac e-transfer? Use Email or Text in step 3.</p>
        </div>
        <div class="checkout-panel" id="secureCheckout">
          <div class="checkout-empty" id="checkoutEmptyState" hidden>
            <img src="/logo.png" alt="" class="checkout-empty-logo" width="88" height="88">
            <p>Your cart is empty. Please add items from the menu before continuing to checkout.</p>
            <a href="/menu" class="btn-primary">Return to menu</a>
          </div>
          <div class="checkout-form checkout-bento" id="checkoutFormBody">
            <article class="checkout-bento-card checkout-bento-order" data-step="1">
              <header class="checkout-bento-head">
                <span class="checkout-step-num" aria-hidden="true">1</span>
                <div>
                  <h2>Order summary</h2>
                  <p>Review quantities before payment</p>
                </div>
              </header>
              <div class="checkout-bento-body">
                <div class="order-rows" id="checkoutOrderRows">
                  ${getCheckoutOrderRowsHTML()}
                </div>
                <a href="/menu" class="checkout-add-more">+ Add more items</a>
              </div>
              <footer class="checkout-bento-foot">
                <p class="order-cart-total">Amount due <strong id="orderCartTotal">$0.00 CAD</strong></p>
              </footer>
            </article>

            <div class="checkout-bento-right">
              <article class="checkout-bento-card" data-step="2">
                <header class="checkout-bento-head">
                  <span class="checkout-step-num" aria-hidden="true">2</span>
                  <div>
                    <h2>Customer information</h2>
                    <p>Required for order confirmation &amp; rewards</p>
                  </div>
                </header>
                <div class="checkout-bento-body">
                  <div class="order-customer-fields checkout-details-fields">
                    <div class="form-group order-name-group">
                      <label for="orderCustomerName">Full name <span class="required-asterisk">*</span></label>
                      <input type="text" id="orderCustomerName" class="form-control" placeholder="Legal / preferred name" autocomplete="name" required aria-required="true">
                      <p id="orderNameError" class="order-name-error" role="alert" style="display: none;">Please enter your name.</p>
                    </div>
                    <div class="form-group order-phone-group">
                      <label for="orderCustomerPhone">Mobile number <span class="required-asterisk">*</span></label>
                      <input type="tel" id="orderCustomerPhone" class="form-control" placeholder="403-555-1234" autocomplete="tel" inputmode="tel" required aria-required="true">
                      <p id="orderPhoneError" class="order-name-error" role="alert" style="display: none;">Please enter a valid mobile number.</p>
                    </div>
                    <div class="form-group order-email-group">
                      <label for="orderCustomerEmail">Email address <span class="optional-label">(optional)</span></label>
                      <input type="email" id="orderCustomerEmail" class="form-control" placeholder="you@example.com" autocomplete="email">
                      <p id="orderEmailError" class="order-name-error" role="alert" style="display: none;">Enter a valid email address or leave it blank.</p>
                    </div>
                  </div>
                  <div class="order-rewards-check">
                    <button type="button" id="checkOrderRewards" class="btn-check-rewards">Look up Soft Bakes Rewards</button>
                    <div id="orderRewardsResult" class="order-rewards-result" aria-live="polite"></div>
                  </div>
                </div>
              </article>

              <article class="checkout-bento-card checkout-bento-pay" data-step="3">
                <header class="checkout-bento-head">
                  <span class="checkout-step-num" aria-hidden="true">3</span>
                  <div>
                    <h2>Place order with owner</h2>
                    <p>Send directly to KC via Text, Email, or Phone · Interac e-transfer</p>
                  </div>
                </header>
                <div class="checkout-bento-body checkout-actions owner-contact-checkout-actions">
                  <div class="order-send-consent">
                    <label class="order-terms-inline" for="orderAgreeTerms">
                      <input type="checkbox" id="orderAgreeTerms" name="orderAgreeTerms" autocomplete="off" checked>
                      <span>I have read and agree to the <button type="button" id="openPoliciesFromOrder" class="order-terms-link">Terms &amp; Policies</button></span>
                    </label>
                    <p class="checkout-policy-highlight">Deposits and payments are non-refundable. Once an order is placed, it cannot be cancelled.</p>
                    <p id="orderTermsError" class="order-terms-inline-error" role="alert" style="display: none;">Please confirm the Terms &amp; Policies before continuing.</p>
                  </div>

                  <div class="owner-contact-banner">
                    <div class="owner-contact-badge-header">
                      <img src="/images/owner-solid.png" alt="KC" class="owner-avatar-sm" width="56" height="56">
                      <div>
                        <strong>KC · Soft Bakes by KC</strong>
                        <span>Owner &amp; Baker · Calgary (McKnight &amp; Carrington pickup)</span>
                      </div>
                    </div>
                    <p class="owner-contact-intro">
                      Square card checkout is temporarily paused. Send your order details directly to KC below to confirm your pickup spot and Interac e-transfer payment.
                    </p>
                    <div class="owner-direct-contact-items">
                      <a href="tel:+14036047532" class="owner-direct-item">
                        <span class="owner-direct-label">Phone &amp; Text</span>
                        <span class="owner-direct-val">+1 (403) 604-7532</span>
                      </a>
                      <a href="mailto:softbakesbykc@gmail.com" class="owner-direct-item">
                        <span class="owner-direct-label">Email</span>
                        <span class="owner-direct-val">softbakesbykc@gmail.com</span>
                      </a>
                      <a href="https://instagram.com/softbakesbykc" target="_blank" rel="noopener noreferrer" class="owner-direct-item">
                        <span class="owner-direct-label">Instagram</span>
                        <span class="owner-direct-val">@softbakesbykc</span>
                      </a>
                      <div class="owner-direct-item">
                        <span class="owner-direct-label">Payment</span>
                        <span class="owner-direct-val">Interac e-transfer</span>
                      </div>
                    </div>
                  </div>

                  <div class="checkout-send-actions">
                    <p class="send-prompt">Tap to send your completed order to KC:</p>
                    <div class="social-sending-buttons">
                      <a href="#" id="sendSms" class="btn-social sms-btn btn-primary" aria-label="Send order via text message">
                        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        <span>Text Order to KC: (403) 604-7532</span>
                      </a>
                      <a href="#" id="sendEmail" class="btn-social email-btn btn-secondary" aria-label="Send order via email">
                        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                        <span>Email Order to KC: softbakesbykc@gmail.com</span>
                      </a>
                      <a href="tel:+14036047532" class="btn-social call-btn btn-secondary" aria-label="Call KC">
                        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                        <span>Call KC: (403) 604-7532</span>
                      </a>
                      <button type="button" id="copyOrderMessage" class="btn-social btn-secondary btn-copy-message" aria-label="Copy order message to clipboard">
                        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                        <span id="copyBtnText">Copy Order Details</span>
                      </button>
                    </div>
                  </div>
                  <div id="messagePreview" style="display:none;" aria-hidden="true"></div>
                  <p class="order-modal-deposit-note checkout-pay-note">Payment is made via Interac e-transfer once KC accepts your order.</p>
                </div>
              </article>
            </div>
          </div>
          <aside class="checkout-brand-strip" aria-label="Soft Bakes by KC">
            <img src="/logo.png" alt="Soft Bakes by KC" class="checkout-brand-logo" width="96" height="96">
            <div class="checkout-brand-copy">
              <p class="checkout-brand-tagline">Soft now. Gone before you know.</p>
              <p class="checkout-brand-meta">Calgary pickup · McKnight &amp; Carrington · Exact spot sent when ready</p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  </main>`;
}

function getAboutStoryHTML({ headingTag = 'h2', includeCtas = false } = {}) {
  const Heading = headingTag === 'h1' ? 'h1' : 'h2';
  return `
    <div class="about-grid">
      <div class="about-image-wrapper">
        <img src="/images/owner-solid.png" alt="Meet the baker, KC of Soft Bakes by KC" class="owner-image-hero" width="450" height="560">
        <div class="owner-badge animated-pulse">Baked with Love</div>
      </div>
      <div class="about-content">
        <span class="story-label">The Soft Bakes Story</span>
        <${Heading} class="section-title about-title">Meet <span class="highlight">KC</span></${Heading}>
        <p class="hero-story-narrative">
          "It all started with a simple love for hosting tea parties. Seeing the joy on my family and friends' faces as they tasted my homemade treats inspired me to share that warmth with the world. Today, every single creation is still baked with that exact same love and care."
        </p>
        <p class="hero-subtitle about-subtitle">Welcome to Soft Bakes by KC, a Calgary home bakery. KC bakery Calgary customers know us for treats baked to order across YYC, from ube pandesal to Dubai chewy cookies.</p>
        ${includeCtas ? `
        <div class="hero-actions">
          <a href="/menu" class="btn-primary">Explore Our Treats</a>
          <a href="#" class="btn-secondary" id="openCustomInquiry">Custom Inquiry</a>
        </div>` : `
        <div class="hero-actions">
          <a href="/about" class="btn-secondary">Read the full story</a>
          <a href="#" class="btn-secondary" id="openCustomInquiry">Custom Inquiry</a>
        </div>`}
      </div>
    </div>`;
}

function getHomePromoStripHTML() {
  return `
    <div class="home-promo-strip">
      <a href="#menu" class="hero-bestseller-float" aria-label="Try our best selling Ube Dream Bun, scroll to menu">
        <span class="hero-bestseller-kicker">Best Seller</span>
        <img src="/images/1.jpg" alt="" class="hero-bestseller-img" width="280" height="120" loading="lazy">
        <strong>Try our best selling ube dream!</strong>
        <span>Dozen (12 pcs)</span>
      </a>
      ${isKuhaPopupActive() ? `<a href="#kuha-popup" class="hero-new-treats-float" aria-label="New Dream Cookies launching at SOHO Volume 2, scroll to details">
        <span class="hero-new-treats-kicker">NEW Dream Cookies</span>
        <span class="hero-new-treats-images" aria-hidden="true">
          <span class="hero-new-treats-photo"><img src="/images/popup/brown-butter-chocolate-chip.jpeg" alt="Brown Butter Chocolate Chip cookie" class="hero-new-treats-img" width="140" height="150" loading="lazy"></span>
          <span class="hero-new-treats-photo"><img src="/images/popup/red-velvet-dream.jpeg" alt="" class="hero-new-treats-img" width="140" height="150" loading="lazy"></span>
        </span>
        <strong>Dream Cookies launching at SOHO Volume 2</strong>
        <span>Classic Chocolate, Red Velvet, Ube &amp; Matcha · Sat Oct 24</span>
      </a>
` : ''}      <a href="#menu" class="hero-new-treats-float" aria-label="New treat — Milky Cheese Bread, box of 12, scroll to menu">
        <span class="hero-new-treats-kicker">NEW Treat</span>
        <span class="hero-new-treats-images hero-new-treats-images--single" aria-hidden="true">
          <span class="hero-new-treats-photo"><img src="/images/milky-cheese-bread.jpeg" alt="" class="hero-new-treats-img hero-new-treats-img--bread" width="280" height="150" loading="lazy"></span>
        </span>
        <strong>Milky Cheese Bread</strong>
        <span>Box of 12 pcs</span>
      </a>
      <a href="/rewards" class="loyalty-promo-float" aria-label="Soft Bakes Rewards — free dozen ube pandesal after 12 orders">
        <span class="loyalty-promo-kicker">Rewards Club</span>
        <strong>Free dozen ube pandesal</strong>
        <span>After 12 confirmed orders</span>
      </a>
    </div>`;
}

function getAboutMainHTML() {
  return `
  <main class="about-page">
    <section class="section about-section about-page-section">
      <div class="container">
        ${getAboutStoryHTML({ headingTag: 'h1', includeCtas: true })}
      </div>
    </section>
  </main>`;
}

function getHeroOrbitHTML() {
  const bubbles = [
    { floatClass: 'float-1', itemId: 'ube-dozen', shortName: 'Ube Dream Bun' },
    { floatClass: 'float-2', itemId: 'dubai-half', shortName: 'Dubai Chewy Cookie' },
    { floatClass: 'float-3', itemId: 'redvelvet-half', shortName: 'Red Velvet Crinkle' },
    { floatClass: 'float-4', itemId: 'milky-dubai-half', shortName: 'Milky Dubai Chewy' },
    { floatClass: 'float-5', itemId: 'ube-dream-cookie-half', shortName: 'Ube Dream Cookie' },
    { floatClass: 'float-6', itemId: 'milky-cheese-bread-half', shortName: 'Milky Cheese Bread' },
    { floatClass: 'float-7', itemId: 'red-velvet-dream-half', shortName: 'Red Velvet Dream' },
  ];
  return `
      <div class="hero-orbit" aria-label="Featured Soft Bakes treats">
        ${bubbles.map(function (bubble) {
          const item = menuItems.find(function (entry) { return entry.id === bubble.itemId; });
          if (!item) return '';
          const tipId = 'hero-bubble-tip-' + bubble.itemId;
          const priceLine = SHOW_PUBLIC_MENU_PRICES && item.dozen
            ? 'Dozen (12 pcs) · ' + item.dozen
            : (SHOW_PUBLIC_MENU_PRICES && item.halfDozen ? 'Half dozen (6 pcs) · ' + item.halfDozen : (SHOW_PUBLIC_MENU_PRICES ? item.price || '' : ''));
          return `
        <div class="hero-bubble-wrap ${bubble.floatClass}${item.isNewRelease ? ' hero-bubble-wrap--new' : ''}" data-bubble-id="${bubble.itemId}">
          <button type="button" class="hero-bubble" aria-expanded="false" aria-controls="${tipId}">
            <span class="hero-bubble-orb">
              <img src="${item.image}" alt="" class="hero-bubble-img${item.imageZoom ? ' hero-bubble-img--zoom' : ''}"${item.imagePosition ? ' style="object-position:' + (item.imageZoom ? 'center 100%' : item.imagePosition) + '"' : ''} width="180" height="180" loading="eager">
            </span>
            ${item.isNewRelease ? '<span class="hero-bubble-new">New release</span>' : ''}
            <span class="hero-bubble-label">${escapeHTML(bubble.shortName)}</span>
          </button>
          <div class="hero-bubble-tip" id="${tipId}" hidden role="dialog" aria-label="${escapeHTML(bubble.shortName)} details">
            <p class="hero-bubble-tip-desc">${escapeHTML(item.description || '')}</p>
            ${priceLine ? '<p class="hero-bubble-tip-price">' + escapeHTML(priceLine) + '</p>' : ''}
            <a href="#menu" class="hero-bubble-tip-link" data-menu-target="${bubble.itemId}">View on menu</a>
          </div>
        </div>`;
        }).join('')}
      </div>`;
}

// Kuha Studios x Soft Bakes pop-up (Social House Vol. 2, Sat Oct 24, 2026). Hidden after midnight MDT that night.
const KUHA_POPUP_END = new Date('2026-10-25T06:00:00Z');
const KUHA_POPUP_POST_URL = 'https://www.instagram.com/kuhastudios.yyc/p/Decffy3j9HA/';
const KUHA_EVENT_BLOG_PATH = '/blogs/kuha-studios-social-house-vol-2-pop-up-calgary';
const KUHA_POPUP_COOKIES = [
  { name: 'Brown Butter Chocolate Chip', img: '/images/popup/brown-butter-chocolate-chip.jpeg', note: 'Brown butter, generous chocolate chips, crisp edges and a soft center. No filling.' },
  { name: 'Red Velvet Dream', img: '/images/popup/red-velvet-dream.jpeg', note: 'Chocolate-chip red velvet, a creamy center, and a white chocolate drizzle. Extra in the best way.' },
  { name: 'Ube Dream Cookies', img: '/images/popup/ube-dream.jpeg', note: 'Our best-selling Ube Dream Bun filling, now tucked into a soft ube cookie with white chocolate. The fan fave, in its cookie era.' },
  { name: 'White Chocolate Matcha', img: '/images/popup/white-chocolate-matcha.jpeg', note: 'Earthy matcha with creamy white chocolate. Soft-baked, with no filling.' }
];

function isKuhaPopupActive() {
  return Date.now() < KUHA_POPUP_END.getTime();
}

function getKuhaPopupHTML() {
  if (!isKuhaPopupActive()) return '';
  return `
    <section id="kuha-popup" class="kuha-popup" aria-labelledby="kuhaPopupTitle">
      <div class="container kuha-popup-inner">
        <div class="kuha-popup-copy">
          <p class="kuha-popup-kicker">Launch day <span aria-hidden="true">✧</span> SOHO Volume 2</p>
          <h2 id="kuhaPopupTitle" class="kuha-popup-title">Our <em>Dream Cookies</em> launch at SOHO Volume 2</h2>
          <p class="kuha-popup-lead">Come be part of the event: take pictures, shop, listen to music, and have a fun time. Be the first to try four new Soft Bakes by KC cookies that are joining our products moving forward.</p>
          <ul class="kuha-popup-details">
            <li><strong>Saturday, Oct. 24</strong><span>1:30 to 9 PM</span></li>
            <li><strong>Studio 122</strong><span>#122, 4029 8 St SE, Calgary</span></li>
          </ul>
          <div class="hero-actions kuha-popup-actions">
            <a href="${KUHA_EVENT_BLOG_PATH}" class="btn-primary">Event details</a>
            <a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('4029 8 St SE #122, Calgary, AB T2G 3A5')}" class="btn-secondary" target="_blank" rel="noopener noreferrer">Get directions</a>
            <a href="${KUHA_POPUP_POST_URL}" class="btn-secondary" target="_blank" rel="noopener noreferrer">View on Instagram</a>
          </div>
        </div>
        <div class="kuha-popup-lineup">
          <div class="kuha-lineup-floating-top">
            <a href="${KUHA_EVENT_BLOG_PATH}" class="kuha-floating-sign kuha-sign--popup" aria-label="Pop-Up Event: Soft Bakes by KC Pop-Up">
              <span class="kuha-sign-icon kuha-sign-icon--popup" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 6.9 7.1.3-5.5 4.6 1.8 7-5.8-4.2-5.8 4.2 1.8-7-5.5-4.6 7.1-.3L12 2z"/></svg>
              </span>
              <span class="kuha-sign-body">
                <span class="kuha-sign-kicker">Special Event</span>
                <span class="kuha-sign-title">Soft Bakes Pop-Up</span>
                <span class="kuha-sign-desc">SOHO Vol. 2 · Studio 122</span>
              </span>
            </a>
          </div>

          <div class="kuha-lineup-media">
            <img src="/images/popup/dream-cookie-lineup.jpeg" alt="Stack of four Dream Cookies: Brown Butter Chocolate Chip, Red Velvet Dream, Ube Dream, and White Chocolate Matcha" width="916" height="1145" loading="lazy">
          </div>

          <div class="kuha-lineup-floating-bottom">
            <a href="${KUHA_EVENT_BLOG_PATH}" class="kuha-floating-sign kuha-sign--date" aria-label="Event Dates: Saturday Oct 24, 1:30 to 9 PM">
              <span class="kuha-sign-icon kuha-sign-icon--date" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
              </span>
              <span class="kuha-sign-body">
                <span class="kuha-sign-kicker">Mark the Date</span>
                <span class="kuha-sign-title">Saturday, Oct. 24</span>
                <span class="kuha-sign-desc">1:30 PM – 9:00 PM</span>
              </span>
            </a>

            <a href="${KUHA_EVENT_BLOG_PATH}" class="kuha-floating-sign kuha-sign--goodtime" aria-label="Invitation: Join us for a good time!">
              <span class="kuha-sign-icon kuha-sign-icon--goodtime" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M20 12h2"/><path d="M2 12h2"/></svg>
              </span>
              <span class="kuha-sign-body">
                <span class="kuha-sign-kicker">You're Invited ✨</span>
                <span class="kuha-sign-title">Join Us for a Good Time!</span>
                <span class="kuha-sign-desc">Treats · Music · SOHO Vibes</span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="container kuha-popup-grid">
        ${KUHA_POPUP_COOKIES.map((c) => `
        <figure class="kuha-cookie">
          <img src="${c.img}" alt="${escapeHTML(c.name)} cookie by Soft Bakes by KC" width="540" height="675" loading="lazy">
          <figcaption><strong>${escapeHTML(c.name)}</strong><span>${escapeHTML(c.note)}</span></figcaption>
        </figure>`).join('')}
      </div>
    </section>`;
}

function getHomeMainHTML() {
  return `
  <main>
    ${getKuhaPopupHTML()}
    <section class="hero hero-brand">
      <div class="hero-motion" aria-hidden="true">
        <video class="hero-motion-video" muted loop playsinline preload="none" disablepictureinpicture></video>
      </div>
      ${getHeroOrbitHTML()}
      <div class="hero-brand-glow" aria-hidden="true"></div>
      <div class="container hero-brand-inner">
        <img src="/logo.png" alt="Soft Bakes by KC" class="hero-logo" width="220" height="220">
        <p class="hero-brand-eyebrow">Baked with love <span aria-hidden="true">✧</span> Calgary</p>
        <h1 class="hero-brand-title">Soft Bakes by KC</h1>
        <p class="hero-brand-tagline">Filipino-inspired treats baked to order in Calgary.</p>
        <div class="hero-actions">
          <a href="#menu" class="btn-primary">Explore Our Treats</a>
          <a href="#about" class="btn-secondary">Meet KC</a>
        </div>
        <div class="hero-social" aria-label="Follow Soft Bakes by KC">
          <a class="hero-social-link" href="${INSTAGRAM_URL}" target="_blank" rel="noopener noreferrer">
            ${ICON_INSTAGRAM}
            <span>${INSTAGRAM_HANDLE}</span>
          </a>
          <span class="hero-social-sep" aria-hidden="true"></span>
          <a class="hero-social-link" href="${FACEBOOK_URL}" target="_blank" rel="noopener noreferrer">
            ${ICON_FACEBOOK}
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </section>

    <a href="/rewards" class="rewards-brand-strip" aria-label="Soft Bakes Rewards — order 12 times, earn a free dozen ube pandesal">
      <span class="rewards-brand-strip-inner">
        <span class="rewards-brand-strip-kicker">Soft Bakes Rewards</span>
        <span class="rewards-brand-strip-copy">Free dozen ube pandesal after 12 confirmed orders</span>
        <span class="rewards-brand-strip-cta">View rewards <span aria-hidden="true">→</span></span>
      </span>
    </a>

    <section id="social" class="section social-section">
      <div class="container">
        <div class="social-section-head">
          <p class="social-kicker">${INSTAGRAM_HANDLE}</p>
          <h2 class="section-title">Fresh from the bake feed</h2>
          <p class="social-section-sub">Drop by for drops, pop-ups, and soft sneak peeks.</p>
        </div>
        <div class="social-embeds social-embeds--instagram-only">
          <div class="instagram-panel">
            <div id="instagramFeed" class="instagram-grid" aria-live="polite">
              <div class="instagram-skeleton" aria-hidden="true"></div>
              <div class="instagram-skeleton" aria-hidden="true"></div>
              <div class="instagram-skeleton" aria-hidden="true"></div>
              <div class="instagram-skeleton" aria-hidden="true"></div>
              <div class="instagram-skeleton" aria-hidden="true"></div>
              <div class="instagram-skeleton" aria-hidden="true"></div>
            </div>
            <a class="social-follow-link" href="${INSTAGRAM_URL}" target="_blank" rel="noopener noreferrer">
              ${ICON_INSTAGRAM}
              <span>Follow on Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section id="about" class="section about-section">
      <div class="container">
        ${getAboutStoryHTML({ headingTag: 'h2', includeCtas: false })}
        ${getHomePromoStripHTML()}
      </div>
    </section>
    
    <section id="menu" class="section menu-section">
      <div class="container">
        ${getMenuCatalogHTML()}
      </div>
    </section>

    <!-- FAQ Section -->
    <section id="faq" class="section faq-section">
      <div class="container">
        <h2 class="section-title">Frequently Asked Questions</h2>
        <div class="faq-accordion">
          <div class="faq-item">
            <button class="faq-question">How do I place an order?</button>
            <div class="faq-answer">
              <p>Choose a quantity, then <strong>Add to Cart</strong> or click <strong>Contact KC to Order</strong>. You can send your order directly to KC by <strong>Text (+1 403-604-7532)</strong> or <strong>Email (softbakesbykc@gmail.com)</strong> and we will confirm your pickup details.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">How do I pay?</button>
            <div class="faq-answer">
              <p>We accept Interac e-transfer. Send your order directly to KC by text or email, and we’ll confirm your bake date and e-transfer payment details when accepted.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">Are deposits refundable? Can I cancel?</button>
            <div class="faq-answer">
              <p>No. Soft Bakes bakes to order, so <strong>deposits and payments are non-refundable</strong>. Once an order is placed or confirmed, it <strong>cannot be cancelled</strong> (there is no cancellation fee or cancel-for-refund option). Please read our Terms &amp; Policies before paying.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">Where do I pick up?</button>
            <div class="faq-answer">
              <p>Orders are pickup in Calgary. Exact pickup location is sent when your order is ready. Pickup areas: McKnight and Carrington.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">Do you have a loyalty rewards program?</button>
            <div class="faq-answer">
              <p>Yes. Soft Bakes Rewards tracks orders with the phone number you use at checkout. After 12 confirmed orders you earn a free ube pandesal. Check progress anytime on our <a href="/rewards">rewards page</a>.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">How much notice is required for an order?</button>
            <div class="faq-answer">
              <p>We bake fresh to order, so please give at least 48 hours notice. Larger custom or event orders usually need 1–2 weeks.</p>
            </div>
          </div>
          <div class="faq-item">
            <button class="faq-question">Are your products allergy-friendly?</button>
            <div class="faq-answer">
              <p>Our kitchen also handles nuts, dairy, wheat, and soy. Please tell us about any severe allergies before ordering.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <section id="testimonials" class="section testimonials-section">
      <div class="container">
        <h2 class="section-title">What Our Customers Say</h2>
        <div class="testimonials-grid">
          ${testimonials.map(t => `
            <div class="testimonial-card">
              <div class="testimonial-stars">${'★'.repeat(t.stars)}</div>
              <p class="testimonial-text">"${t.text}"</p>
              <p class="testimonial-name">- ${t.name}</p>
            </div>
          `).join('')}
        </div>
      </div>
    </section>

    <!-- How It Works Section -->
    <section id="how-it-works" class="section how-it-works-section">
      <div class="container">
        <h2 class="section-title">How It Works</h2>
        <div class="steps-grid">
          <div class="step-card">
            <div class="step-number">1</div>
            <h3>Pick Your Favorites</h3>
            <p>Choose your quantities, then build a mixed cart or use Express Order for one treat.</p>
          </div>
          <div class="step-card">
            <div class="step-number">2</div>
            <h3>Connect with KC</h3>
            <p>Send your order by text or email to confirm your bake date and Interac e-transfer payment.</p>
          </div>
          <div class="step-card">
            <div class="step-number">3</div>
            <h3>Freshly Baked Pickup</h3>
            <p>We bake to order, then send your pickup spot when it’s ready — McKnight or Carrington area.</p>
          </div>
        </div>
      </div>
    </section>
  </main>`;
}

function getFooterHTML() {
  return `
  <footer id="contact" class="footer">
    <div class="container footer-container">
      <div class="footer-logo-wrapper">
         <img src="/logo.png" alt="Soft Bakes by KC Logo" class="brand-logo-footer" />
      </div>
      <div class="footer-contact">
        <div class="contact-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          <a href="tel:+14036047532">+1 (403) 604-7532</a>
        </div>
        <div class="contact-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
          <a href="https://instagram.com/softbakesbykc" target="_blank">@softbakesbykc</a>
        </div>
        <div class="contact-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
          <a href="https://www.facebook.com/people/Soft-Bakes-by-KC/61578518656069/" target="_blank">Soft Bakes by KC</a>
        </div>
      </div>

      <div class="footer-newsletter">
        <h4>Join the VIP List</h4>
        <p>Get early access to holiday drops & special boxes!</p>
        <form class="newsletter-form" id="newsletterForm">
          <input type="email" placeholder="Your Email" class="form-control" required>
          <button type="submit" class="btn-primary">Join</button>
        </form>
        <div id="newsletterSuccess" class="newsletter-success" style="display: none; color: var(--accent-primary); margin-top: 1rem;">Welcome to the VIP list!</div>
      </div>

      <div class="footer-links" style="margin-top: 2rem; opacity: 0.8;">
        <a href="/rewards" style="color: var(--text-light); text-decoration: underline; font-size: 0.9rem; margin-right: 1rem;">Rewards</a>
        <a href="/blogs" style="color: var(--text-light); text-decoration: underline; font-size: 0.9rem; margin-right: 1rem;">Blog</a>
        <a href="#" id="openPolicies" style="color: var(--text-light); text-decoration: underline; font-size: 0.9rem;">Terms & Policies</a>
      </div>
      <p class="copyright mt-4">&copy; ${new Date().getFullYear()} Soft Bakes by KC. All rights reserved.</p>
    </div>
  </footer>`;
}

function getLayoutHTML(mainContent, isBlogsActive, isRewardsActive, isMenuActive = false, isAboutActive = false) {
  return `
  <div class="announcement-bar" id="announcementBar">
    <div class="container announcement-container">
      ${isKuhaPopupActive()
        ? `<p><a class="announcement-link" href="${KUHA_EVENT_BLOG_PATH}">🍪 New Dream Cookies launch at SOHO Volume 2 · Sat Oct 24 · 1:30–9 PM · Studio 122 →</a></p>`
        : `<p>❤️ We're always taking orders! 🍞 Baking times vary. We'll let you know when your order will be made. 🍪 ❤️</p>`}
      <button class="announcement-close" id="closeAnnouncement">&times;</button>
    </div>
  </div>
  ${getHeaderHTML(isBlogsActive, isRewardsActive, isMenuActive, isAboutActive)}
  ${mainContent}
  ${getFooterHTML()}
  ${getCartDrawerHTML()}
  ${getModalsHTML()}
`;
}

function getCartDrawerHTML() {
  return `
  <div id="cartDrawerOverlay" class="cart-drawer-overlay" aria-hidden="true">
    <aside id="cartDrawer" class="cart-drawer" aria-label="Shopping cart">
      <div class="cart-drawer-header">
        <div>
          <span class="story-label">Your order</span>
          <h2>Soft Bakes Cart</h2>
        </div>
        <button type="button" id="closeCartDrawer" class="cart-drawer-close" aria-label="Close shopping cart">&times;</button>
      </div>
      <p id="cartDrawerEmpty" class="cart-drawer-empty">Your cart is empty. Add a treat from the menu to get started.</p>
      <div id="cartDrawerItems" class="cart-drawer-items"></div>
      <div class="cart-drawer-footer">
        <div class="cart-drawer-subtotal"><span>Subtotal</span><strong id="cartDrawerSubtotal">$0.00 CAD</strong></div>
        <p>Send your order directly to KC via Text or Email to confirm pickup and payment.</p>
        <button type="button" id="cartDrawerCheckout" class="btn-primary w-full">Review &amp; Contact Owner to Order</button>
        <button type="button" id="cartDrawerClear" class="cart-clear-button" hidden>Clear cart</button>
      </div>
    </aside>
  </div>
  <button type="button" id="stickyCartBar" class="sticky-cart-bar" hidden aria-label="Cart is empty">
    <span class="sticky-cart-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 8V5a3 3 0 0 1 6 0v3"/></svg>
    </span>
    <span class="sticky-cart-copy">
      <strong id="stickyCartCount">0 items</strong>
      <span id="stickyCartSubtotal">$0.00 CAD</span>
    </span>
    <span class="sticky-cart-action">View cart <span aria-hidden="true">→</span></span>
  </button>
  <div id="cartToast" class="cart-toast" role="status" aria-live="polite"></div>`;
}

function getModalsHTML() {
  return `
  <!-- Single-product Express Order Modal -->
  <div id="expressOrderModal" class="modal-overlay" aria-hidden="true">
    <div class="modal-content express-order-modal-content" role="dialog" aria-modal="true" aria-labelledby="expressOrderTitle">
      <button type="button" class="modal-close" id="closeExpressOrderModal" aria-label="Close express order">&times;</button>
      <div class="modal-header-with-image">
        <img src="/logo.png" alt="Soft Bakes by KC" class="modal-header-img" width="64" height="64">
        <div class="modal-header-text">
          <h3 class="modal-title" id="expressOrderTitle">Order with KC</h3>
          <p class="modal-desc">Send your order directly to KC via Text, Email, or Phone.</p>
        </div>
      </div>
      <div class="express-order-summary">
        <img id="expressOrderImage" src="/logo.png" alt="" width="72" height="72">
        <div class="express-order-summary-copy">
          <strong id="expressOrderProduct">Selected treat</strong>
          <span><span id="expressOrderQuantity">1</span> × <span id="expressOrderUnitPrice">$0.00</span></span>
        </div>
        <strong id="expressOrderTotal">$0.00 CAD</strong>
      </div>
      <div class="order-customer-fields express-customer-fields">
        <div class="form-group">
          <label for="expressCustomerName">Your name <span class="optional-label">(optional)</span></label>
          <input type="text" id="expressCustomerName" class="form-control" placeholder="Enter your name" autocomplete="name">
        </div>
        <div class="form-group">
          <label for="expressCustomerPhone">Mobile number <span class="optional-label">(optional)</span></label>
          <input type="tel" id="expressCustomerPhone" class="form-control" placeholder="403-555-1234" autocomplete="tel" inputmode="tel">
        </div>
      </div>

      <div class="express-owner-contact-box">
        <div class="owner-contact-badge-header">
          <img src="/images/owner-solid.png" alt="KC" class="owner-avatar-sm" width="48" height="48">
          <div>
            <strong>KC · Soft Bakes by KC</strong>
            <span>Direct Orders · Calgary (McKnight &amp; Carrington pickup)</span>
          </div>
        </div>
        <div class="owner-direct-contact-items">
          <a href="tel:+14036047532" class="owner-direct-item">
            <span class="owner-direct-label">Phone &amp; Text</span>
            <span class="owner-direct-val">+1 (403) 604-7532</span>
          </a>
          <a href="mailto:softbakesbykc@gmail.com" class="owner-direct-item">
            <span class="owner-direct-label">Email</span>
            <span class="owner-direct-val">softbakesbykc@gmail.com</span>
          </a>
        </div>
      </div>

      <div class="express-contact-actions">
        <a href="#" id="expressSendSms" class="btn-primary w-full express-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <span>Text KC to Order: (403) 604-7532</span>
        </a>
        <a href="#" id="expressSendEmail" class="btn-secondary w-full express-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          <span>Email KC to Order: softbakesbykc@gmail.com</span>
        </a>
        <a href="tel:+14036047532" class="btn-secondary w-full express-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          <span>Call KC: (403) 604-7532</span>
        </a>
        <button type="button" id="expressCopyOrder" class="btn-secondary w-full express-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
          <span id="expressCopyText">Copy Order Details</span>
        </button>
      </div>
      <p class="order-modal-deposit-note mt-4" style="text-align: center; font-size: 0.8rem; color: var(--text-light);">
        Square card payments are temporarily paused. Orders and Interac e-transfer details are confirmed directly with KC.
      </p>
    </div>
  </div>

  <!-- Policies Modal -->
  <div id="policiesModal" class="modal-overlay policies-modal-overlay">
    <div class="modal-content policies-modal-content">
      <div class="policies-modal-topbar">
        <h3 class="modal-title policies-modal-title">Terms &amp; Policies</h3>
        <button type="button" class="btn-policies-exit" id="closePoliciesModal" aria-label="Close terms and return to order">Close</button>
      </div>
      <div class="policy-section policies-modal-body mt-4">
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">About our business</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">Soft Bakes by KC is a small, home-based food business located in Calgary, Alberta. Products are prepared in a private home kitchen. By requesting or placing an order, you acknowledge this and accept the terms below.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Orders &amp; your agreement</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">When you send us an order request (by message, email, or other channel we provide), you are making an offer to purchase. We will confirm availability, price, and pickup or delivery details. An order is not confirmed until we accept it and any required deposit is received as we specify. If you use our website to send an order, you tick a box to agree to these Terms &amp; Policies before the send buttons work; that counts as your acceptance on the site (your message to us does not need to repeat this).</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Deposits &amp; payment</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">A deposit (typically 50% of the order total, as stated at checkout or in our messages) is required to confirm your order unless we agree otherwise in writing. Deposits are applied to your order total. <strong>All deposits are non-refundable.</strong> Payment methods and timing will be confirmed when we accept your order. Paying in full through Square (or another method we confirm) also counts as placing your order under these terms.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Allergen disclaimer</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">Our treats are prepared in a home kitchen that is not subject to inspection. Our kitchen uses and may process peanuts, tree nuts, wheat, dairy, eggs, soy, and other allergens. While we try to avoid cross-contact, we cannot guarantee that any product is free of allergens. If you have allergies or dietary restrictions, contact us before ordering; you assume responsibility for any reaction if you choose to consume our products after we have disclosed these risks.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Refund &amp; cancellation</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">Everything we offer is baked fresh and made to order. Ingredients and baking time are planned around each booking. <strong>Once an order is placed or confirmed, it cannot be cancelled.</strong> There is no cancellation fee and no cancel-for-refund option. <strong>All payments, including deposits and any balance paid, are non-refundable.</strong> If something about your finished order is wrong, contact us as soon as you can and we will try to help where we can. Nothing here limits rights you may have under Alberta’s consumer protection laws where they apply.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Limitation of liability</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">To the fullest extent permitted by applicable law in Alberta, Soft Bakes by KC is not liable for indirect or consequential damages arising from your purchase or use of our products. Our total liability for any claim related to an order is limited to the amount you paid us for that order. Some jurisdictions do not allow certain limitations; in those cases, our liability is limited to the minimum extent allowed by law.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Privacy</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">We collect only the information we need to communicate about and fulfill your order (for example, name, phone, email). We do not sell your personal information. We may use services (e.g. messaging or payment) that process data under their own policies.</p>
        <h4 style="font-weight: 600; margin-bottom: 0.5rem; color: var(--accent-primary);">Changes</h4>
        <p style="font-size: 0.9rem; color: var(--text-light); margin-bottom: 1.5rem;">We may update these terms from time to time. The version on our website when you place your order request applies to that request. If you have questions, contact us before ordering.</p>
        <p style="font-size: 0.8rem; color: var(--text-light); font-style: italic; margin-bottom: 0;">This page is for your information. It is not legal advice. For advice specific to your situation, speak with a qualified professional in Alberta.</p>
      </div>
    </div>
  </div>
  <!-- Custom Inquiry Modal -->
  <div id="inquiryModal" class="modal-overlay">
    <div class="modal-content">
      <button class="modal-close" id="closeInquiryModal">&times;</button>
      <h3 class="modal-title">Custom Inquiry</h3>
      <p class="modal-desc">Planning an event or need a special treat? Tell us what you're looking for!</p>
      <form id="customInquiryForm">
        <div class="form-group">
          <label for="inquiryDate">Event Date</label>
          <input type="date" id="inquiryDate" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="inquiryDetails">Treat Details & Theme</label>
          <textarea id="inquiryDetails" class="form-control" rows="3" placeholder="Tell us about the occasion, flavors, or any ideas you have!"></textarea>
        </div>
        <div class="form-group">
          <label for="inquiryQuantity">Approximate Quantity</label>
          <input type="text" id="inquiryQuantity" class="form-control" placeholder="e.g., 2 dozen cookies">
        </div>
        <div class="modal-actions">
          <p class="send-prompt">Send inquiry via:</p>
          <div class="social-sending-buttons">
            <a href="#" id="inquiryEmail" class="btn-social email-btn">Email Inquiry</a>
            <a href="#" id="inquirySms" class="btn-social sms-btn">SMS Inquiry</a>
          </div>
        </div>
      </form>
    </div>
  </div>`;
}

function resetBodyModalScrollLock() {
  const y = document.body.dataset.modalScrollY;
  document.body.classList.remove('modal-open');
  document.body.style.top = '';
  delete document.body.dataset.modalScrollY;
  if (y !== undefined && y !== '') {
    window.scrollTo(0, parseInt(y, 10) || 0);
  }
}

function render() {
  resetBodyModalScrollLock();
  const pathname = window.location.pathname.replace(/\/$/, '') || '/';
  const isBlogs = pathname === '/blogs' || pathname.startsWith('/blogs/');
  const isRewards = pathname === '/rewards';
  const isMenu = pathname === '/menu';
  const isAbout = pathname === '/about';
  const isCheckout = pathname === '/checkout';
  const isAdminLogin = pathname === '/admin/login';
  const isAdminOrders = pathname === '/admin/orders';
  const isAdminHistory = pathname === '/admin/history';
  const isAdminDrafts = pathname === '/admin/drafts';
  const isAdminLoyalty = pathname === '/admin/loyalty';
  const isAdmin = isAdminLogin || isAdminOrders || isAdminHistory || isAdminDrafts || isAdminLoyalty;
  if ((isAdminOrders || isAdminHistory || isAdminDrafts || isAdminLoyalty) && !getCookieValue('softbakes_admin_csrf')) {
    history.replaceState(null, '', '/admin/login');
    render();
    return;
  }
  const mainContent = isBlogs
    ? getBlogsMainHTML(pathname)
    : isMenu
      ? getMenuMainHTML()
    : isAbout
      ? getAboutMainHTML()
    : isCheckout
      ? getCheckoutMainHTML()
    : isRewards
      ? getRewardsMainHTML()
      : isAdminLogin
        ? getAdminLoginMainHTML()
      : isAdminOrders
        ? getAdminOrdersMainHTML()
      : isAdminHistory
        ? getAdminHistoryMainHTML()
      : isAdminDrafts
        ? getAdminDraftsMainHTML()
      : isAdminLoyalty
        ? getAdminLoyaltyMainHTML()
        : getHomeMainHTML();
  document.querySelector('#app').innerHTML = isAdmin
    ? `<div class="admin-app-shell">${mainContent}</div>`
    : getLayoutHTML(mainContent, isBlogs, isRewards, isMenu, isAbout);
  if (isBlogs) {
    const slug = pathname.replace(/^\/blogs\/?/, '');
    const post = slug ? getPostBySlug(slug) : null;
    document.title = post ? post.title + ' | Soft Bakes by KC' : (slug ? 'Page Not Found | Soft Bakes by KC' : 'Blog | Soft Bakes by KC');
    updateBlogSEO(post, pathname);
    if (slug && !post) {
      setMeta('robots', 'noindex, nofollow');
    }
    injectLocalBusinessSchema();
    initBlogCarousel();
  } else if (isRewards) {
    document.title = 'Rewards | Soft Bakes by KC';
    setCanonical(window.location.origin + '/rewards');
    setMeta('description', 'Check your Soft Bakes by KC loyalty rewards progress by phone number.');
    setMeta('og:title', 'Rewards | Soft Bakes by KC', true);
    setMeta('og:description', 'Track your way to a free ube pandesal with Soft Bakes rewards.', true);
    setMeta('og:url', window.location.origin + '/rewards', true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', window.location.origin + '/images/og-share.png', true);
    setMeta('twitter:title', 'Rewards | Soft Bakes by KC');
    setMeta('twitter:description', 'Track your way to a free ube pandesal with Soft Bakes rewards.');
    setMeta('twitter:image', window.location.origin + '/images/og-share.png');
    injectLocalBusinessSchema();
  } else if (isMenu) {
    document.title = 'Menu | Soft Bakes by KC';
    setCanonical(window.location.origin + '/menu');
    setMeta('description', 'Signature treats in Calgary: Ube Dream Cookies, Milky Cheese Bread, Dubai Chewy Cookies, ube pandesal, and more. Baked to order for pickup.');
    setMeta('og:title', 'Menu | Soft Bakes by KC', true);
    setMeta('og:description', 'Filipino-inspired treats baked to order in Calgary. Order half dozen boxes and pickup-friendly trays.', true);
    setMeta('og:url', window.location.origin + '/menu', true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', window.location.origin + '/images/milky-dubai-chewy.png', true);
    setMeta('twitter:title', 'Menu | Soft Bakes by KC');
    setMeta('twitter:description', 'Filipino-inspired treats baked to order in Calgary.');
    setMeta('twitter:image', window.location.origin + '/images/milky-dubai-chewy.png');
    injectLocalBusinessSchema();
  } else if (isAbout) {
    document.title = 'About KC | Soft Bakes by KC';
    setCanonical(window.location.origin + '/about');
    setMeta('description', 'Meet KC, the baker behind Soft Bakes by KC in Calgary. A home bakery story of tea parties, Filipino-inspired treats, and baked-to-order care.');
    setMeta('og:title', 'About KC | Soft Bakes by KC', true);
    setMeta('og:description', 'Meet KC, the baker behind Soft Bakes by KC in Calgary.', true);
    setMeta('og:url', window.location.origin + '/about', true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', window.location.origin + '/images/owner-solid.png', true);
    setMeta('twitter:title', 'About KC | Soft Bakes by KC');
    setMeta('twitter:description', 'Meet KC, the baker behind Soft Bakes by KC in Calgary.');
    setMeta('twitter:image', window.location.origin + '/images/owner-solid.png');
    injectLocalBusinessSchema();
  } else if (isCheckout) {
    document.title = 'Secure Checkout | Soft Bakes by KC';
    setCanonical(window.location.origin + '/checkout');
    setMeta('description', 'Secure Soft Bakes by KC cart checkout. Pay with Square or send your order for Interac e-transfer.');
    setMeta('robots', 'noindex, nofollow');
    setMeta('og:title', 'Secure Checkout | Soft Bakes by KC', true);
    setMeta('og:description', 'Secure Soft Bakes by KC cart checkout.', true);
    setMeta('og:url', window.location.origin + '/checkout', true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', window.location.origin + '/images/og-share.png', true);
    setMeta('twitter:title', 'Secure Checkout | Soft Bakes by KC');
    setMeta('twitter:description', 'Secure Soft Bakes by KC cart checkout.');
    setMeta('twitter:image', window.location.origin + '/images/og-share.png');
  } else if (isAdmin) {
    document.title = `${isAdminLogin ? 'Admin Login' : isAdminOrders ? 'Order Tracker' : isAdminHistory ? 'Order History' : isAdminDrafts ? 'Draft Orders' : 'Loyalty Admin'} | Soft Bakes by KC`;
    setCanonical(window.location.origin + pathname);
    setMeta('description', 'Private administration for Soft Bakes by KC.');
    setMeta('robots', 'noindex, nofollow');
    removeMeta('og:title', true);
    removeMeta('og:description', true);
    removeMeta('og:url', true);
    removeMeta('og:type', true);
    removeMeta('og:image', true);
  } else {
    document.title = 'Filipino Bakery in Calgary | Soft Bakes by KC';
    setCanonical(window.location.origin + (pathname || '/'));
    setMeta('description', HOMEPAGE_DESCRIPTION);
    setMeta('og:title', 'Filipino Bakery in Calgary | Soft Bakes by KC', true);
    setMeta('og:description', HOMEPAGE_DESCRIPTION, true);
    setMeta('og:url', window.location.origin + (pathname || '/'), true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', window.location.origin + '/images/og-share.png', true);
    setMeta('og:locale', 'en_CA', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Filipino Bakery in Calgary | Soft Bakes by KC');
    setMeta('twitter:description', HOMEPAGE_DESCRIPTION);
    setMeta('twitter:image', window.location.origin + '/images/og-share.png');
    setMeta('geo.region', 'CA-AB');
    setMeta('geo.placename', 'Calgary');
    const scriptEl = document.getElementById('blog-jsonld');
    if (scriptEl) scriptEl.remove();
    injectLocalBusinessSchema();
  }
  if (isAdminLogin) attachAdminLoginListeners();
  else if (isAdminOrders) attachAdminOrdersListeners();
  else if (isAdminHistory) attachAdminHistoryListeners();
  else if (isAdminDrafts) attachAdminDraftsListeners();
  else if (isAdminLoyalty) attachAdminLoyaltyListeners();
  else attachAppListeners();
}

// Client-side routing: intercept same-origin / and /blogs links to avoid full reload
document.body.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const href = link.getAttribute('href');
  if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return;
  try {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const path = url.pathname;
    const isAppRoute = path === '/' || path === '/menu' || path === '/about' || path === '/checkout' || path === '/rewards' || path === '/admin/login' || path === '/admin/orders' || path === '/admin/history' || path === '/admin/drafts' || path === '/admin/loyalty' || path === '/blogs' || path.startsWith('/blogs/');
    if (!isAppRoute) return;
    e.preventDefault();
    const pathChanged = window.location.pathname !== path;
    const hashChanged = window.location.hash !== url.hash;
    if (pathChanged) {
      history.pushState(null, '', href);
      render();
      if (url.hash && url.hash.length > 1) {
        const el = document.getElementById(url.hash.slice(1));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (hashChanged) {
      history.pushState(null, '', href);
      if (url.hash && url.hash.length > 1) {
        const el = document.getElementById(url.hash.slice(1));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  } catch (_) {}
});

// Handle browser back/forward
window.addEventListener('popstate', () => render());

// Must be initialized before render() — attachHeroBubbleListeners assigns these (TDZ if left below).
let closeOpenHeroBubbles = function () {};
let stopHeroBubbleDrift = function () {};

// Initial render
render();

function renderRewardsSummary(summary) {
  if (!summary || !summary.found) {
    return `<div class="rewards-message">${escapeHTML(summary?.message || 'No loyalty record was found yet. Make sure you use the same phone number you ordered with.')}</div>`;
  }

  const threshold = summary.rewardThreshold || 6;
  const availableRewards = summary.availableRewards || 0;
  const currentPoints = summary.currentPoints ?? summary.points ?? 0;
  const lifetimePoints = summary.lifetimePoints ?? summary.totalOrders ?? currentPoints;
  const claimedPoints = summary.claimedPoints ?? ((summary.redeemedRewards || 0) * threshold);
  const progressOrders = summary.progressOrders || 0;
  const rewardText = availableRewards === 1 ? '1 free ube pandesal available' : `${availableRewards} free ube pandesal rewards available`;
  const progressLabel = availableRewards > 0 ? 'Progress after available rewards' : 'Progress to next free';

  return `
    <div class="rewards-summary">
      <p class="rewards-greeting">Hi ${escapeHTML(summary.name)}!</p>
      <div class="rewards-current-points">
        <span>Current usable points</span>
        <strong>${currentPoints}</strong>
        <small>Lifetime earned ${lifetimePoints} - claimed ${claimedPoints}</small>
      </div>
      <div class="rewards-progress-row">
        <span>${progressLabel}</span>
        <strong>${progressOrders} of ${threshold}</strong>
      </div>
      <div class="rewards-progress-bar" aria-hidden="true">
        <span style="width: ${Math.min(100, Math.round((progressOrders / threshold) * 100))}%"></span>
      </div>
      <div class="rewards-stats">
        <div><strong>${lifetimePoints}</strong><span>lifetime earned</span></div>
        <div><strong>${claimedPoints}</strong><span>claimed points</span></div>
        <div><strong>${availableRewards}</strong><span>available rewards</span></div>
        <div><strong>${summary.redeemedRewards || 0}</strong><span>redeemed rewards</span></div>
      </div>
      <p class="rewards-message">${availableRewards > 0 ? `${rewardText}. You also have ${progressOrders} point${progressOrders === 1 ? '' : 's'} toward the next reward after claiming.` : `${summary.ordersUntilNextReward || threshold} more point${(summary.ordersUntilNextReward || threshold) === 1 ? '' : 's'} until your next ${LOYALTY_REWARD_LABEL}.`}</p>
      ${availableRewards > 0 ? `<button type="button" class="btn-primary rewards-redeem-btn" data-reward-name="${escapeHTML(summary.name)}" data-reward-count="${availableRewards}">Claim Your Reward</button>` : ''}
    </div>`;
}

function attachRewardsListeners() {
  const form = document.getElementById('rewardsLookupForm');
  const resultEl = document.getElementById('rewardsLookupResult');
  if (!form || !resultEl) return;

  async function lookupRewards(phone) {
    resultEl.innerHTML = '<div class="rewards-message">Looking up your rewards...</div>';
    try {
      const response = await fetch('/api/rewards/lookup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Unable to look up rewards right now.');
      resultEl.innerHTML = renderRewardsSummary(data);
    } catch (error) {
      resultEl.innerHTML = `<div class="rewards-message rewards-error">${escapeHTML(error.message)}</div>`;
    }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const phone = document.getElementById('rewardsPhone')?.value || '';
    await lookupRewards(phone);
  });

  const query = new URLSearchParams(window.location.search);
  const checkoutId = query.get('checkout') || '';
  if (query.get('payment') !== 'success' || !/^[0-9a-f-]{36}$/i.test(checkoutId)) return;

  let savedPhone = '';
  try {
    savedPhone = sessionStorage.getItem('softbakes_square_phone') || '';
  } catch (_) {}
  const phoneInput = document.getElementById('rewardsPhone');
  if (phoneInput && savedPhone) phoneInput.value = savedPhone;
  resultEl.innerHTML = '<div class="rewards-message">Square returned you safely. Confirming payment and updating your rewards...</div>';

  void (async () => {
    for (let attempt = 0; attempt < 8; attempt += 1) {
      try {
        const response = await fetch('/api/checkout/square/' + encodeURIComponent(checkoutId) + '/status', {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to confirm checkout.');
        if (data.status === 'paid') {
          clearCart();
          if (savedPhone) {
            await lookupRewards(savedPhone);
          } else {
            resultEl.innerHTML = '<div class="rewards-message">Payment confirmed. Enter the same mobile number used at checkout to view your updated rewards.</div>';
          }
          return;
        }
        if (data.status === 'cancelled') {
          resultEl.innerHTML = '<div class="rewards-message rewards-error">This checkout was not completed. No rewards were added.</div>';
          return;
        }
      } catch (error) {
        if (attempt === 7) {
          resultEl.innerHTML = `<div class="rewards-message rewards-error">${escapeHTML(error.message)}</div>`;
          return;
        }
      }
      await new Promise(resolve => setTimeout(resolve, 1500));
    }
    resultEl.innerHTML = '<div class="rewards-message">Square is still confirming your payment. Your rewards will update automatically; check again in a moment.</div>';
  })();
}

function getCookieValue(name) {
  const prefix = name + '=';
  const part = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(prefix));
  return part ? decodeURIComponent(part.slice(prefix.length)) : '';
}

function navigateAdmin(path) {
  history.replaceState(null, '', path);
  render();
}

async function adminFetch(path, { method = 'GET', body } = {}) {
  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (!['GET', 'HEAD'].includes(method)) {
    headers['x-admin-csrf'] = getCookieValue('softbakes_admin_csrf');
  }
  const response = await fetch(path, {
    method,
    headers,
    credentials: 'same-origin',
    cache: 'no-store',
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json();
  if (response.status === 401) {
    navigateAdmin('/admin/login');
    throw new Error(data.error || 'Admin login required.');
  }
  if (!response.ok) throw new Error(data.error || 'Admin request failed.');
  return data;
}

function adminRequest(path, body) {
  return adminFetch(path, { method: 'POST', body: body || {} });
}

function adminGetRequest(path) {
  return adminFetch(path);
}

async function ensureAdminSession() {
  try {
    return await adminGetRequest('/api/admin/session');
  } catch {
    return null;
  }
}

function attachAdminLogout() {
  document.querySelectorAll('[data-admin-logout]').forEach(button => {
    button.addEventListener('click', async function () {
      button.disabled = true;
      try {
        await adminRequest('/api/admin/logout', {});
      } catch (_) {}
      navigateAdmin('/admin/login');
    });
  });
}

function renderAdminSquareOrders(orders) {
  const resultEl = document.getElementById('adminSquareOrders');
  if (!resultEl) return;
  if (!Array.isArray(orders) || !orders.length) {
    resultEl.innerHTML = '<p class="admin-square-empty">No Square checkouts have been recorded yet.</p>';
    return;
  }
  resultEl.innerHTML = orders.map(function (order) {
    const items = Array.isArray(order.items) ? order.items : [];
    const when = order.paidAt || order.createdAt;
    const statusLabel = order.status === 'paid' ? 'Paid + credited' : order.status === 'pending' ? 'Pending payment' : 'Cancelled';
    return `
      <article class="admin-square-order">
        <div class="admin-square-order-topline">
          <div>
            <strong>${escapeHTML(order.name)}</strong>
            <span>${escapeHTML(order.phone)}</span>
          </div>
          <span class="admin-square-status status-${escapeHTML(order.status)}">${statusLabel}</span>
        </div>
        <ul>${items.map(item => `<li>${Number(item.quantity) || 1} × ${escapeHTML(item.name)}</li>`).join('')}</ul>
        <div class="admin-square-order-meta">
          <span>$${(Number(order.amountCents || 0) / 100).toFixed(2)} ${escapeHTML(order.currency || 'CAD')}</span>
          <span>${Number(order.points || 0)} point(s)</span>
          <time>${when ? new Date(when).toLocaleString() : ''}</time>
        </div>
        ${order.paymentId ? `<code title="Square payment ID">${escapeHTML(order.paymentId)}</code>` : ''}
      </article>`;
  }).join('');
}

async function loadAdminSquareOrders() {
  const resultEl = document.getElementById('adminSquareOrders');
  const refreshBtn = document.getElementById('refreshSquareOrders');
  if (!resultEl) return;
  if (refreshBtn) refreshBtn.disabled = true;
  resultEl.innerHTML = '<p class="admin-square-empty">Loading Square checkouts...</p>';
  try {
    const data = await adminGetRequest('/api/admin/square/orders?limit=30');
    renderAdminSquareOrders(data.orders);
  } catch (error) {
    resultEl.innerHTML = `<p class="admin-result-error">${escapeHTML(error.message)}</p>`;
  } finally {
    if (refreshBtn) refreshBtn.disabled = false;
  }
}

function showAdminResult(message, isError = false) {
  const resultEl = document.getElementById('adminResult');
  if (!resultEl) return;
  resultEl.classList.toggle('admin-result-error', !!isError);
  resultEl.innerHTML = `<pre>${escapeHTML(message)}</pre>`;
}

function attachAdminLoyaltyListeners() {
  if (!document.getElementById('adminOrderForm')) return;
  void ensureAdminSession().then(session => {
    if (session) void loadAdminSquareOrders();
  });
  attachAdminLogout();
  document.getElementById('refreshSquareOrders')?.addEventListener('click', () => {
    void loadAdminSquareOrders();
  });

  document.getElementById('adminOrderForm')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const data = await adminRequest('/api/orders/intake', {
        name: document.getElementById('adminOrderName')?.value || '',
        phone: document.getElementById('adminOrderPhone')?.value || '',
        source: 'manual_admin',
        rawNote: document.getElementById('adminOrderNote')?.value || '',
      });
      showAdminResult(JSON.stringify(data, null, 2));
      e.target.reset();
    } catch (error) {
      showAdminResult(error.message, true);
    }
  });

  document.getElementById('adminRedeemForm')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const data = await adminRequest('/api/rewards/redeem', {
        phone: document.getElementById('adminRedeemPhone')?.value || '',
        notes: 'Free ube pandesal manually redeemed.',
      });
      showAdminResult(JSON.stringify(data, null, 2));
      e.target.reset();
    } catch (error) {
      showAdminResult(error.message, true);
    }
  });

  document.getElementById('telegramCandidateForm')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const rawNote = document.getElementById('candidateNote')?.value || '';
      const data = await adminRequest('/api/telegram/candidates', {
        candidateRef: document.getElementById('candidateRef')?.value || '',
        name: document.getElementById('candidateName')?.value || '',
        phone: document.getElementById('candidatePhone')?.value || '',
        confidence: 0,
        payload: { rawNote },
      });
      showAdminResult(JSON.stringify(data, null, 2));
      e.target.reset();
    } catch (error) {
      showAdminResult(error.message, true);
    }
  });

  document.getElementById('approveCandidate')?.addEventListener('click', async () => {
    const id = document.getElementById('candidateReviewId')?.value || '';
    try {
      const data = await adminRequest(`/api/telegram/candidates/${encodeURIComponent(id)}/approve`, {});
      showAdminResult(JSON.stringify(data, null, 2));
    } catch (error) {
      showAdminResult(error.message, true);
    }
  });

  document.getElementById('rejectCandidate')?.addEventListener('click', async () => {
    const id = document.getElementById('candidateReviewId')?.value || '';
    try {
      const data = await adminRequest(`/api/telegram/candidates/${encodeURIComponent(id)}/reject`, {});
      showAdminResult(JSON.stringify(data, null, 2));
    } catch (error) {
      showAdminResult(error.message, true);
    }
  });
}

function attachAdminLoginListeners() {
  const form = document.getElementById('adminLoginForm');
  const statusEl = document.getElementById('adminLoginStatus');
  if (!form || !statusEl) return;

  async function finishLogin(response) {
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Unable to log in.');
    navigateAdmin('/admin/orders');
  }

  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const telegramToken = fragment.get('token') || '';
  if (telegramToken) {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    form.hidden = true;
    statusEl.textContent = 'Verifying your single-use Telegram link...';
    void fetch('/api/admin/login/telegram', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ token: telegramToken }),
    }).then(finishLogin).catch(error => {
      statusEl.textContent = error.message;
      statusEl.classList.add('is-error');
      form.hidden = false;
    });
    return;
  }

  void fetch('/api/admin/session', { credentials: 'same-origin', cache: 'no-store' }).then(response => {
    if (response.ok) navigateAdmin('/admin/orders');
  }).catch(() => {});

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    const passwordInput = document.getElementById('adminPassword');
    const submit = form.querySelector('button[type="submit"]');
    statusEl.classList.remove('is-error');
    statusEl.textContent = 'Logging in securely...';
    if (submit) submit.disabled = true;
    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ password: passwordInput?.value || '' }),
      });
      await finishLogin(response);
    } catch (error) {
      statusEl.textContent = error.message;
      statusEl.classList.add('is-error');
      if (passwordInput) {
        passwordInput.value = '';
        passwordInput.focus();
      }
      if (submit) submit.disabled = false;
    }
  });
}

function toDateTimeLocal(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const local = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
  return local.toISOString().slice(0, 16);
}

function getAdminStatusActions(order) {
  const actions = {
    new: [['preparing', 'Start preparing'], ['cancelled', 'Cancel']],
    preparing: [['ready', 'Mark ready'], ['cancelled', 'Cancel']],
    ready: [['completed', 'Complete'], ['preparing', 'Back to preparing']],
    completed: [['ready', 'Reopen as ready']],
    cancelled: [['new', 'Restore order']],
  };
  return (actions[order.status] || []).map(([status, label]) => (
    `<button type="button" class="${status === 'cancelled' ? 'btn-secondary' : 'btn-primary'}" data-admin-order-status="${status}">${label}</button>`
  )).join('');
}

function renderAdminOrders(orders) {
  const list = document.getElementById('adminOrderList');
  if (!list) return;
  if (!Array.isArray(orders) || !orders.length) {
    list.innerHTML = '<p class="admin-orders-empty">No orders match this view.</p>';
    return;
  }
  list.innerHTML = orders.map(order => {
    const items = Array.isArray(order.items) ? order.items : [];
    const itemText = items.length
      ? items.map(item => `<li>${Number(item.quantity) || 1} × ${escapeHTML(item.name || item)}</li>`).join('')
      : `<li>${escapeHTML(order.rawNote || 'Order details unavailable')}</li>`;
    const email = order.customer?.email || '';
    const readyPanel = order.status === 'ready' ? `
      <section class="admin-ready-panel">
        <label for="readyMessage-${order.id}">Customer-ready message</label>
        <textarea id="readyMessage-${order.id}" class="form-control admin-ready-message" rows="5">${escapeHTML(order.readyMessage)}</textarea>
        <div class="admin-contact-actions">
          <button type="button" class="btn-primary" data-admin-notify-open="sms">Open SMS</button>
          ${email ? '<button type="button" class="btn-secondary" data-admin-notify-open="email">Open Email</button>' : ''}
          <button type="button" class="btn-secondary" data-admin-notify-open="copy">Copy message</button>
        </div>
        <div class="admin-contact-actions">
          <button type="button" class="admin-mark-contacted" data-admin-contacted="sms">Mark SMS sent</button>
          ${email ? '<button type="button" class="admin-mark-contacted" data-admin-contacted="email">Mark email sent</button>' : ''}
        </div>
        ${order.notifiedReadyAt ? `<p class="admin-contacted-note">Customer marked contacted ${new Date(order.notifiedReadyAt).toLocaleString()} via ${escapeHTML(order.notificationChannel || 'message')}.</p>` : ''}
      </section>` : '';
    return `
      <article class="admin-order-card" data-admin-order-id="${order.id}" data-customer-phone="${escapeHTML(order.customer?.phone || '')}" data-customer-email="${escapeHTML(email)}">
        <div class="admin-order-card-header">
          <div>
            <span class="admin-order-number">Order #${order.id} · ${escapeHTML(order.source)}</span>
            <h2>${escapeHTML(order.customer?.name || 'Customer')}</h2>
            <p>${escapeHTML(order.customer?.phone || '')}${email ? ` · ${escapeHTML(email)}` : ''}</p>
          </div>
          <span class="admin-fulfillment-status status-${escapeHTML(order.status)}">${escapeHTML(order.status)}</span>
        </div>
        <div class="admin-order-summary">
          <ul>${itemText}</ul>
          <div><strong>$${(Number(order.amountCents || 0) / 100).toFixed(2)} CAD</strong><span>${new Date(order.orderDate).toLocaleString()}</span></div>
        </div>
        <details class="admin-order-details" ${order.status === 'ready' ? 'open' : ''}>
          <summary>Fulfillment details</summary>
          <div class="admin-order-fields">
            <label>Method
              <select class="form-control" data-admin-field="method">
                <option value="undecided" ${order.method === 'undecided' ? 'selected' : ''}>Not decided</option>
                <option value="pickup" ${order.method === 'pickup' ? 'selected' : ''}>Pickup</option>
                <option value="courier" ${order.method === 'courier' ? 'selected' : ''}>Courier</option>
              </select>
            </label>
            <label>Date and time
              <input type="datetime-local" class="form-control" data-admin-field="scheduledAt" value="${toDateTimeLocal(order.scheduledAt)}">
            </label>
            <label>Location
              <input type="text" class="form-control" data-admin-field="location" value="${escapeHTML(order.location || '')}" placeholder="Confirm privately with customer">
            </label>
            <label>Fulfillment note
              <textarea class="form-control" data-admin-field="note" rows="3" placeholder="Pickup or courier details">${escapeHTML(order.note || '')}</textarea>
            </label>
          </div>
          <button type="button" class="btn-secondary admin-save-fulfillment" data-admin-save-fulfillment>Save fulfillment details</button>
          ${readyPanel}
        </details>
        <div class="admin-order-status-actions">${getAdminStatusActions(order)}</div>
      </article>`;
  }).join('');
}

async function loadAdminOrders() {
  const list = document.getElementById('adminOrderList');
  const statusEl = document.getElementById('adminOrdersStatus');
  if (!list || !statusEl) return;
  const filter = document.getElementById('adminOrderFilter')?.value || 'active';
  const search = document.getElementById('adminOrderSearch')?.value || '';
  statusEl.textContent = 'Loading confirmed orders...';
  try {
    const data = await adminGetRequest(`/api/admin/orders?filter=${encodeURIComponent(filter)}&search=${encodeURIComponent(search)}&limit=100`);
    renderAdminOrders(data.orders);
    statusEl.textContent = `${data.orders.length} order${data.orders.length === 1 ? '' : 's'} shown`;
  } catch (error) {
    if (document.getElementById('adminOrderList')) {
      list.innerHTML = `<p class="admin-result-error">${escapeHTML(error.message)}</p>`;
      statusEl.textContent = '';
    }
  }
}

function renderAdminHistory(orders) {
  const list = document.getElementById('adminHistoryList');
  const summaryEl = document.getElementById('adminHistorySummary');
  if (!list) return;
  if (!Array.isArray(orders) || !orders.length) {
    list.innerHTML = '<p class="admin-orders-empty">No past orders match this view.</p>';
    if (summaryEl) summaryEl.innerHTML = '';
    return;
  }

  const revenueCents = orders.reduce((total, order) => total + (Number(order.amountCents) || 0), 0);
  const points = orders.reduce((total, order) => total + (Number(order.points) || 0), 0);
  const quantity = orders.reduce((total, order) => {
    const items = Array.isArray(order.items) ? order.items : [];
    return total + items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
  }, 0);
  if (summaryEl) {
    summaryEl.innerHTML = `
      <div><strong>${orders.length}</strong><span>orders</span></div>
      <div><strong>$${(revenueCents / 100).toFixed(2)}</strong><span>revenue</span></div>
      <div><strong>${quantity}</strong><span>units</span></div>
      <div><strong>${points}</strong><span>points</span></div>`;
  }

  list.innerHTML = orders.map((order) => {
    const items = Array.isArray(order.items) ? order.items : [];
    const itemText = items.length
      ? items.map((item) => `<li>${Number(item.quantity) || 1} × ${escapeHTML(item.name || item)}${item.lineTotal != null ? ` · $${Number(item.lineTotal).toFixed(2)}` : ''}</li>`).join('')
      : `<li>${escapeHTML(order.rawNote || 'Order details unavailable')}</li>`;
    const when = order.completedAt || order.orderDate;
    return `
      <article class="admin-order-card admin-history-card" data-admin-order-id="${order.id}">
        <div class="admin-order-card-header">
          <div>
            <span class="admin-order-number">Order #${order.id} · ${escapeHTML(order.source || 'manual')}</span>
            <h2>${escapeHTML(order.customer?.name || 'Customer')}</h2>
            <p>${escapeHTML(order.customer?.phone || '')}${order.customer?.email ? ` · ${escapeHTML(order.customer.email)}` : ''}</p>
          </div>
          <span class="admin-fulfillment-status status-${escapeHTML(order.status)}">${escapeHTML(order.status)}</span>
        </div>
        <div class="admin-order-summary">
          <ul>${itemText}</ul>
          <div>
            <strong>$${(Number(order.amountCents || 0) / 100).toFixed(2)} CAD</strong>
            <span>${Number(order.points || 0)} point(s)</span>
            <span>${when ? new Date(when).toLocaleString() : ''}</span>
            <span>${escapeHTML(order.method || 'undecided')}</span>
          </div>
        </div>
        <div class="admin-order-status-actions">${getAdminStatusActions(order)}</div>
      </article>`;
  }).join('');
}

async function loadAdminHistory() {
  const list = document.getElementById('adminHistoryList');
  const statusEl = document.getElementById('adminHistoryStatus');
  if (!list || !statusEl) return;
  const filter = document.getElementById('adminHistoryFilter')?.value || 'history';
  const search = document.getElementById('adminHistorySearch')?.value || '';
  statusEl.textContent = 'Loading order history...';
  try {
    const data = await adminGetRequest(`/api/admin/orders?filter=${encodeURIComponent(filter)}&search=${encodeURIComponent(search)}&limit=100`);
    renderAdminHistory(data.orders);
    statusEl.textContent = `${data.orders.length} past order${data.orders.length === 1 ? '' : 's'} shown`;
  } catch (error) {
    list.innerHTML = `<p class="admin-result-error">${escapeHTML(error.message)}</p>`;
    statusEl.textContent = '';
  }
}

function attachAdminHistoryListeners() {
  const list = document.getElementById('adminHistoryList');
  if (!list) return;
  attachAdminLogout();
  void ensureAdminSession().then((session) => {
    if (session) void loadAdminHistory();
  });
  document.getElementById('refreshAdminHistory')?.addEventListener('click', () => void loadAdminHistory());
  document.getElementById('adminHistoryFilter')?.addEventListener('change', () => void loadAdminHistory());
  let searchTimer;
  document.getElementById('adminHistorySearch')?.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => void loadAdminHistory(), 300);
  });
  list.addEventListener('click', async function (event) {
    const card = event.target.closest('[data-admin-order-id]');
    const statusButton = event.target.closest('[data-admin-order-status]');
    if (!card || !statusButton) return;
    const orderId = card.dataset.adminOrderId;
    const statusEl = document.getElementById('adminHistoryStatus');
    try {
      statusButton.disabled = true;
      await adminFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/fulfillment`, {
        method: 'PATCH',
        body: { status: statusButton.dataset.adminOrderStatus },
      });
      await loadAdminHistory();
    } catch (error) {
      if (statusEl) statusEl.textContent = error.message;
      statusButton.disabled = false;
    }
  });
}

function getOrderCardPayload(card) {
  return {
    method: card.querySelector('[data-admin-field="method"]')?.value || 'undecided',
    scheduledAt: card.querySelector('[data-admin-field="scheduledAt"]')?.value || null,
    location: card.querySelector('[data-admin-field="location"]')?.value || '',
    note: card.querySelector('[data-admin-field="note"]')?.value || '',
  };
}

function attachAdminOrdersListeners() {
  const list = document.getElementById('adminOrderList');
  if (!list) return;
  attachAdminLogout();
  void ensureAdminSession().then(session => {
    if (session) void loadAdminOrders();
  });
  document.getElementById('refreshAdminOrders')?.addEventListener('click', () => void loadAdminOrders());
  document.getElementById('adminOrderFilter')?.addEventListener('change', () => void loadAdminOrders());
  let searchTimer;
  document.getElementById('adminOrderSearch')?.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => void loadAdminOrders(), 300);
  });

  list.addEventListener('click', async function (event) {
    const card = event.target.closest('[data-admin-order-id]');
    if (!card) return;
    const orderId = card.dataset.adminOrderId;
    const statusEl = document.getElementById('adminOrdersStatus');
    const statusButton = event.target.closest('[data-admin-order-status]');
    const saveButton = event.target.closest('[data-admin-save-fulfillment]');
    const notifyButton = event.target.closest('[data-admin-notify-open]');
    const contactedButton = event.target.closest('[data-admin-contacted]');
    try {
      if (statusButton) {
        statusButton.disabled = true;
        await adminFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/fulfillment`, {
          method: 'PATCH',
          body: { ...getOrderCardPayload(card), status: statusButton.dataset.adminOrderStatus },
        });
        await loadAdminOrders();
        return;
      }
      if (saveButton) {
        saveButton.disabled = true;
        await adminFetch(`/api/admin/orders/${encodeURIComponent(orderId)}/fulfillment`, {
          method: 'PATCH',
          body: getOrderCardPayload(card),
        });
        if (statusEl) statusEl.textContent = `Order #${orderId} fulfillment details saved.`;
        saveButton.disabled = false;
        return;
      }
      if (notifyButton) {
        const channel = notifyButton.dataset.adminNotifyOpen;
        const message = card.querySelector('.admin-ready-message')?.value || '';
        await adminRequest(`/api/admin/orders/${encodeURIComponent(orderId)}/notification`, { action: 'opened', channel });
        if (channel === 'copy') {
          await navigator.clipboard.writeText(message);
          if (statusEl) statusEl.textContent = 'Ready message copied.';
        } else if (channel === 'sms') {
          const phone = (card.dataset.customerPhone || '').replace(/[^\d+]/g, '');
          window.location.href = `sms:${phone}?body=${encodeURIComponent(message)}`;
        } else if (channel === 'email') {
          window.location.href = `mailto:${encodeURIComponent(card.dataset.customerEmail || '')}?subject=${encodeURIComponent('Your Soft Bakes order is ready')}&body=${encodeURIComponent(message)}`;
        }
        return;
      }
      if (contactedButton) {
        await adminRequest(`/api/admin/orders/${encodeURIComponent(orderId)}/notification`, {
          action: 'contacted',
          channel: contactedButton.dataset.adminContacted,
        });
        await loadAdminOrders();
      }
    } catch (error) {
      if (statusEl) statusEl.textContent = error.message;
      if (statusButton) statusButton.disabled = false;
      if (saveButton) saveButton.disabled = false;
    }
  });
}

function formatDraftMoney(cents) {
  return `$${(Number(cents || 0) / 100).toFixed(2)}`;
}

function draftDisplayLabel(status) {
  switch (status) {
    case 'draft': return 'Draft';
    case 'link_ready': return 'Link ready';
    case 'email_sent': return 'Email sent';
    case 'email_delivered': return 'Email delivered';
    case 'email_bounced': return 'Email bounced';
    case 'email_complained': return 'Email complained';
    case 'email_failed': return 'Email failed';
    case 'paid': return 'Paid';
    case 'cancelled': return 'Cancelled';
    default: return status || 'Draft';
  }
}

function attachAdminDraftsListeners() {
  const list = document.getElementById('adminDraftList');
  const form = document.getElementById('adminDraftForm');
  if (!list || !form) return;

  attachAdminLogout();

  let catalogItems = [];
  let draftLines = [];
  let activeDraft = null;

  const statusEl = document.getElementById('adminDraftFormStatus');
  const listStatusEl = document.getElementById('adminDraftsStatus');
  const linesEl = document.getElementById('adminDraftLines');
  const totalsEl = document.getElementById('adminDraftTotals');
  const catalogSelect = document.getElementById('adminDraftCatalogSelect');
  const draftIdInput = document.getElementById('adminDraftId');
  const createLinkBtn = document.getElementById('adminDraftCreateLink');
  const composerTitle = document.getElementById('adminDraftComposerTitle');

  function setComposerStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function computeLocalTotals() {
    const amountCents = draftLines.reduce((total, item) => total + (item.quantity * item.unitPriceCents), 0);
    const points = draftLines.reduce((total, item) => total + (item.quantity * item.pointsPerUnit), 0);
    return { amountCents, points };
  }

  function renderDraftLines() {
    if (!linesEl || !totalsEl) return;
    if (!draftLines.length) {
      linesEl.innerHTML = '<p class="admin-draft-empty-lines">No items yet. Add a catalog or custom line.</p>';
    } else {
      linesEl.innerHTML = draftLines.map((item, index) => `
        <article class="admin-draft-line" data-draft-line-index="${index}">
          <div>
            <strong>${escapeHTML(item.name)}</strong>
            <span>${item.kind === 'catalog' ? 'Catalog' : 'Custom'} · ${escapeHTML(item.unitLabel || 'each')}</span>
          </div>
          <div class="admin-draft-line-controls">
            <label>Qty
              <input type="number" min="1" max="50" value="${item.quantity}" data-draft-line-qty>
            </label>
            ${item.kind === 'custom' ? `
              <label>Price ($)
                <input type="number" min="0.01" step="0.01" value="${(item.unitPriceCents / 100).toFixed(2)}" data-draft-line-price>
              </label>
              <label>Pts
                <input type="number" min="0" max="20" value="${item.pointsPerUnit}" data-draft-line-points>
              </label>
            ` : `<span class="admin-draft-line-price">${formatDraftMoney(item.unitPriceCents)} · ${item.pointsPerUnit} pt</span>`}
            <button type="button" class="btn-secondary" data-draft-line-remove>Remove</button>
          </div>
        </article>
      `).join('');
    }
    const totals = computeLocalTotals();
    totalsEl.innerHTML = `<strong>Total ${formatDraftMoney(totals.amountCents)}</strong><span>${totals.points} point(s)</span>`;
    if (createLinkBtn) {
      createLinkBtn.disabled = !draftIdInput.value || (activeDraft && activeDraft.status !== 'draft');
    }
  }

  function fillComposerFromDraft(draft) {
    activeDraft = draft;
    draftIdInput.value = draft?.id || '';
    document.getElementById('adminDraftName').value = draft?.customer?.name || '';
    document.getElementById('adminDraftPhone').value = draft?.customer?.phone || '';
    document.getElementById('adminDraftEmail').value = draft?.customer?.email || '';
    draftLines = Array.isArray(draft?.items)
      ? draft.items.map((item) => ({
          kind: item.kind || 'catalog',
          id: item.id,
          name: item.name,
          quantity: Number(item.quantity) || 1,
          unitPriceCents: Number(item.unitPriceCents) || 0,
          unitLabel: item.unitLabel || 'each',
          pointsPerUnit: Number(item.pointsPerUnit ?? 1),
        }))
      : [];
    if (composerTitle) {
      composerTitle.textContent = draft?.id ? `Editing draft #${draft.id}` : 'New draft';
    }
    renderDraftLines();
  }

  function resetComposer() {
    fillComposerFromDraft(null);
    setComposerStatus('');
  }

  function getComposerPayload() {
    return {
      name: document.getElementById('adminDraftName').value.trim(),
      phone: document.getElementById('adminDraftPhone').value.trim(),
      email: document.getElementById('adminDraftEmail').value.trim(),
      items: draftLines.map((item) => item.kind === 'catalog'
        ? { kind: 'catalog', id: item.id, quantity: item.quantity }
        : {
            kind: 'custom',
            name: item.name,
            quantity: item.quantity,
            unitPriceCents: item.unitPriceCents,
            unitLabel: item.unitLabel || 'each',
            pointsPerUnit: item.pointsPerUnit,
          }),
    };
  }

  async function loadCatalog() {
    const data = await adminGetRequest('/api/admin/drafts/catalog');
    catalogItems = Array.isArray(data.items) ? data.items : [];
    if (!catalogSelect) return;
    catalogSelect.innerHTML = catalogItems.map((item) => (
      `<option value="${escapeHTML(item.id)}">${escapeHTML(item.name)} · ${formatDraftMoney(item.unitPriceCents)}</option>`
    )).join('');
  }

  async function loadAdminDrafts() {
    const filter = document.getElementById('adminDraftFilter')?.value || 'all';
    const search = document.getElementById('adminDraftSearch')?.value || '';
    list.innerHTML = '<p class="admin-orders-empty">Loading drafts...</p>';
    try {
      const data = await adminGetRequest(`/api/admin/drafts?status=${encodeURIComponent(filter)}&search=${encodeURIComponent(search)}&limit=100`);
      const drafts = Array.isArray(data.drafts) ? data.drafts : [];
      if (!drafts.length) {
        list.innerHTML = '<p class="admin-orders-empty">No drafts yet.</p>';
        if (listStatusEl) listStatusEl.textContent = '';
        return;
      }
      list.innerHTML = drafts.map((draft) => {
        const items = Array.isArray(draft.items) ? draft.items : [];
        const canEdit = draft.status === 'draft';
        const canLink = draft.status === 'draft';
        const canEmail = draft.status === 'link_ready' && !!draft.paymentUrl;
        const canCancel = draft.status === 'draft' || draft.status === 'link_ready';
        return `
          <article class="admin-draft-card" data-admin-draft-id="${draft.id}">
            <div class="admin-draft-card-header">
              <div>
                <span class="admin-order-number">Draft #${draft.id}</span>
                <h2>${escapeHTML(draft.customer?.name || 'Customer')}</h2>
                <p>${escapeHTML(draft.customer?.phone || '')}<br>${escapeHTML(draft.customer?.email || '')}</p>
              </div>
              <span class="admin-draft-status status-${escapeHTML(draft.displayStatus || draft.status)}">${escapeHTML(draftDisplayLabel(draft.displayStatus || draft.status))}</span>
            </div>
            <div class="admin-order-summary">
              <ul>${items.map((item) => `<li>${Number(item.quantity) || 1} × ${escapeHTML(item.name)}</li>`).join('')}</ul>
              <div>
                <strong>${formatDraftMoney(draft.amountCents)}</strong>
                <span>${Number(draft.points || 0)} point(s)</span>
                ${draft.orderId ? `<a href="/admin/orders">Fulfillment #${draft.orderId}</a>` : ''}
              </div>
            </div>
            <div class="admin-draft-card-actions">
              ${canEdit ? `<button type="button" class="btn-secondary" data-admin-draft-edit>Edit</button>` : ''}
              ${canLink ? `<button type="button" class="btn-primary" data-admin-draft-link>Create link &amp; email</button>` : ''}
              ${canEmail ? `<button type="button" class="btn-primary" data-admin-draft-email>Resend email</button>` : ''}
              ${draft.paymentUrl ? `<button type="button" class="btn-secondary" data-admin-draft-copy>Copy link</button>` : ''}
              ${canCancel ? `<button type="button" class="btn-secondary" data-admin-draft-cancel>Cancel</button>` : ''}
              <button type="button" class="btn-secondary" data-admin-draft-clone>Clone</button>
            </div>
            ${draft.emailFailureText ? `<p class="admin-draft-failure">${escapeHTML(draft.emailFailureText)}</p>` : ''}
          </article>`;
      }).join('');
      if (listStatusEl) listStatusEl.textContent = `${drafts.length} draft(s)`;
    } catch (error) {
      list.innerHTML = `<p class="admin-orders-empty">${escapeHTML(error.message)}</p>`;
    }
  }

  async function saveComposerDraft() {
    const payload = getComposerPayload();
    if (!payload.items.length) throw new Error('Add at least one item before saving.');
    const draftId = draftIdInput.value;
    const data = draftId
      ? await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}`, { method: 'PATCH', body: payload })
      : await adminFetch('/api/admin/drafts', { method: 'POST', body: payload });
    fillComposerFromDraft(data.draft);
    setComposerStatus(`Draft #${data.draft.id} saved. Total ${formatDraftMoney(data.draft.amountCents)}.`);
    await loadAdminDrafts();
    return data.draft;
  }

  async function createLinkAndEmail(draftId) {
    const linked = await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}/payment-link`, { method: 'POST', body: {} });
    let emailed = linked.draft;
    try {
      const emailResult = await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}/email`, { method: 'POST', body: {} });
      emailed = emailResult.draft;
      setComposerStatus(`Payment link emailed to ${emailed.customer.email}.`);
    } catch (error) {
      setComposerStatus(`Link created, but email failed: ${error.message}`, true);
    }
    fillComposerFromDraft(emailed);
    await loadAdminDrafts();
    return emailed;
  }

  void ensureAdminSession().then(async (session) => {
    if (!session) return;
    try {
      await loadCatalog();
      renderDraftLines();
      await loadAdminDrafts();
    } catch (error) {
      setComposerStatus(error.message, true);
    }
  });

  document.getElementById('refreshAdminDrafts')?.addEventListener('click', () => void loadAdminDrafts());
  document.getElementById('adminDraftFilter')?.addEventListener('change', () => void loadAdminDrafts());
  let searchTimer;
  document.getElementById('adminDraftSearch')?.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => void loadAdminDrafts(), 300);
  });
  document.getElementById('adminDraftReset')?.addEventListener('click', resetComposer);

  document.getElementById('adminDraftAddCatalog')?.addEventListener('click', function () {
    const id = catalogSelect?.value;
    const item = catalogItems.find((entry) => entry.id === id);
    if (!item) return;
    const existing = draftLines.find((line) => line.kind === 'catalog' && line.id === id);
    if (existing) existing.quantity += 1;
    else {
      draftLines.push({
        kind: 'catalog',
        id: item.id,
        name: item.name,
        quantity: 1,
        unitPriceCents: item.unitPriceCents,
        unitLabel: item.unitLabel,
        pointsPerUnit: item.pointsPerUnit,
      });
    }
    renderDraftLines();
  });

  document.getElementById('adminDraftAddCustom')?.addEventListener('click', function () {
    const name = document.getElementById('adminDraftCustomName').value.trim();
    const quantity = Number(document.getElementById('adminDraftCustomQty').value);
    const price = Number(document.getElementById('adminDraftCustomPrice').value);
    const pointsPerUnit = Number(document.getElementById('adminDraftCustomPoints').value);
    if (name.length < 2) {
      setComposerStatus('Custom items need a name.', true);
      return;
    }
    if (!Number.isInteger(quantity) || quantity < 1) {
      setComposerStatus('Custom quantity must be a whole number.', true);
      return;
    }
    if (!(price > 0)) {
      setComposerStatus('Custom unit price must be greater than zero.', true);
      return;
    }
    draftLines.push({
      kind: 'custom',
      name,
      quantity,
      unitPriceCents: Math.round(price * 100),
      unitLabel: 'each',
      pointsPerUnit: Number.isInteger(pointsPerUnit) ? pointsPerUnit : 1,
    });
    document.getElementById('adminDraftCustomName').value = '';
    document.getElementById('adminDraftCustomQty').value = '1';
    document.getElementById('adminDraftCustomPrice').value = '';
    document.getElementById('adminDraftCustomPoints').value = '1';
    setComposerStatus('');
    renderDraftLines();
  });

  linesEl.addEventListener('input', function (event) {
    const card = event.target.closest('[data-draft-line-index]');
    if (!card) return;
    const index = Number(card.dataset.draftLineIndex);
    const line = draftLines[index];
    if (!line) return;
    if (event.target.matches('[data-draft-line-qty]')) {
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity > 0) line.quantity = quantity;
    }
    if (event.target.matches('[data-draft-line-price]') && line.kind === 'custom') {
      const price = Number(event.target.value);
      if (price > 0) line.unitPriceCents = Math.round(price * 100);
    }
    if (event.target.matches('[data-draft-line-points]') && line.kind === 'custom') {
      const points = Number(event.target.value);
      if (Number.isInteger(points) && points >= 0) line.pointsPerUnit = points;
    }
    const totals = computeLocalTotals();
    totalsEl.innerHTML = `<strong>Total ${formatDraftMoney(totals.amountCents)}</strong><span>${totals.points} point(s)</span>`;
  });

  linesEl.addEventListener('click', function (event) {
    const removeBtn = event.target.closest('[data-draft-line-remove]');
    if (!removeBtn) return;
    const card = removeBtn.closest('[data-draft-line-index]');
    const index = Number(card?.dataset.draftLineIndex);
    if (!Number.isInteger(index)) return;
    draftLines.splice(index, 1);
    renderDraftLines();
  });

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    const saveBtn = document.getElementById('adminDraftSave');
    if (saveBtn) saveBtn.disabled = true;
    try {
      await saveComposerDraft();
    } catch (error) {
      setComposerStatus(error.message, true);
    } finally {
      if (saveBtn) saveBtn.disabled = false;
    }
  });

  createLinkBtn?.addEventListener('click', async function () {
    createLinkBtn.disabled = true;
    try {
      const draft = await saveComposerDraft();
      await createLinkAndEmail(draft.id);
    } catch (error) {
      setComposerStatus(error.message, true);
    } finally {
      createLinkBtn.disabled = !draftIdInput.value || (activeDraft && activeDraft.status !== 'draft');
    }
  });

  list.addEventListener('click', async function (event) {
    const card = event.target.closest('[data-admin-draft-id]');
    if (!card) return;
    const draftId = card.dataset.adminDraftId;
    try {
      if (event.target.closest('[data-admin-draft-edit]')) {
        const data = await adminGetRequest(`/api/admin/drafts/${encodeURIComponent(draftId)}`);
        fillComposerFromDraft(data.draft);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if (event.target.closest('[data-admin-draft-link]')) {
        await createLinkAndEmail(draftId);
        return;
      }
      if (event.target.closest('[data-admin-draft-email]')) {
        const data = await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}/email`, { method: 'POST', body: {} });
        setComposerStatus(`Payment link resent to ${data.draft.customer.email}.`);
        await loadAdminDrafts();
        return;
      }
      if (event.target.closest('[data-admin-draft-copy]')) {
        const data = await adminGetRequest(`/api/admin/drafts/${encodeURIComponent(draftId)}`);
        if (!data.draft.paymentUrl) throw new Error('No payment link available.');
        await navigator.clipboard.writeText(data.draft.paymentUrl);
        if (listStatusEl) listStatusEl.textContent = `Copied payment link for draft #${draftId}.`;
        return;
      }
      if (event.target.closest('[data-admin-draft-cancel]')) {
        if (!window.confirm(`Cancel draft #${draftId}? The payment link will stop working.`)) return;
        await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}/cancel`, {
          method: 'POST',
          body: { reason: 'Cancelled from admin drafts' },
        });
        await loadAdminDrafts();
        if (String(draftIdInput.value) === String(draftId)) resetComposer();
        return;
      }
      if (event.target.closest('[data-admin-draft-clone]')) {
        const data = await adminFetch(`/api/admin/drafts/${encodeURIComponent(draftId)}/clone`, { method: 'POST', body: {} });
        fillComposerFromDraft(data.draft);
        setComposerStatus(`Cloned draft #${draftId} into editable draft #${data.draft.id}.`);
        await loadAdminDrafts();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (error) {
      if (listStatusEl) listStatusEl.textContent = error.message;
      setComposerStatus(error.message, true);
    }
  });
}

function getInstagramEmbedFallbackHTML() {
  return `
    <div class="instagram-embed-shell">
      <iframe
        title="Soft Bakes by KC on Instagram"
        src="https://www.instagram.com/softbakesbykc/embed"
        loading="lazy"
        allowtransparency="true"
        frameborder="0"
        scrolling="no"
      ></iframe>
    </div>`;
}

function renderInstagramPosts(posts) {
  return posts.map((post) => {
    const caption = escapeHTML((post.caption || '').slice(0, 120));
    const alt = caption || 'Soft Bakes by KC Instagram post';
    const isVideo = String(post.mediaType || '').toUpperCase() === 'VIDEO' || String(post.mediaType || '').toUpperCase() === 'REELS';
    return `
      <a class="instagram-tile" href="${escapeHTML(post.permalink)}" target="_blank" rel="noopener noreferrer">
        <img src="${escapeHTML(post.imageUrl)}" alt="${alt}" loading="lazy" width="400" height="400">
        ${isVideo ? '<span class="instagram-tile-badge" aria-hidden="true">▶</span>' : ''}
        ${caption ? `<span class="instagram-tile-caption">${caption}</span>` : ''}
      </a>`;
  }).join('');
}

async function loadInstagramFeed() {
  const grid = document.getElementById('instagramFeed');
  if (!grid) return;
  try {
    const response = await fetch('/api/instagram/feed', { headers: { Accept: 'application/json' } });
    const data = await response.json().catch(() => ({}));
    if (Array.isArray(data.posts) && data.posts.length) {
      grid.classList.add('instagram-grid--live');
      grid.innerHTML = renderInstagramPosts(data.posts);
      return;
    }
  } catch (_) {
    // Fall through to official Instagram embed.
  }
  grid.classList.remove('instagram-grid--live');
  grid.classList.add('instagram-grid--embed');
  grid.innerHTML = getInstagramEmbedFallbackHTML();
}

function resetHeroBubbleInlineStyles(wraps) {
  wraps.forEach(function (el) {
    el.style.left = '';
    el.style.top = '';
    el.style.right = '';
    el.style.bottom = '';
    el.style.transform = '';
    el.style.willChange = '';
  });
}

function syncHeroBubbleMotion(wraps) {
  const list = wraps && wraps.length
    ? wraps
    : Array.from(document.querySelectorAll('.hero-bubble-wrap'));
  if (!list.length) {
    stopHeroBubbleDrift();
    return;
  }
  const desktop = window.matchMedia('(min-width: 901px)');
  if (desktop.matches) {
    startHeroBubbleDrift(list);
  } else {
    stopHeroBubbleDrift();
    resetHeroBubbleInlineStyles(list);
  }
  if (!syncHeroBubbleMotion.bound) {
    const onChange = function () { syncHeroBubbleMotion(); };
    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', onChange);
    } else if (typeof desktop.addListener === 'function') {
      desktop.addListener(onChange);
    }
    syncHeroBubbleMotion.bound = true;
  }
}

function startHeroBubbleDrift(wraps) {
  stopHeroBubbleDrift();
  const orbit = document.querySelector('.hero-orbit');
  if (!orbit || !wraps.length) return;
  if (!window.matchMedia('(min-width: 901px)').matches) return;

  // Fixed composition with a slow, bounded drift; no collisions or wandering.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const layout = [
    { x: 0.10, y: 0.13 },
    { x: 0.90, y: 0.15 },
    { x: 0.06, y: 0.70 },
    { x: 0.94, y: 0.70 },
    { x: 0.035, y: 0.42 },
    { x: 0.965, y: 0.44 },
    { x: 0.165, y: 0.455 },
  ];
  const bodies = wraps.map(function (el, index) {
    return { el: el, home: layout[index % layout.length], x: 0, y: 0,
      time: index * 3.1, period: 20 + index * 1.6 };
  });
  orbit.classList.add('hero-orbit--drift');
  let rafId = 0;
  let lastTs = 0;
  let visible = true;

  function paint(body) {
    const phase = body.time * Math.PI * 2 / body.period;
    const dx = reducedMotion.matches ? 0 : Math.sin(phase) * 3;
    const dy = reducedMotion.matches ? 0 : Math.cos(phase) * 6;
    body.el.style.transform = 'translate3d(' + (body.x + dx).toFixed(2) +
      'px,' + (body.y + dy).toFixed(2) + 'px,0)';
  }

  function measure() {
    bodies.forEach(function (body) {
      body.x = body.home.x * Math.max(orbit.clientWidth - body.el.offsetWidth, 0);
      body.y = body.home.y * Math.max(orbit.clientHeight - body.el.offsetHeight, 0);
      paint(body);
    });
  }

  function step(ts) {
    const dt = lastTs ? Math.min((ts - lastTs) / 1000, 0.05) : 0;
    lastTs = ts;
    if (visible && !document.hidden && !reducedMotion.matches) {
      bodies.forEach(function (body) {
        if (body.el.classList.contains('is-open') || body.el.matches(':hover, :focus-within')) return;
        body.time += dt;
        paint(body);
      });
    }
    rafId = window.requestAnimationFrame(step);
  }

  measure();
  const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
  if (ro) ro.observe(orbit);
  const io = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (entries) {
    visible = entries[0].isIntersecting;
  }) : null;
  if (io) io.observe(orbit);
  window.addEventListener('resize', measure);
  reducedMotion.addEventListener('change', measure);
  rafId = window.requestAnimationFrame(step);

  stopHeroBubbleDrift = function () {
    window.cancelAnimationFrame(rafId);
    window.removeEventListener('resize', measure);
    reducedMotion.removeEventListener('change', measure);
    if (ro) ro.disconnect();
    if (io) io.disconnect();
    orbit.classList.remove('hero-orbit--drift');
    resetHeroBubbleInlineStyles(wraps);
    stopHeroBubbleDrift = function () {};
  };
}

// Remotion-rendered ambient loop behind the desktop hero (remotion-popup-menu: HeroLoop).
// Mobile never requests it; reduced-motion visitors get the still poster.
// State lives on the function because render() runs before later top-level bindings exist.
function initHeroMotion() {
  if (initHeroMotion.stop) initHeroMotion.stop();
  const sources = [
    { src: '/videos/hero-loop.mp4?v=11', type: 'video/mp4' },
  ];
  const video = document.querySelector('.hero-motion-video');
  if (!video) return;
  const shell = video.closest('.hero-motion');
  const hero = video.closest('.hero-brand');
  const desktop = window.matchMedia('(min-width: 901px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  let visible = true;

  function setReady(ready) {
    shell.classList.toggle('is-ready', ready);
    if (hero) hero.classList.toggle('has-motion', ready);
  }

  function sync() {
    if (!desktop.matches) {
      video.pause();
      setReady(false);
      return;
    }
    if (!video.poster) video.poster = '/videos/hero-loop-poster.jpg?v=11';
    if (reducedMotion.matches || saveData) {
      video.pause();
      setReady(true);
      return;
    }
    if (!video.dataset.loaded) {
      video.dataset.loaded = 'true';
      video.innerHTML = sources.map(function (source) {
        return '<source src="' + source.src + '" type="' + source.type + '">';
      }).join('');
      video.preload = 'auto';
      video.load();
    }
    if (visible && !document.hidden) {
      const playing = video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    } else {
      video.pause();
    }
  }

  // KC's wand spell in the loop (HeroLoop WAND_WINDOW, seconds) lights up
  // and flips the new-release bubbles: Ube Dream Cookie, which she aims at,
  // and Red Velvet Dream beside it, which the sparkles pass on the way.
  const spellWindow = [16.87, 18.2];
  const spellTargets = Array.from(document.querySelectorAll('.hero-bubble-wrap.float-5, .hero-bubble-wrap.float-7'));
  let spellRaf = 0;
  function watchSpell() {
    const time = video.currentTime;
    const casting = time >= spellWindow[0] && time < spellWindow[1];
    spellTargets.forEach(function (target) { target.classList.toggle('is-enchanted', casting); });
    drawPerch(time);
    spellRaf = window.requestAnimationFrame(watchSpell);
  }
  function stopSpell() {
    window.cancelAnimationFrame(spellRaf);
    spellRaf = 0;
    spellTargets.forEach(function (target) { target.classList.remove('is-enchanted'); });
    if (perch) perch.style.opacity = '0';
  }

  // Finale: KC perches on the "B" of the logo and waves. The logo is page
  // HTML, so she plays from the sprite sheet (HeroLoop PERCH_WINDOW, row 7)
  // pinned to the lettering instead of being baked into the video.
  const perchStart = 18.667;
  const logo = hero && hero.querySelector('.hero-logo');
  let perch = null;
  if (logo) {
    perch = document.createElement('span');
    perch.className = 'hero-perch';
    perch.setAttribute('aria-hidden', 'true');
    logo.insertAdjacentElement('afterend', perch);
  }
  function smoothStep(x) { return x <= 0 ? 0 : x >= 1 ? 1 : x * x * (3 - 2 * x); }
  function drawPerch(time) {
    if (!perch) return;
    const f = (time - perchStart) * 30;
    const presence = f < 0 || f > 80 ? 0 : Math.min(smoothStep(f / 10), smoothStep((80 - f) / 10));
    perch.style.opacity = presence.toFixed(3);
    if (!presence) return;
    // Same scale as the video (object-fit: cover of a 1920x1080 frame).
    const box = video.getBoundingClientRect();
    const scale = Math.max(box.width / 1920, box.height / 1080);
    const parent = (perch.offsetParent || hero).getBoundingClientRect();
    const mark = logo.getBoundingClientRect();
    const cell = 240 * scale;
    const col = Math.max(0, Math.min(11, Math.round((f - 20) / 4)));
    // Sprite cell point (120, 170) is her seat; it lands on the top of the B.
    perch.style.width = perch.style.height = cell + 'px';
    perch.style.left = (mark.left - parent.left + mark.width * 0.465 - 120 * scale) + 'px';
    perch.style.top = (mark.top - parent.top + mark.height * 0.11 - 170 * scale) + 'px';
    perch.style.backgroundSize = (2880 * scale) + 'px ' + (1920 * scale) + 'px';
    perch.style.backgroundPosition = (-col * cell) + 'px ' + (-7 * cell) + 'px';
  }

  function onPlaying() {
    setReady(true);
    if (!spellRaf) spellRaf = window.requestAnimationFrame(watchSpell);
  }
  function onVisibility() { sync(); }
  video.addEventListener('playing', onPlaying);
  video.addEventListener('pause', stopSpell);
  document.addEventListener('visibilitychange', onVisibility);
  desktop.addEventListener('change', sync);
  reducedMotion.addEventListener('change', sync);
  const io = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(function (entries) {
    visible = entries[0].isIntersecting;
    sync();
  }) : null;
  if (io) io.observe(shell);
  sync();

  initHeroMotion.stop = function () {
    video.removeEventListener('playing', onPlaying);
    video.removeEventListener('pause', stopSpell);
    stopSpell();
    document.removeEventListener('visibilitychange', onVisibility);
    desktop.removeEventListener('change', sync);
    reducedMotion.removeEventListener('change', sync);
    if (io) io.disconnect();
    if (perch) perch.remove();
    video.pause();
    initHeroMotion.stop = null;
  };
}

// Mobile: KC pops up as visitors scroll. Each stage is a Remotion strip of one
// whole visit (remotion-popup-menu: KCStrip, KCMobileSheet) that plays when
// its spot scrolls into view and again every few seconds while it stays.
// Beside the hero logo she waves her wand and the logo glows and flips.
function initMobileKC() {
  if (initMobileKC.stop) initMobileKC.stop();
  const mobile = window.matchMedia('(max-width: 900px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (typeof IntersectionObserver === 'undefined') return;
  const logo = document.querySelector('.hero-brand .hero-logo');
  const stages = [
    { anchor: logo, strip: 'kc-mobile-wand', frames: 32, logo: true, again: 6000 },
    { anchor: document.querySelector('.menu-section .section-title'), strip: 'kc-strip-frost', frames: 40, again: 9000 },
    { anchor: document.querySelector('.faq-section .section-title'), strip: 'kc-strip-whisk', frames: 40, again: 9000 },
    { anchor: document.querySelector('.testimonials-section .section-title'), strip: 'kc-strip-oven-love', frames: 40, again: 9000 },
    { anchor: document.querySelector('.how-it-works-section .section-title'), strip: 'kc-strip-pan-buns', frames: 40, again: 9000 },
  ].filter(function (stage) { return stage.anchor; });
  const timers = [];
  const later = function (fn, ms) { timers.push(window.setTimeout(fn, ms)); };

  stages.forEach(function (stage) {
    const el = document.createElement('span');
    el.className = 'kc-stage' + (stage.logo ? ' kc-stage--logo' : '');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="kc-sprite"></span>';
    if (stage.logo) stage.anchor.insertAdjacentElement('afterend', el);
    else stage.anchor.insertAdjacentElement('beforebegin', el);
    stage.el = el;
    stage.sprite = el.firstChild;
    stage.sprite.style.setProperty('--kc-steps', stage.frames - 1);
    stage.sprite.style.setProperty('--kc-end', (-(stage.frames - 1) * 120) + 'px');
    stage.sprite.addEventListener('animationend', function () {
      el.classList.remove('is-playing');
      if (stage.inView) stage.timer = window.setTimeout(function () { play(stage); }, stage.again);
    });
  });

  // The wand strip's spell lands at (116, 47) of its frame: aim it at the
  // left side of the logo.
  function placeLogoStage(stage) {
    const box = stage.anchor.getBoundingClientRect();
    const parent = (stage.el.offsetParent || stage.anchor.parentElement).getBoundingClientRect();
    stage.el.style.left = (box.left - parent.left + box.width * 0.15 - 116) + 'px';
    stage.el.style.top = (box.top - parent.top + box.height * 0.45 - 47) + 'px';
  }

  function play(stage) {
    window.clearTimeout(stage.timer);
    if (!mobile.matches || reducedMotion.matches || document.hidden) return;
    if (!stage.sprite.style.backgroundImage) stage.sprite.style.backgroundImage = 'url(/sprites/' + stage.strip + '.webp?v=1)';
    if (stage.logo) {
      placeLogoStage(stage);
      later(function () { logo.classList.add('is-enchanted'); }, 1130);
      later(function () { logo.classList.remove('is-enchanted'); }, 2400);
    }
    stage.el.classList.remove('is-playing');
    void stage.el.offsetWidth;
    stage.el.classList.add('is-playing');
  }

  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      const stage = stages.find(function (item) { return item.anchor === entry.target; });
      if (!stage) return;
      stage.inView = entry.isIntersecting;
      if (stage.inView && !stage.el.classList.contains('is-playing')) play(stage);
      if (!stage.inView) window.clearTimeout(stage.timer);
    });
  }, { rootMargin: '-10% 0px -20% 0px' });
  stages.forEach(function (stage) { io.observe(stage.anchor); });

  initMobileKC.stop = function () {
    io.disconnect();
    timers.forEach(window.clearTimeout);
    stages.forEach(function (stage) {
      window.clearTimeout(stage.timer);
      stage.el.remove();
    });
    if (logo) logo.classList.remove('is-enchanted');
    initMobileKC.stop = null;
  };
}

function attachHeroBubbleListeners() {
  const wraps = Array.from(document.querySelectorAll('.hero-bubble-wrap'));
  if (!wraps.length) return;

  function closeAllBubbles(exceptWrap) {
    wraps.forEach(function (wrap) {
      if (exceptWrap && wrap === exceptWrap) return;
      const button = wrap.querySelector('.hero-bubble');
      const tip = wrap.querySelector('.hero-bubble-tip');
      wrap.classList.remove('is-open');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (tip) tip.hidden = true;
    });
  }
  closeOpenHeroBubbles = closeAllBubbles;

  wraps.forEach(function (wrap) {
    const button = wrap.querySelector('.hero-bubble');
    const tip = wrap.querySelector('.hero-bubble-tip');
    if (!button || !tip) return;
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      const willOpen = tip.hidden;
      closeAllBubbles(willOpen ? wrap : null);
      wrap.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      tip.hidden = !willOpen;
    });
  });

  if (!attachHeroBubbleListeners.docBound) {
    document.addEventListener('click', function (event) {
      if (event.target.closest('.hero-bubble-wrap')) return;
      closeOpenHeroBubbles();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeOpenHeroBubbles();
    });
    attachHeroBubbleListeners.docBound = true;
  }

  document.querySelectorAll('.hero-bubble-tip-link[data-menu-target]').forEach(function (link) {
    link.addEventListener('click', function () {
      const targetId = link.getAttribute('data-menu-target') || '';
      window.setTimeout(function () {
        const card = document.querySelector('[data-order-id="' + targetId + '"]');
        if (card) {
          card.classList.add('menu-card-highlight');
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { card.classList.remove('menu-card-highlight'); }, 1800);
        }
      }, 50);
    });
  });

  syncHeroBubbleMotion(wraps);
}

function attachAppListeners() {
  const announcementBar = document.getElementById('announcementBar');
  const closeAnnouncementBtn = document.getElementById('closeAnnouncement');
  if (closeAnnouncementBtn && announcementBar) {
    closeAnnouncementBtn.addEventListener('click', () => {
      announcementBar.style.display = 'none';
    });
  }

  attachHeroBubbleListeners();
  initHeroMotion();
  initMobileKC();
  loadInstagramFeed();
  attachRewardsListeners();
  attachAdminLoyaltyListeners();

  const checkoutPanel = document.getElementById('secureCheckout');
  const expressModal = document.getElementById('expressOrderModal');
  const closeExpressModalBtn = document.getElementById('closeExpressOrderModal');
  const expressPayWithSquare = document.getElementById('expressPayWithSquare');
  const expressCheckoutStatus = document.getElementById('expressCheckoutStatus');
  const orderBtns = document.querySelectorAll('.order-btn');
  const addToCartButtons = document.querySelectorAll('[data-order-action="add"]');
  const buyNowButtons = document.querySelectorAll('[data-order-action="buy-now"]');
  const productQuantityButtons = document.querySelectorAll('[data-card-qty-action]');
  const productQuantityInputs = document.querySelectorAll('.product-card-qty-input');
  const cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  const openCartDrawerBtn = document.getElementById('openCartDrawer');
  const stickyCartBar = document.getElementById('stickyCartBar');
  const closeCartDrawerBtn = document.getElementById('closeCartDrawer');
  const cartDrawerCheckoutBtn = document.getElementById('cartDrawerCheckout');
  const cartDrawerClearBtn = document.getElementById('cartDrawerClear');
  const messagePreview = document.getElementById('messagePreview');
  const sendEmail = document.getElementById('sendEmail');
  const sendWa = document.getElementById('sendWa');
  const sendFb = document.getElementById('sendFb');
  const sendSms = document.getElementById('sendSms');
  const payWithSquare = document.getElementById('payWithSquare');
  const squareCheckoutStatus = document.getElementById('squareCheckoutStatus');
  let expressOrderContext = null;

  function getOrderName() {
    const el = document.getElementById('orderCustomerName');
    return el ? (el.value || '').trim() : '';
  }

  function getOrderPhone() {
    const el = document.getElementById('orderCustomerPhone');
    return el ? (el.value || '').trim() : '';
  }

  function getOrderEmail() {
    const el = document.getElementById('orderCustomerEmail');
    return el ? (el.value || '').trim() : '';
  }

  function isValidOrderEmail(value) {
    const email = String(value || '').trim();
    return !email || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function isValidOrderPhone(value) {
    const raw = String(value || '').trim();
    const digits = raw.replace(/\D/g, '');
    if (raw.startsWith('+')) return digits.length >= 10 && digits.length <= 15;
    return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
  }

  function getProductCardQuantity(card) {
    const input = card?.querySelector('.product-card-qty-input');
    const quantity = Math.max(1, Math.min(Number.parseInt(input?.value, 10) || 1, 50));
    if (input) input.value = String(quantity);
    return quantity;
  }

  function getExpressValue(id) {
    const input = document.getElementById(id);
    return input ? String(input.value || '').trim() : '';
  }

  function showExpressError(errorId, inputId, show) {
    const error = document.getElementById(errorId);
    const input = document.getElementById(inputId);
    if (error) error.hidden = !show;
    if (input) input.classList.toggle('input-error', !!show);
  }

  function clearExpressErrors() {
    showExpressError('expressNameError', 'expressCustomerName', false);
    showExpressError('expressPhoneError', 'expressCustomerPhone', false);
    showExpressError('expressEmailError', 'expressCustomerEmail', false);
    const termsError = document.getElementById('expressTermsError');
    if (termsError) termsError.hidden = true;
  }

  function validateExpressOrder() {
    const name = getExpressValue('expressCustomerName');
    const phone = getExpressValue('expressCustomerPhone');
    const email = getExpressValue('expressCustomerEmail');
    const terms = document.getElementById('expressAgreeTerms');
    if (!name) {
      showExpressError('expressNameError', 'expressCustomerName', true);
      document.getElementById('expressCustomerName')?.focus();
      return false;
    }
    showExpressError('expressNameError', 'expressCustomerName', false);
    if (!isValidOrderPhone(phone)) {
      showExpressError('expressPhoneError', 'expressCustomerPhone', true);
      document.getElementById('expressCustomerPhone')?.focus();
      return false;
    }
    showExpressError('expressPhoneError', 'expressCustomerPhone', false);
    if (!isValidOrderEmail(email)) {
      showExpressError('expressEmailError', 'expressCustomerEmail', true);
      document.getElementById('expressCustomerEmail')?.focus();
      return false;
    }
    showExpressError('expressEmailError', 'expressCustomerEmail', false);
    if (!terms?.checked) {
      const termsError = document.getElementById('expressTermsError');
      if (termsError) termsError.hidden = false;
      terms?.focus();
      return false;
    }
    const termsError = document.getElementById('expressTermsError');
    if (termsError) termsError.hidden = true;
    return true;
  }

  function showOrderNameError(show) {
    const err = document.getElementById('orderNameError');
    const input = document.getElementById('orderCustomerName');
    if (err) err.style.display = show ? 'block' : 'none';
    if (input) input.classList.toggle('input-error', !!show);
  }

  function showOrderPhoneError(show) {
    const err = document.getElementById('orderPhoneError');
    const input = document.getElementById('orderCustomerPhone');
    if (err) err.style.display = show ? 'block' : 'none';
    if (input) input.classList.toggle('input-error', !!show);
  }

  function showOrderEmailError(show) {
    const err = document.getElementById('orderEmailError');
    const input = document.getElementById('orderCustomerEmail');
    if (err) err.style.display = show ? 'block' : 'none';
    if (input) input.classList.toggle('input-error', !!show);
  }

  function showOrderTermsError(show) {
    const err = document.getElementById('orderTermsError');
    if (err) err.style.display = show ? 'block' : 'none';
  }

  function getOrderTermsAgreed() {
    const el = document.getElementById('orderAgreeTerms');
    return !!(el && el.checked);
  }

  function getSelectedCart() {
    return availableOrderableItems.map(function (item) {
      const input = document.getElementById('qty-' + item.id);
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: input ? parseInt(input.value, 10) || 0 : 0,
      };
    }).filter(item => item.quantity > 0);
  }

  function hydrateOrderInputsFromCart() {
    const cart = getCart();
    availableOrderableItems.forEach(function (item) {
      const input = document.getElementById('qty-' + item.id);
      if (input) input.value = String(cart[item.id] || 0);
    });
  }

  function syncCartFromOrderInputs() {
    const cart = {};
    availableOrderableItems.forEach(function (item) {
      const input = document.getElementById('qty-' + item.id);
      const quantity = input ? Math.max(0, Math.min(parseInt(input.value, 10) || 0, 50)) : 0;
      if (input) input.value = String(quantity);
      if (quantity > 0) cart[item.id] = quantity;
    });
    setCart(cart);
  }

  function updateOrderTotal() {
    const total = getSelectedCart().reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalEl = document.getElementById('orderCartTotal');
    if (totalEl) totalEl.textContent = '$' + total.toFixed(2) + ' CAD';
    return total;
  }

  function updateMessage() {
    updateOrderTotal();
    if (!sendEmail || !sendSms) return;
    let message;
    const customerName = getOrderName();
    const customerPhone = getOrderPhone();
    if (orderModalCustomMessage) {
      message = orderModalCustomMessage.replace('{name}', customerName || 'there');
    } else if (orderModalChatWithKC) {
      message = 'Hi KC I would like to place an order!';
    } else {
      orderModalChatWithKC = false;
      const lines = [];
      let total = 0;
      availableOrderableItems.forEach(function (item) {
        const input = document.getElementById('qty-' + item.id);
        const qty = input ? parseInt(input.value, 10) || 0 : 0;
        if (qty > 0) {
          lines.push('• ' + item.name + ' x ' + qty);
          total += qty * item.price;
        }
      });
      const greeting = customerName ? 'Hello, my name is ' + customerName + '.' : 'Hello,';
      const phoneLine = customerPhone ? '\nMobile: ' + customerPhone : '';
      if (lines.length === 0) {
        message = (customerName ? 'Hi KC, my name is ' + customerName + '.' : 'Hi KC!') + phoneLine + '\n\nI would like to place an order and pay by Interac e-transfer. Please confirm payment details when you accept. Pickup location can be shared when ready.';
      } else {
        message = greeting + phoneLine + '\n\nI would like to order:\n\n' + lines.join('\n') + '\n\nFull order total: $' + total.toFixed(2) + '.\n\nI would like to pay by Interac e-transfer (please confirm details when you accept). Pickup location can be shared when the order is ready.';
      }
    }
    const previewText = message.replace(/\+/g, ' ');
    if (messagePreview) messagePreview.textContent = previewText;
    const encodedMessage = encodeURIComponent(message);
    const smsBody = encodeSmsBody(message);
    if (sendEmail) sendEmail.setAttribute('href', 'mailto:' + ORDER_ETRANSFER_EMAIL + '?subject=Order Request&body=' + encodedMessage);
    if (sendSms) sendSms.setAttribute('href', 'sms:' + SMS_NUM + '?body=' + smsBody);
    if (sendWa) sendWa.setAttribute('href', 'https://wa.me/' + WHATSAPP_NUM + '?text=' + encodeURIComponent(message));
    if (sendFb) sendFb.setAttribute('href', MESSENGER_URL + '?text=' + encodedMessage);
  }

  function setBodyModalLock(locked) {
    if (locked) {
      const scrollY = window.scrollY || window.pageYOffset;
      document.body.style.top = '-' + scrollY + 'px';
      document.body.classList.add('modal-open');
      document.body.dataset.modalScrollY = String(scrollY);
    } else {
      const scrollY = parseInt(document.body.dataset.modalScrollY || '0', 10);
      document.body.classList.remove('modal-open');
      document.body.style.top = '';
      delete document.body.dataset.modalScrollY;
      window.scrollTo(0, scrollY);
    }
  }

  function updateBodyModalLock() {
    const anyActive = document.querySelector('.modal-overlay.active, .cart-drawer-overlay.active');
    if (anyActive && !document.body.classList.contains('modal-open')) {
      setBodyModalLock(true);
    } else if (!anyActive && document.body.classList.contains('modal-open')) {
      setBodyModalLock(false);
    }
  }

  function openCartDrawer() {
    if (!cartDrawerOverlay) return;
    renderCartUI();
    cartDrawerOverlay.classList.add('active');
    cartDrawerOverlay.setAttribute('aria-hidden', 'false');
    updateBodyModalLock();
    closeCartDrawerBtn?.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawerOverlay) return;
    cartDrawerOverlay.classList.remove('active');
    cartDrawerOverlay.setAttribute('aria-hidden', 'true');
    updateBodyModalLock();
  }

  function openExpressModal(item, quantity) {
    if (!expressModal || !item) return;
    expressOrderContext = {
      item,
      quantity: Math.max(1, Math.min(Number.parseInt(quantity, 10) || 1, 50)),
    };
    const image = document.getElementById('expressOrderImage');
    const product = document.getElementById('expressOrderProduct');
    const quantityEl = document.getElementById('expressOrderQuantity');
    const unitPrice = document.getElementById('expressOrderUnitPrice');
    const total = document.getElementById('expressOrderTotal');
    if (image) {
      image.src = item.image || '/logo.png';
      image.alt = item.name;
    }
    if (product) product.textContent = item.name;
    if (quantityEl) quantityEl.textContent = String(expressOrderContext.quantity);
    if (unitPrice) unitPrice.textContent = '$' + item.price.toFixed(2);
    if (total) total.textContent = '$' + (item.price * expressOrderContext.quantity).toFixed(2) + ' CAD';

    const expressName = document.getElementById('expressCustomerName');
    const expressPhone = document.getElementById('expressCustomerPhone');
    if (expressName && !expressName.value) expressName.value = getOrderName();
    if (expressPhone && !expressPhone.value) expressPhone.value = getOrderPhone();
    updateExpressModalLinks();
    expressModal.classList.add('active');
    expressModal.setAttribute('aria-hidden', 'false');
    updateBodyModalLock();
    window.setTimeout(() => {
      expressName?.focus();
    }, 50);
  }

  
  function updateExpressModalLinks() {
    if (!expressOrderContext) return '';
    const customerName = (document.getElementById('expressCustomerName')?.value || '').trim();
    const customerPhone = (document.getElementById('expressCustomerPhone')?.value || '').trim();
    const treat = expressOrderContext.item.name;
    const qty = expressOrderContext.quantity;
    const total = (expressOrderContext.item.price * qty).toFixed(2);
    const greeting = customerName ? 'Hi KC, my name is ' + customerName + '.' : 'Hi KC!';
    const phoneLine = customerPhone ? '\nMobile: ' + customerPhone : '';
    const message = greeting + phoneLine + '\n\nI would like to order:\n• ' + treat + ' x ' + qty + ' ($' + total + ' CAD)\n\nI would like to pay by Interac e-transfer. Please confirm pickup area (McKnight / Carrington) and payment details when you accept. Thank you!';

    const smsEl = document.getElementById('expressSendSms');
    const emailEl = document.getElementById('expressSendEmail');
    if (smsEl) smsEl.href = 'sms:' + SMS_NUM + '?body=' + encodeSmsBody(message);
    if (emailEl) emailEl.href = 'mailto:' + ORDER_ETRANSFER_EMAIL + '?subject=' + encodeURIComponent('Order Request - ' + treat) + '&body=' + encodeURIComponent(message);
    return message;
  }

  ['expressCustomerName', 'expressCustomerPhone'].forEach(function(id) {
    document.getElementById(id)?.addEventListener('input', updateExpressModalLinks);
  });

  const expressCopyOrderBtn = document.getElementById('expressCopyOrder');
  if (expressCopyOrderBtn) {
    expressCopyOrderBtn.addEventListener('click', async function() {
      const msg = updateExpressModalLinks();
      if (!msg) return;
      try {
        await navigator.clipboard.writeText(msg);
        const span = document.getElementById('expressCopyText');
        if (span) {
          const orig = span.textContent;
          span.textContent = 'Copied to clipboard! ✓';
          setTimeout(() => { span.textContent = orig; }, 2500);
        }
      } catch (_) {
        alert('Order message:\n\n' + msg);
      }
    });
  }

  function closeExpressModal() {
    if (!expressModal) return;
    expressModal.classList.remove('active');
    expressModal.setAttribute('aria-hidden', 'true');
    updateBodyModalLock();
  }

  function syncCheckoutEmptyState() {
    const emptyState = document.getElementById('checkoutEmptyState');
    const formBody = document.getElementById('checkoutFormBody');
    if (!emptyState || !formBody) return;
    const hasItems = getSelectedCart().length > 0;
    const redeemMode = !!orderModalCustomMessage;
    emptyState.hidden = hasItems || redeemMode;
    formBody.hidden = !hasItems && !redeemMode;
  }

  function readCheckoutHandoff() {
    try {
      const raw = sessionStorage.getItem(CHECKOUT_REWARD_MESSAGE_KEY);
      if (!raw) return null;
      sessionStorage.removeItem(CHECKOUT_REWARD_MESSAGE_KEY);
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
      return null;
    }
  }

  function initCheckoutPage(options = {}) {
    if (!checkoutPanel) return;
    const handoff = options.rewardMessage || options.customerName || options.customerPhone
      ? options
      : (readCheckoutHandoff() || {});
    orderModalChatWithKC = false;
    showOrderNameError(false);
    showOrderPhoneError(false);
    showOrderEmailError(false);
    showOrderTermsError(false);
    const agreeTerms = document.getElementById('orderAgreeTerms');
    if (agreeTerms) agreeTerms.checked = false;

    if (handoff.rewardMessage) {
      orderModalCustomMessage = handoff.rewardMessage;
      const rowsEl = document.getElementById('checkoutOrderRows');
      if (rowsEl) {
        rowsEl.innerHTML = '<p class="checkout-cart-empty-note">Reward claim ready — send by Email/Text in step 3, or add treats from the menu first.</p>';
      }
      const totalEl = document.getElementById('orderCartTotal');
      if (totalEl) totalEl.textContent = '$0.00 CAD';
    } else {
      orderModalCustomMessage = '';
      hydrateOrderInputsFromCart();
    }

    if (handoff.customerName) {
      const orderNameInput = document.getElementById('orderCustomerName');
      if (orderNameInput) orderNameInput.value = handoff.customerName;
    }
    if (handoff.customerPhone) {
      const orderPhoneInput = document.getElementById('orderCustomerPhone');
      if (orderPhoneInput) orderPhoneInput.value = handoff.customerPhone;
    }

    updateMessage();
    syncCheckoutEmptyState();
    window.scrollTo(0, 0);
    window.setTimeout(function () {
      document.getElementById('orderCustomerName')?.focus();
    }, 50);
  }

  function goToCheckout(options = {}) {
    closeCartDrawer();
    try {
      if (options.rewardMessage || options.customerName || options.customerPhone) {
        sessionStorage.setItem(CHECKOUT_REWARD_MESSAGE_KEY, JSON.stringify({
          rewardMessage: options.rewardMessage || '',
          customerName: options.customerName || '',
          customerPhone: options.customerPhone || '',
        }));
      } else {
        sessionStorage.removeItem(CHECKOUT_REWARD_MESSAGE_KEY);
      }
    } catch (_) {}
    const alreadyOnCheckout = (window.location.pathname.replace(/\/$/, '') || '/') === '/checkout';
    if (alreadyOnCheckout) {
      initCheckoutPage(options);
      return;
    }
    history.pushState(null, '', '/checkout');
    render();
  }

  function openRewardRedeemCheckout(customerName = '', availableRewards = 1, customerPhone = '') {
    goToCheckout({
      customerName,
      customerPhone,
      rewardMessage: `Hi KC, my name is {name}. I have ${availableRewards} free ube pandesal reward${availableRewards === 1 ? '' : 's'} available and would like to claim one with my next order.`,
    });
  }

  document.addEventListener('click', function (e) {
    const flavorBtn = e.target.closest('.ensaymada-flavor-btn');
    if (flavorBtn) {
      e.preventDefault();
      const card = flavorBtn.closest('.card');
      const carousel = card ? card.querySelector('.ensaymada-carousel') : null;
      const idx = parseInt(flavorBtn.getAttribute('data-ensaymada-index'), 10);
      if (carousel && !isNaN(idx)) {
        carousel.classList.add('manual');
        carousel.querySelectorAll('.ensaymada-slide').forEach(function (slide, i) {
          slide.classList.toggle('active', i === idx);
        });
        carousel.closest('.card').querySelectorAll('.ensaymada-flavor-btn').forEach(function (b, i) {
          b.classList.toggle('active', i === idx);
          b.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
        });
      }
    }
  });

  orderBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  productQuantityButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('[data-order-id]');
      const input = card?.querySelector('.product-card-qty-input');
      if (!input) return;
      const current = getProductCardQuantity(card);
      input.value = String(
        button.dataset.cardQtyAction === 'increase'
          ? Math.min(current + 1, 50)
          : Math.max(current - 1, 1)
      );
    });
  });

  productQuantityInputs.forEach(function (input) {
    input.addEventListener('input', function () {
      const parsed = Number.parseInt(input.value, 10);
      if (Number.isInteger(parsed) && parsed > 50) input.value = '50';
    });
    input.addEventListener('change', function () {
      getProductCardQuantity(input.closest('[data-order-id]'));
    });
  });

  addToCartButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('[data-order-id]');
      const itemId = card?.dataset.orderId || '';
      const item = availableOrderableItems.find(entry => entry.id === itemId);
      if (!item) return;
      const quantity = getProductCardQuantity(card);
      addToCart(itemId, quantity);
      showCartToast(quantity + ' × ' + item.name + ' added to cart');
      pulseStickyCart();
    });
  });

  buyNowButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('[data-order-id]');
      const itemId = card?.dataset.orderId || '';
      const item = availableOrderableItems.find(entry => entry.id === itemId);
      if (!item) return;
      openExpressModal(item, getProductCardQuantity(card));
    });
  });

  if (openCartDrawerBtn) openCartDrawerBtn.addEventListener('click', openCartDrawer);
  if (stickyCartBar) stickyCartBar.addEventListener('click', openCartDrawer);
  if (closeCartDrawerBtn) closeCartDrawerBtn.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function (event) {
      if (event.target === cartDrawerOverlay) closeCartDrawer();
      const actionButton = event.target.closest('[data-cart-action]');
      if (!actionButton) return;
      const row = actionButton.closest('[data-cart-id]');
      const itemId = row?.dataset.cartId || '';
      const current = getCart()[itemId] || 0;
      if (actionButton.dataset.cartAction === 'increase') setCartQuantity(itemId, current + 1);
      if (actionButton.dataset.cartAction === 'decrease') setCartQuantity(itemId, current - 1);
      if (actionButton.dataset.cartAction === 'remove') setCartQuantity(itemId, 0);
    });
  }
  if (cartDrawerCheckoutBtn) {
    cartDrawerCheckoutBtn.addEventListener('click', function () {
      goToCheckout();
    });
  }
  if (cartDrawerClearBtn) {
    cartDrawerClearBtn.addEventListener('click', function () {
      clearCart();
      showCartToast('Cart cleared');
    });
  }

  document.addEventListener('click', function (e) {
    const redeemBtn = e.target.closest('.rewards-redeem-btn');
    if (!redeemBtn) return;
    e.preventDefault();
    openRewardRedeemCheckout(
      redeemBtn.dataset.rewardName || '',
      parseInt(redeemBtn.dataset.rewardCount || '1', 10) || 1,
      document.getElementById('rewardsPhone')?.value || ''
    );
  });

  if (closeExpressModalBtn) closeExpressModalBtn.addEventListener('click', closeExpressModal);
  if (expressModal) {
    expressModal.addEventListener('click', function (event) {
      if (event.target === expressModal) closeExpressModal();
    });
    expressModal.addEventListener('touchmove', function (event) {
      if (event.target === expressModal) event.preventDefault();
    }, { passive: false });
  }

  ['expressCustomerName', 'expressCustomerPhone', 'expressCustomerEmail'].forEach(function (id) {
    document.getElementById(id)?.addEventListener('input', function () {
      const errorId = id === 'expressCustomerName'
        ? 'expressNameError'
        : id === 'expressCustomerPhone'
          ? 'expressPhoneError'
          : 'expressEmailError';
      showExpressError(errorId, id, false);
    });
  });
  document.getElementById('expressAgreeTerms')?.addEventListener('change', function () {
    const termsError = document.getElementById('expressTermsError');
    if (termsError) termsError.hidden = true;
  });

  function refreshCheckoutOrderRows() {
    const rowsEl = document.getElementById('checkoutOrderRows');
    if (!rowsEl) return;
    rowsEl.innerHTML = getCheckoutOrderRowsHTML();
    rowsEl.querySelectorAll('.order-qty-input').forEach(function (input) {
      input.addEventListener('input', onCheckoutQtyInput);
      input.addEventListener('change', onCheckoutQtyInput);
    });
  }

  function onCheckoutQtyInput() {
    orderModalChatWithKC = false;
    orderModalCustomMessage = '';
    syncCartFromOrderInputs();
    updateMessage();
    syncCheckoutEmptyState();
    if (getSelectedCart().length !== document.querySelectorAll('#checkoutOrderRows .order-row').length) {
      refreshCheckoutOrderRows();
      updateMessage();
    }
  }

  if (checkoutPanel) {
    checkoutPanel.addEventListener('click', (e) => {
      const minus = e.target.closest('.order-qty-minus');
      const plus = e.target.closest('.order-qty-plus');
      if (minus || plus) {
        const row = (minus || plus).closest('.order-row');
        const input = row ? row.querySelector('.order-qty-input') : null;
        if (input) {
          orderModalChatWithKC = false;
          orderModalCustomMessage = '';
          let v = parseInt(input.value, 10) || 0;
          if (minus && v > 0) { v--; input.value = v; }
          if (plus && v < 50) { v++; input.value = v; }
          syncCartFromOrderInputs();
          updateMessage();
          syncCheckoutEmptyState();
          if (v === 0) {
            refreshCheckoutOrderRows();
            updateMessage();
          }
        }
      }
    });

    document.querySelectorAll('#checkoutOrderRows .order-qty-input').forEach(function (input) {
      input.addEventListener('input', onCheckoutQtyInput);
      input.addEventListener('change', onCheckoutQtyInput);
    });

    initCheckoutPage();
  }

  const chatWithKCBtn = document.getElementById('orderChatWithKC');
  if (chatWithKCBtn) {
    chatWithKCBtn.addEventListener('click', function () {
      orderModalChatWithKC = true;
      orderModalCustomMessage = '';
      updateMessage();
    });
  }

  renderCartUI();

  function requireOrderNameBeforeSend(callback) {
    const name = getOrderName();
    if (!name) {
      showOrderNameError(true);
      showOrderTermsError(false);
      const input = document.getElementById('orderCustomerName');
      if (input) input.focus();
      return false;
    }
    showOrderNameError(false);
    const phone = getOrderPhone();
    if (!isValidOrderPhone(phone)) {
      showOrderPhoneError(true);
      showOrderTermsError(false);
      const input = document.getElementById('orderCustomerPhone');
      if (input) input.focus();
      return false;
    }
    showOrderPhoneError(false);
    if (!isValidOrderEmail(getOrderEmail())) {
      showOrderEmailError(true);
      const input = document.getElementById('orderCustomerEmail');
      if (input) input.focus();
      return false;
    }
    showOrderEmailError(false);
    if (!getOrderTermsAgreed()) {
      showOrderTermsError(true);
      const agree = document.getElementById('orderAgreeTerms');
      if (agree) agree.focus();
      return false;
    }
    showOrderTermsError(false);
    if (callback) callback();
    return true;
  }

  const orderNameInput = document.getElementById('orderCustomerName');
  if (orderNameInput) {
    orderNameInput.addEventListener('input', function () {
      showOrderNameError(false);
      updateMessage();
    });
    orderNameInput.addEventListener('change', updateMessage);
  }

  const orderPhoneInput = document.getElementById('orderCustomerPhone');
  if (orderPhoneInput) {
    orderPhoneInput.addEventListener('input', function () {
      showOrderPhoneError(false);
      const resultEl = document.getElementById('orderRewardsResult');
      if (resultEl) resultEl.textContent = '';
      updateMessage();
    });
    orderPhoneInput.addEventListener('change', updateMessage);
  }

  const orderEmailInput = document.getElementById('orderCustomerEmail');
  if (orderEmailInput) {
    orderEmailInput.addEventListener('input', function () {
      showOrderEmailError(false);
    });
  }

  const checkOrderRewards = document.getElementById('checkOrderRewards');
  if (checkOrderRewards) {
    checkOrderRewards.addEventListener('click', async function () {
      const phone = getOrderPhone();
      const resultEl = document.getElementById('orderRewardsResult');
      if (!isValidOrderPhone(phone)) {
        showOrderPhoneError(true);
        if (orderPhoneInput) orderPhoneInput.focus();
        return;
      }
      showOrderPhoneError(false);
      checkOrderRewards.disabled = true;
      if (resultEl) {
        resultEl.textContent = 'Checking your profile...';
        resultEl.classList.remove('is-error');
      }
      try {
        const response = await fetch('/api/rewards/lookup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to check rewards right now.');
        if (data.found) {
          const orderName = document.getElementById('orderCustomerName');
          if (orderName && !orderName.value.trim() && data.name) orderName.value = data.name;
          const rewardCount = data.availableRewards || 0;
          if (resultEl) {
            resultEl.textContent = `Welcome back, ${data.name}! ${data.progressOrders || 0}/${data.rewardThreshold} points toward your next reward${rewardCount ? ` · ${rewardCount} available now` : ''}.`;
          }
          updateMessage();
        } else if (resultEl) {
          resultEl.textContent = 'No profile yet — we will securely create one with this number after your paid order.';
        }
      } catch (error) {
        if (resultEl) resultEl.textContent = error.message;
        if (resultEl) resultEl.classList.add('is-error');
      } finally {
        checkOrderRewards.disabled = false;
      }
    });
  }

  if (payWithSquare) {
    payWithSquare.addEventListener('click', async function () {
      if (!requireOrderNameBeforeSend()) return;
      const cart = getSelectedCart();
      if (!cart.length) {
        if (squareCheckoutStatus) {
          squareCheckoutStatus.textContent = 'Choose at least one item before starting Square checkout.';
          squareCheckoutStatus.classList.add('is-error');
        }
        return;
      }

      payWithSquare.disabled = true;
      setSquareButtonLabel(payWithSquare, 'Opening secure Square checkout...');
      if (squareCheckoutStatus) {
        squareCheckoutStatus.textContent = '';
        squareCheckoutStatus.classList.remove('is-error');
      }
      try {
        const response = await fetch('/api/checkout/square', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: getOrderName(),
            phone: getOrderPhone(),
            email: getOrderEmail(),
            items: cart.map(item => ({ id: item.id, quantity: item.quantity })),
            termsAccepted: getOrderTermsAgreed(),
          }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to start Square checkout.');
        const paymentUrl = new URL(data.url);
        if (paymentUrl.protocol !== 'https:') throw new Error('Square returned an invalid checkout link.');
        try {
          sessionStorage.setItem('softbakes_square_phone', getOrderPhone());
        } catch (_) {}
        window.location.assign(paymentUrl.toString());
      } catch (error) {
        if (squareCheckoutStatus) {
          squareCheckoutStatus.textContent = error.message;
          squareCheckoutStatus.classList.add('is-error');
        }
        payWithSquare.disabled = false;
        setSquareButtonLabel(payWithSquare, SQUARE_CHECKOUT_LABEL);
      }
    });

    void fetch('/api/checkout/square/config', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    }).then(response => response.json()).then((data) => {
      if (data.available) return;
      payWithSquare.disabled = true;
      setSquareButtonLabel(payWithSquare, 'Square checkout is being connected');
      if (expressPayWithSquare) {
        expressPayWithSquare.disabled = true;
        setSquareButtonLabel(expressPayWithSquare, 'Square checkout is being connected');
      }
      if (squareCheckoutStatus) {
        squareCheckoutStatus.textContent = 'Square checkout is temporarily unavailable. Please contact KC to order.';
      }
    }).catch(() => {
      payWithSquare.disabled = true;
      setSquareButtonLabel(payWithSquare, 'Square checkout temporarily unavailable');
      if (expressPayWithSquare) {
        expressPayWithSquare.disabled = true;
        setSquareButtonLabel(expressPayWithSquare, 'Square checkout temporarily unavailable');
      }
    });
  }

  if (expressPayWithSquare) {
    expressPayWithSquare.addEventListener('click', async function () {
      if (!expressOrderContext || !validateExpressOrder()) return;
      expressPayWithSquare.disabled = true;
      setSquareButtonLabel(expressPayWithSquare, 'Opening secure Square checkout...');
      if (expressCheckoutStatus) {
        expressCheckoutStatus.textContent = '';
        expressCheckoutStatus.classList.remove('is-error');
      }
      try {
        const response = await fetch('/api/checkout/square', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: getExpressValue('expressCustomerName'),
            phone: getExpressValue('expressCustomerPhone'),
            email: getExpressValue('expressCustomerEmail'),
            items: [{
              id: expressOrderContext.item.id,
              quantity: expressOrderContext.quantity,
            }],
            termsAccepted: !!document.getElementById('expressAgreeTerms')?.checked,
          }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to start Square checkout.');
        const paymentUrl = new URL(data.url);
        if (paymentUrl.protocol !== 'https:') throw new Error('Square returned an invalid checkout link.');
        try {
          sessionStorage.setItem('softbakes_square_phone', getExpressValue('expressCustomerPhone'));
        } catch (_) {}
        window.location.assign(paymentUrl.toString());
      } catch (error) {
        if (expressCheckoutStatus) {
          expressCheckoutStatus.textContent = error.message;
          expressCheckoutStatus.classList.add('is-error');
        }
        expressPayWithSquare.disabled = false;
        setSquareButtonLabel(expressPayWithSquare);
      }
    });
  }

  const orderAgreeTermsInput = document.getElementById('orderAgreeTerms');
  if (orderAgreeTermsInput) {
    orderAgreeTermsInput.addEventListener('change', function () {
      showOrderTermsError(false);
      updateMessage();
    });
  }

  [sendSms, sendWa, sendFb, sendEmail].forEach(function (link) {
    if (link) {
      link.addEventListener('click', function (e) {
        updateMessage();
        if (!requireOrderNameBeforeSend()) {
          e.preventDefault();
        }
      });
    }
  });

  const copyOrderMessageBtn = document.getElementById('copyOrderMessage');
  if (copyOrderMessageBtn && messagePreview) {
    copyOrderMessageBtn.addEventListener('click', function (e) {
      if (!requireOrderNameBeforeSend()) return;
      const text = messagePreview.textContent || '';
      if (!text) return;
      navigator.clipboard.writeText(text).then(function () {
        const origLabel = copyOrderMessageBtn.getAttribute('aria-label');
        const copyBtnText = document.getElementById('copyBtnText');
        if (copyBtnText) copyBtnText.textContent = 'Copied!';
        copyOrderMessageBtn.setAttribute('aria-label', 'Copied to clipboard');
        copyOrderMessageBtn.setAttribute('aria-live', 'polite');
        setTimeout(function () {
          if (copyBtnText) copyBtnText.textContent = 'Copy message';
          copyOrderMessageBtn.setAttribute('aria-label', origLabel || 'Copy order message to clipboard');
          copyOrderMessageBtn.removeAttribute('aria-live');
        }, 2000);
      });
    });
  }

  const faqQuestions = document.querySelectorAll('.faq-question');
  faqQuestions.forEach(btn => {
    btn.addEventListener('click', () => {
      const isActive = btn.classList.contains('active');
      document.querySelectorAll('.faq-question').forEach(q => q.classList.remove('active'));
      document.querySelectorAll('.faq-answer').forEach(a => { a.style.maxHeight = null; });
      if (!isActive) {
        btn.classList.add('active');
        const answer = btn.nextElementSibling;
        if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  const policiesModal = document.getElementById('policiesModal');
  const openPoliciesBtn = document.getElementById('openPolicies');
  const closePoliciesBtn = document.getElementById('closePoliciesModal');
  if (openPoliciesBtn && policiesModal) {
    openPoliciesBtn.addEventListener('click', (e) => {
      e.preventDefault();
      policiesModal.classList.add('active');
      updateBodyModalLock();
    });
  }
  const openPoliciesFromOrder = document.getElementById('openPoliciesFromOrder');
  if (openPoliciesFromOrder && policiesModal) {
    openPoliciesFromOrder.addEventListener('click', (e) => {
      e.preventDefault();
      policiesModal.classList.add('active');
      updateBodyModalLock();
    });
  }
  const openPoliciesFromExpress = document.getElementById('openPoliciesFromExpress');
  if (openPoliciesFromExpress && policiesModal) {
    openPoliciesFromExpress.addEventListener('click', (e) => {
      e.preventDefault();
      policiesModal.classList.add('active');
      updateBodyModalLock();
    });
  }
  if (closePoliciesBtn && policiesModal) {
    closePoliciesBtn.addEventListener('click', () => {
      policiesModal.classList.remove('active');
      updateBodyModalLock();
    });
  }
  if (policiesModal) {
    policiesModal.addEventListener('click', (e) => {
      if (e.target === policiesModal) {
        policiesModal.classList.remove('active');
        updateBodyModalLock();
      }
    });
    policiesModal.addEventListener('touchmove', (e) => {
      if (e.target === policiesModal) e.preventDefault();
    }, { passive: false });
  }

  const inquiryModal = document.getElementById('inquiryModal');
  const openInquiryBtn = document.getElementById('openCustomInquiry');
  const closeInquiryBtn = document.getElementById('closeInquiryModal');
  const inquiryEmailEl = document.getElementById('inquiryEmail');
  const inquirySmsEl = document.getElementById('inquirySms');
  if (openInquiryBtn && inquiryModal) {
    openInquiryBtn.addEventListener('click', (e) => {
      e.preventDefault();
      inquiryModal.classList.add('active');
      updateBodyModalLock();
    });
  }
  if (closeInquiryBtn && inquiryModal) {
    closeInquiryBtn.addEventListener('click', () => {
      inquiryModal.classList.remove('active');
      updateBodyModalLock();
    });
  }
  if (inquiryModal) {
    inquiryModal.addEventListener('click', (e) => {
      if (e.target === inquiryModal) {
        inquiryModal.classList.remove('active');
        updateBodyModalLock();
      }
    });
    inquiryModal.addEventListener('touchmove', (e) => {
      if (e.target === inquiryModal) e.preventDefault();
    }, { passive: false });
  }

  function updateInquiryLinks() {
    const dateEl = document.getElementById('inquiryDate');
    const detailsEl = document.getElementById('inquiryDetails');
    const qtyEl = document.getElementById('inquiryQuantity');
    if (!inquiryEmailEl || !inquirySmsEl || !dateEl || !detailsEl || !qtyEl) return;
    const message = `Hi Soft Bakes! I'm interested in a custom order for ${dateEl.value}. 
Details: ${detailsEl.value}
Quantity: ${qtyEl.value}
Let me know if you're available!`;
    const encoded = encodeURIComponent(message);
    inquiryEmailEl.href = `mailto:${EMAIL_ADDR}?subject=Custom Order Inquiry&body=${encoded}`;
    inquirySmsEl.href = `sms:${SMS_NUM}?&body=${encoded}`;
  }
  document.getElementById('customInquiryForm')?.addEventListener('input', updateInquiryLinks);

  const newsletterForm = document.getElementById('newsletterForm');
  const newsletterSuccess = document.getElementById('newsletterSuccess');
  if (newsletterForm && newsletterSuccess) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      newsletterForm.style.display = 'none';
      newsletterSuccess.style.display = 'block';
    });
  }
}

function initBlogCarousel() {
  const carousel = document.querySelector('.blog-carousel');
  if (!carousel) return;
  const track = carousel.querySelector('.blog-carousel-track');
  const slides = carousel.querySelectorAll('.blog-carousel-slide');
  const dotsContainer = carousel.querySelector('.blog-carousel-dots');
  const prevBtn = carousel.querySelector('.blog-carousel-prev');
  const nextBtn = carousel.querySelector('.blog-carousel-next');
  if (!track || !slides.length || !dotsContainer) return;

  const total = slides.length;
  let index = 0;
  let autoplayTimer = null;
  const AUTOPLAY_MS = 4500;

  slides.forEach((slide, i) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'blog-carousel-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.addEventListener('click', () => goTo(i));
    dotsContainer.appendChild(dot);
  });
  const dots = dotsContainer.querySelectorAll('.blog-carousel-dot');

  function goTo(i) {
    index = (i + total) % total;
    track.style.transform = 'translateX(-' + index * 100 + '%)';
    dots.forEach((d, j) => d.classList.toggle('active', j === index));
    slides.forEach((s, j) => s.setAttribute('aria-hidden', j !== index));
  }

  function next() {
    goTo(index + 1);
  }
  function prev() {
    goTo(index - 1);
  }

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  slides.forEach((s, j) => s.setAttribute('aria-hidden', j !== 0));
  if (total > 1) {
    autoplayTimer = setInterval(next, AUTOPLAY_MS);
    carousel.addEventListener('mouseenter', () => { clearInterval(autoplayTimer); });
    carousel.addEventListener('mouseleave', () => { autoplayTimer = setInterval(next, AUTOPLAY_MS); });
  }
}
